var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _use, _use2, _path320, _path321, _path322, _circle, _path323, _path324, _path325, _path326, _path327, _circle2, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBo = function SvgBo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h640v320H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h640v160H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.579 210.711c-.577.556-97.586 97.453-98.012 97.875a91.75 91.75 0 0 0-1.297-.972c.4-.408 97.455-97.259 98.023-97.846-.249-.29 1.746 1.222 1.286.943z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M374.685 204.532c-.359.687-1.425 2.451-1.01 3.752-.791-.512-1.188-.899-1.947-1.46.51.898.358 1.42-.129 1.744-.318.42-1.407.322-2.103.19.696.425 1.468.864 2.434.958.966.094 1.302.04 1.89.098-.586.315-2.127.83-3.202.997-.538.084-1.58.179-2.04-.1-.576.556-1.853-.356-1.285-.943-.249-.29-.278-.755-.341-1.37-.071-.695.08-1.895.662-3.021.09.563.267 1.157.484 1.697.214.53.664.962 1.11 1.43-.26-.487-.417-1.224.097-1.756.513-.532 1.258-.533 1.958-.256-.623-.482-1.097-.771-1.85-1.32.78-.006 3.269-.964 4.09-1.456.823-.492 3.432-2.557 4.897-3.805-1.208 1.395-3.363 3.949-3.715 4.621z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.026 222.785c-.733.398-125.133 70.613-125.678 70.918-.24-.323-.704-.947-.934-1.241.514-.298 124.945-70.457 125.68-70.888-.146-.337 1.285 1.587.932 1.21z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M394.883 218.288c-.566.576-2.158 2.02-2.177 3.368-.597-.679-.854-1.145-1.403-1.863.202.983-.112 1.448-.684 1.645-.44.329-1.457-.023-2.083-.314.533.573 1.133 1.178 2.031 1.496.899.319 1.239.347 1.785.541-.664.164-2.31.295-3.398.202-.543-.047-1.575-.202-1.928-.578-.733.398-1.667-.78-.932-1.211-.146-.337-.025-.791.112-1.398.155-.684.687-1.802 1.608-2.747a7.777 7.777 0 0 0-.08 1.746c.035.56.329 1.081.606 1.636-.093-.529-.006-1.274.658-1.664.664-.39 1.381-.215 1.965.217-.443-.611-.807-1-1.354-1.706.751.178 3.452-.155 4.4-.433.948-.279 4.12-1.648 5.93-2.5-1.61 1.055-4.502 3-5.056 3.563z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376.324 217.483c-.662.482-112.453 84.859-112.944 85.226-.29-.291-.85-.854-1.126-1.117.461-.356 112.292-84.683 112.95-85.197-.2-.316 1.53 1.42 1.12 1.088z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M383.374 212.093c-.467.637-1.809 2.257-1.609 3.595-.7-.601-1.031-1.032-1.692-1.678.36.95.125 1.448-.41 1.71-.383.38-1.446.152-2.114-.062.62.504 1.314 1.031 2.255 1.24.94.208 1.282.195 1.855.322-.63.242-2.24.568-3.332.605-.546.019-1.593-.01-2.003-.342-.662.482-1.778-.574-1.12-1.088-.2-.316-.153-.78-.116-1.397.042-.697.387-1.867 1.146-2.912a7.821 7.821 0 0 0 .205 1.738c.125.55.5 1.032.865 1.548-.177-.513-.213-1.262.382-1.727.594-.465 1.333-.377 1.981-.02-.538-.552-.961-.894-1.617-1.527.772.086 3.393-.565 4.286-.954.894-.39 3.813-2.123 5.466-3.184-1.422 1.238-3.971 3.51-4.428 4.133z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.421 210.711c.577.556 97.586 97.453 98.012 97.875.334-.254.981-.744 1.297-.972-.4-.408-97.455-97.259-98.023-97.846.249-.29-1.746 1.222-1.286.943z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.315 204.532c.359.687 1.425 2.451 1.01 3.752.791-.512 1.188-.899 1.947-1.46-.51.898-.358 1.42.129 1.744.318.42 1.407.322 2.103.19-.696.425-1.468.864-2.434.958-.966.094-1.302.04-1.89.098.586.315 2.127.83 3.202.997.538.084 1.58.179 2.04-.1.576.556 1.853-.356 1.285-.943.249-.29.278-.755.341-1.37.071-.695-.08-1.895-.662-3.021a8.013 8.013 0 0 1-.484 1.697c-.214.53-.664.962-1.11 1.43.26-.487.417-1.224-.097-1.756-.513-.532-1.258-.533-1.958-.256.623-.482 1.097-.771 1.85-1.32-.78-.006-3.269-.964-4.09-1.456-.823-.492-3.432-2.557-4.897-3.805 1.208 1.395 3.363 3.949 3.715 4.621z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.974 222.785c.733.398 125.133 70.613 125.678 70.918.24-.323.704-.947.934-1.241-.514-.298-124.945-70.457-125.68-70.888.146-.337-1.285 1.587-.932 1.21z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.117 218.288c.566.576 2.158 2.02 2.177 3.368.597-.679.854-1.145 1.403-1.863-.202.983.112 1.448.684 1.645.44.329 1.457-.023 2.083-.314-.533.573-1.133 1.178-2.031 1.496-.899.319-1.239.347-1.785.541.664.164 2.31.295 3.398.202.543-.047 1.575-.202 1.928-.578.733.398 1.667-.78.932-1.211.146-.337.025-.791-.112-1.398-.155-.684-.687-1.802-1.608-2.747.096.562.116 1.176.08 1.746-.035.56-.329 1.081-.606 1.636.093-.529.006-1.274-.658-1.664-.664-.39-1.381-.215-1.965.217.443-.611.807-1 1.354-1.706-.751.178-3.452-.155-4.4-.433-.948-.279-4.12-1.648-5.93-2.5 1.61 1.055 4.502 3 5.056 3.563z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M263.676 217.483c.662.482 112.453 84.859 112.944 85.226.29-.291.85-.854 1.126-1.117-.461-.356-112.292-84.683-112.95-85.197.2-.316-1.53 1.42-1.12 1.088z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M256.626 212.093c.467.637 1.809 2.257 1.609 3.595.7-.601 1.031-1.032 1.692-1.678-.36.95-.125 1.448.41 1.71.383.38 1.446.152 2.114-.062-.62.504-1.314 1.031-2.255 1.24-.94.208-1.282.195-1.855.322.63.242 2.24.568 3.332.605.546.019 1.593-.01 2.003-.342.662.482 1.778-.574 1.12-1.088.2-.316.153-.78.116-1.397-.042-.697-.387-1.867-1.146-2.912a7.821 7.821 0 0 1-.205 1.738c-.125.55-.5 1.032-.865 1.548.177-.513.213-1.262-.382-1.727-.594-.465-1.333-.377-1.981-.02.538-.552.961-.894 1.617-1.527-.772.086-3.393-.565-4.286-.954-.894-.39-3.813-2.123-5.466-3.184 1.422 1.238 3.971 3.51 4.428 4.133z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M300.137 283.455c3.917-2.668 15.088-4.065 16.66-3.625-7.94 6.048-15.968 6.269-16.66 3.625z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M300.176 283.47c.692 2.644 8.68 2.408 16.604-3.606-8.484 2.567-15.65 4.053-16.604 3.607z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M300.176 283.47c.692 2.644 8.68 2.408 16.604-3.606-8.484 2.567-15.65 4.053-16.604 3.607z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M300.154 283.422c4.17-2.837 15.677-3.922 16.69-3.636-7.953 6.024-15.998 6.28-16.69 3.636z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M347.561 220.164l-25.466 52.32c-1.265.98-2.314-.335-2.674-.189-1.527 1.713-3.63 2.067-4.073 2.467-1.77 2.412-.796 4.371-.69 4.534 1.325 1.787-1.566 3.527-1.45 4.08-.567 1.002-2.7.775-3.14 1.99-.094-.138-4.334 8.323-4.78 9.23-.633.49-3.647 6.126-3.647 6.126-2.113-.036-10.234-5.217-10.393-5.137 4.563-7.3 15.506-18.501 15.284-19.216 3.076-5.207 7.988-10.849 10.101-10.813 2.997-1.577 4.458-5.633 3.876-6.567 2.302-.054 3.557-1.424 3.717-1.505l18.798-37.572c1.57-.517 1.334.124 1.837 1.028 0 0 1.001-1.203.936-1.35.888-.433 1.753.184 1.764.574z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M348.545 208.75c-.487 1.033.268 1.037.528 1.177l1.08.292c1.222.02 1.866.652 1.877 1.043l-29.935 61.223c-1.265.98-2.474-.256-2.863-.1l20.53-41.83s7.9-14.703 9.97-18.79l-2.716-1.161c-.843-.2-1.096-.765-.725-1.62l12.572-21.617-10.135 20.985-.183.397",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M348.545 208.75c-.487 1.033.268 1.037.528 1.177l1.08.292c1.222.02 1.866.652 1.877 1.043l-29.935 61.223c-1.265.98-2.474-.256-2.863-.1l20.53-41.83s7.9-14.703 9.97-18.79l-2.716-1.161c-.843-.2-1.096-.765-.725-1.62l12.572-21.617-10.135 20.985-.183.397",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.803 272.44c-2.94-.13-4.589 2.045-2.669 4.65m1.378-2.339c-1.055.573-1.722-.334-1.722-.334m15.251-13.07c-1.554 5.606-4.38 9.323-4.948 10.467-2.16 2.203-3.948 7.211-3.62 8.088l-8.101 13.307",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M321.96 272.698c-1.322-.466-5.702-4.54-10.003-3.829-3.277 3.809-5.24 7.692-5.823 8.222 4 3.299 6.634 4.937 7.61 5.433.638-.407.985-1.535.985-1.535.832-.921-.19-1.739-.19-1.739.112-2.458 1.9-4.172 3.715-4.29 2.277-.187 1.637-.37 1.927-.381 1.044-.597 1.78-1.881 1.78-1.881z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M321.96 272.698c-1.322-.466-5.702-4.54-10.003-3.829-3.277 3.809-5.24 7.692-5.823 8.222 4 3.299 6.634 4.937 7.61 5.433.638-.407.985-1.535.985-1.535.832-.921-.19-1.739-.19-1.739.112-2.458 1.9-4.172 3.715-4.29 2.277-.187 1.637-.37 1.927-.381 1.044-.597 1.78-1.881 1.78-1.881z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M317.606 272.78c-2.016-.04-4.077.92-4.751 2.633l4.751-2.633",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M317.606 272.78c-2.016-.04-4.077.92-4.751 2.633m-3.597.677c.187.417.712.638 1.198.479.485-.16.73-.635.544-1.052-.187-.417-.729-.604-1.214-.444-.486.16-.714.6-.528 1.017zm2.502-3.413c.187.417.741.629 1.226.47.486-.16.704-.626.517-1.043-.186-.417-.701-.614-1.186-.454-.486.16-.743.61-.557 1.027z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M345.309 226.113c.8-.264 1.15-1.167.765-2.026l-4.69-1.693s-.548.096-1.018.729c-.46.658.169 1.183.169 1.183l4.774 1.807",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M345.309 226.113c.8-.264 1.15-1.167.765-2.026l-4.69-1.693s-.548.096-1.018.729c-.46.658.169 1.183.169 1.183l4.774 1.807",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M294.53 286.058c3.862-2.726 15.003-4.29 16.585-3.874-7.818 6.166-15.84 6.507-16.585 3.874z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M294.57 286.073c.745 2.633 8.727 2.277 16.527-3.854-8.43 2.693-15.565 4.286-16.527 3.854z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M294.57 286.073c.745 2.633 8.727 2.277 16.527-3.854-8.43 2.693-15.565 4.286-16.527 3.854z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M294.547 286.025c4.111-2.899 15.594-4.156 16.613-3.885-7.83 6.142-15.868 6.517-16.613 3.885z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M340.659 222.067L316.26 274.76c-1.245.998-2.32-.302-2.677-.15-1.492 1.736-3.587 2.121-4.022 2.528-1.722 2.438-.707 4.382-.598 4.543 1.361 1.767-1.494 3.55-1.366 4.101-.547 1.011-2.685.816-3.099 2.037-.097-.136-4.165 8.387-4.592 9.3-.623.5-3.522 6.18-3.522 6.18-2.113-.005-10.338-5.063-10.496-4.98 4.414-7.368 15.128-18.731 14.89-19.443 2.97-5.252 7.767-10.966 9.88-10.962 2.965-1.622 4.343-5.699 3.742-6.624 2.3-.089 3.527-1.477 3.686-1.56l18.03-37.848c1.56-.54 1.336.104 1.858 1 0 0 .977-1.217.908-1.363.879-.447 1.756.157 1.775.547z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M340.659 222.067L316.26 274.76c-1.245.998-2.32-.302-2.677-.15-1.492 1.736-3.587 2.121-4.022 2.528-1.722 2.438-.707 4.382-.598 4.543 1.361 1.767-1.494 3.55-1.366 4.101-.547 1.011-2.685.816-3.099 2.037-.097-.136-4.165 8.387-4.592 9.3-.623.5-3.522 6.18-3.522 6.18-2.113-.005-10.338-5.063-10.496-4.98 4.414-7.368 15.128-18.731 14.89-19.443 2.97-5.252 7.767-10.966 9.88-10.962 2.965-1.622 4.343-5.699 3.742-6.624 2.3-.089 3.527-1.477 3.686-1.56l18.03-37.848c1.56-.54 1.336.104 1.858 1 0 0 .977-1.217.908-1.363.879-.447 1.756.157 1.775.547z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M341.41 210.639c-.466 1.04.29 1.034.552 1.17l1.086.276c1.222 0 1.879.624 1.898 1.014l-28.685 61.662c-1.245.998-2.479-.218-2.864-.056l19.675-42.131s7.6-14.82 9.586-18.937l-2.739-1.121c-.847-.188-1.11-.748-.757-1.608l12.13-21.802-9.707 21.133-.175.4",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M341.41 210.639c-.466 1.04.29 1.034.552 1.17l1.086.276c1.222 0 1.879.624 1.898 1.014l-28.685 61.662c-1.245.998-2.479-.218-2.864-.056l19.675-42.131s7.6-14.82 9.586-18.937l-2.739-1.121c-.847-.188-1.11-.748-.757-1.608l12.13-21.802-9.707 21.133-.175.4",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M302.97 274.915c-2.942-.086-4.546 2.114-2.573 4.69m1.33-2.36c-1.043.588-1.729-.308-1.729-.308m14.983-13.296c-1.44 5.628-4.189 9.387-4.734 10.54-2.115 2.234-3.801 7.268-3.456 8.14l-7.828 13.426",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M316.131 274.976c-1.331-.446-5.794-4.455-10.08-3.679-3.198 3.857-5.083 7.77-5.654 8.308 4.067 3.239 6.734 4.838 7.72 5.318.628-.416.952-1.548.952-1.548.814-.934-.224-1.737-.224-1.737.062-2.459 1.815-4.2 3.627-4.346 2.272-.22 1.629-.394 1.918-.409 1.032-.612 1.741-1.907 1.741-1.907z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M316.131 274.976c-1.331-.446-5.794-4.455-10.08-3.679-3.198 3.857-5.083 7.77-5.654 8.308 4.067 3.239 6.734 4.838 7.72 5.318.628-.416.952-1.548.952-1.548.814-.934-.224-1.737-.224-1.737.062-2.459 1.815-4.2 3.627-4.346 2.272-.22 1.629-.394 1.918-.409 1.032-.612 1.741-1.907 1.741-1.907z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M311.78 275.123c-2.017-.01-4.058.98-4.698 2.704l4.697-2.704",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M311.78 275.123c-2.017-.01-4.058.98-4.698 2.704m-3.582.73c.195.415.724.628 1.207.461.482-.167.718-.645.523-1.06-.195-.413-.741-.592-1.223-.425-.483.167-.702.611-.507 1.025zm2.432-3.45c.196.415.754.618 1.236.451.482-.166.69-.635.495-1.05-.195-.413-.714-.602-1.195-.435-.482.167-.73.621-.536 1.035z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M338.528 228.048c.794-.275 1.125-1.183.724-2.036l-4.725-1.623s-.545.104-1.002.744c-.446.664.193 1.18.193 1.18l4.81 1.735",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M338.528 228.048c.794-.275 1.125-1.183.724-2.036l-4.725-1.623s-.545.104-1.002.744c-.446.664.193 1.18.193 1.18l4.81 1.735",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M340.62 283.281c-3.957-2.695-15.241-4.106-16.83-3.662 8.022 6.109 16.13 6.332 16.83 3.662z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M340.58 283.297c-.7 2.67-8.768 2.43-16.772-3.643 8.57 2.592 15.809 4.093 16.772 3.643z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M340.58 283.297c-.7 2.67-8.768 2.43-16.772-3.643 8.57 2.592 15.809 4.093 16.772 3.643z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M340.602 283.247c-4.212-2.865-15.835-3.96-16.859-3.672 8.034 6.084 16.16 6.342 16.859 3.672z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M292.716 219.35l25.724 52.85c1.278.99 2.337-.34 2.7-.192 1.543 1.73 3.666 2.088 4.114 2.492 1.79 2.436.804 4.415.698 4.58-1.339 1.805 1.582 3.562 1.464 4.12.573 1.013 2.728.784 3.171 2.01.096-.138 4.38 8.408 4.83 9.324.639.495 3.684 6.188 3.684 6.188 2.134-.036 10.336-5.27 10.497-5.188-4.61-7.374-15.663-18.689-15.438-19.411-3.107-5.26-8.07-10.958-10.204-10.922-3.027-1.593-4.503-5.69-3.914-6.634-2.326-.054-3.593-1.438-3.755-1.52l-18.989-37.951c-1.586-.522-1.346.125-1.854 1.039 0 0-1.012-1.215-.946-1.364-.897-.437-1.77.185-1.782.58z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M291.722 207.82c.492 1.044-.271 1.049-.533 1.19l-1.092.295c-1.233.02-1.884.659-1.895 1.054l30.238 61.84c1.278.99 2.499-.257 2.891-.1l-20.737-42.252s-7.98-14.852-10.07-18.98l2.742-1.173c.852-.203 1.107-.773.733-1.636l-12.7-21.835 10.238 21.196.185.401",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M291.722 207.82c.492 1.044-.271 1.049-.533 1.19l-1.092.295c-1.233.02-1.884.659-1.895 1.054l30.238 61.84c1.278.99 2.499-.257 2.891-.1l-20.737-42.252s-7.98-14.852-10.07-18.98l2.742-1.173c.852-.203 1.107-.773.733-1.636l-12.7-21.835 10.238 21.196.185.401",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M331.865 272.154c2.971-.13 4.636 2.067 2.697 4.698m-1.392-2.363c1.065.578 1.74-.337 1.74-.337m-15.406-13.202c1.57 5.663 4.424 9.417 4.998 10.572 2.182 2.226 3.988 7.284 3.657 8.17l8.183 13.44",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M318.575 272.415c1.336-.47 5.76-4.587 10.105-3.868 3.31 3.847 5.294 7.77 5.882 8.305-4.041 3.333-6.702 4.988-7.688 5.488-.643-.41-.994-1.55-.994-1.55-.84-.93.191-1.757.191-1.757-.113-2.482-1.92-4.214-3.752-4.334-2.3-.188-1.654-.374-1.946-.384-1.054-.603-1.798-1.9-1.798-1.9z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M318.575 272.415c1.336-.47 5.76-4.587 10.105-3.868 3.31 3.847 5.294 7.77 5.882 8.305-4.041 3.333-6.702 4.988-7.688 5.488-.643-.41-.994-1.55-.994-1.55-.84-.93.191-1.757.191-1.757-.113-2.482-1.92-4.214-3.752-4.334-2.3-.188-1.654-.374-1.946-.384-1.054-.603-1.798-1.9-1.798-1.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M322.974 272.498c2.036-.04 4.118.929 4.8 2.66l-4.8-2.66",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M322.974 272.498c2.036-.04 4.118.929 4.8 2.66m3.632.684c-.189.421-.719.644-1.21.483-.49-.162-.738-.641-.55-1.063.189-.42.737-.61 1.227-.448.49.161.721.607.533 1.028zm-2.528-3.448c-.188.421-.748.635-1.238.474-.49-.162-.71-.632-.522-1.053.189-.421.708-.62 1.199-.458.49.161.75.616.561 1.037z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M294.991 225.36c-.808-.267-1.161-1.179-.773-2.047l4.738-1.71s.553.097 1.028.736c.464.665-.17 1.196-.17 1.196l-4.823 1.824",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M294.991 225.36c-.808-.267-1.161-1.179-.773-2.047l4.738-1.71s.553.097 1.028.736c.464.665-.17 1.196-.17 1.196l-4.823 1.824",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M345.634 286.058c-3.862-2.726-15.003-4.29-16.585-3.874 7.818 6.166 15.84 6.507 16.585 3.874z",
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M345.594 286.073c-.745 2.633-8.727 2.277-16.528-3.854 8.431 2.693 15.566 4.286 16.528 3.854z",
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M345.594 286.073c-.745 2.633-8.727 2.277-16.528-3.854 8.431 2.693 15.566 4.286 16.528 3.854z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M345.617 286.025c-4.111-2.899-15.595-4.156-16.613-3.885 7.83 6.142 15.868 6.517 16.613 3.885z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M299.505 222.067l24.398 52.694c1.245.998 2.32-.302 2.677-.15 1.491 1.736 3.586 2.121 4.022 2.528 1.722 2.438.706 4.382.598 4.543-1.362 1.767 1.494 3.55 1.366 4.101.547 1.011 2.684.816 3.099 2.037.097-.136 4.165 8.387 4.592 9.3.623.5 3.522 6.18 3.522 6.18 2.113-.005 10.338-5.063 10.496-4.98-4.414-7.368-15.128-18.731-14.89-19.443-2.97-5.252-7.767-10.966-9.88-10.962-2.965-1.622-4.343-5.699-3.742-6.624-2.301-.089-3.527-1.477-3.686-1.56l-18.03-37.848c-1.56-.54-1.336.104-1.858 1 0 0-.977-1.217-.908-1.363-.879-.447-1.756.157-1.776.547z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M299.505 222.067l24.398 52.694c1.245.998 2.32-.302 2.677-.15 1.491 1.736 3.586 2.121 4.022 2.528 1.722 2.438.706 4.382.598 4.543-1.362 1.767 1.494 3.55 1.366 4.101.547 1.011 2.684.816 3.099 2.037.097-.136 4.165 8.387 4.592 9.3.623.5 3.522 6.18 3.522 6.18 2.113-.005 10.338-5.063 10.496-4.98-4.414-7.368-15.128-18.731-14.89-19.443-2.97-5.252-7.767-10.966-9.88-10.962-2.965-1.622-4.343-5.699-3.742-6.624-2.301-.089-3.527-1.477-3.686-1.56l-18.03-37.848c-1.56-.54-1.336.104-1.858 1 0 0-.977-1.217-.908-1.363-.879-.447-1.756.157-1.776.547z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M298.753 210.639c.467 1.04-.289 1.034-.55 1.17l-1.088.276c-1.221 0-1.878.624-1.897 1.014l28.685 61.662c1.245.998 2.478-.218 2.864-.056l-19.675-42.131s-7.6-14.82-9.586-18.937l2.739-1.121c.847-.188 1.11-.748.757-1.608l-12.13-21.802 9.707 21.133.174.4",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M298.753 210.639c.467 1.04-.289 1.034-.55 1.17l-1.088.276c-1.221 0-1.878.624-1.897 1.014l28.685 61.662c1.245.998 2.478-.218 2.864-.056l-19.675-42.131s-7.6-14.82-9.586-18.937l2.739-1.121c.847-.188 1.11-.748.757-1.608l-12.13-21.802 9.707 21.133.174.4",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M337.193 274.915c2.943-.086 4.547 2.114 2.574 4.69m-1.33-2.36c1.043.588 1.729-.308 1.729-.308m-14.983-13.296c1.44 5.628 4.189 9.387 4.734 10.54 2.115 2.234 3.801 7.268 3.456 8.14l7.828 13.426",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M324.032 274.976c1.332-.446 5.795-4.455 10.08-3.679 3.199 3.857 5.084 7.77 5.655 8.308-4.067 3.239-6.734 4.838-7.72 5.318-.628-.416-.952-1.548-.952-1.548-.814-.934.224-1.737.224-1.737-.062-2.459-1.815-4.2-3.627-4.346-2.272-.22-1.63-.394-1.919-.409-1.03-.612-1.74-1.907-1.74-1.907z",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M324.032 274.976c1.332-.446 5.795-4.455 10.08-3.679 3.199 3.857 5.084 7.77 5.655 8.308-4.067 3.239-6.734 4.838-7.72 5.318-.628-.416-.952-1.548-.952-1.548-.814-.934.224-1.737.224-1.737-.062-2.459-1.815-4.2-3.627-4.346-2.272-.22-1.63-.394-1.919-.409-1.03-.612-1.74-1.907-1.74-1.907z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M328.385 275.123c2.016-.01 4.057.98 4.697 2.704l-4.697-2.704",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M328.385 275.123c2.016-.01 4.057.98 4.697 2.704m3.582.73c-.195.415-.725.628-1.207.461-.482-.167-.718-.645-.523-1.06.195-.413.741-.592 1.223-.425.483.167.702.611.507 1.025zm-2.433-3.45c-.195.415-.753.618-1.235.451-.482-.166-.69-.635-.495-1.05.195-.413.713-.602 1.195-.435.482.167.73.621.535 1.035z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M301.636 228.048c-.794-.275-1.126-1.183-.724-2.036l4.725-1.623s.545.104 1.002.744c.446.664-.193 1.18-.193 1.18l-4.81 1.735",
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M301.636 228.048c-.794-.275-1.126-1.183-.724-2.036l4.725-1.623s.545.104 1.002.744c.446.664-.193 1.18-.193 1.18l-4.81 1.735",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M315.25 250.666c.522-.58 35.137-37.479 35.536-37.91a97.442 97.442 0 0 1-1.364-.936c-.388.406-35.094 37.343-35.654 37.922-.379-.163 1.89 1.267 1.482.924z",
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M349.812 212.207c-1.257-1.023-3.447-2.235-4.987-1.838-.519-2.146 2.504-4.384 3.77-4.057-.316 2.353 3.186 3.845 3.12 3.852l-1.903 2.043z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M352.105 210.406c.979.768 1.399.828 2.79 1.577 1.366.734 3.244-1.115 4.114-1.684 0 0 .93 3.4-1.133 5.64-2.063 2.242-4.555 2.717-6.523 2.058 0 0 2.592-2.54 1.523-3.642-1.036-1.069-1.41-1.156-2.444-1.833",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.67726 .73575 -.82314 -.56784 0 0)",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.124,
    d: "M-27.732-406.526h4.138v2.264h-4.138z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M308.168 290.315l-.922 9.039s1.399-1.712 1.735-2.281c.336-.57 1.549-2.09 1.808-7.36 0 0-.947-2.912-1.393-2.906-.741-.366-1.228 3.508-1.228 3.508zm2.223-20.15s-2.427 14.512-2.673 15.832c0 .451 1.232 1.648 2.122-1.158l1.466-10.551s-.66-2.811-.915-4.124z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M315.877 284.565c-.592-.744-1.332-1.673-1.405-2.048l-.382 3.202s2.02 1.475 1.731 4.3l.392-.57.227-1.131s.415-1.886.419-3.015c0 0-.427-.182-.982-.738z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M307.246 299.352s3.353-2.868 3.543-9.64l.415-1.886s.07 1.504.742.366c.655-1.514.622-2.83.622-2.83s1.213-1.52 1.578.354c0 0-1.126 8.854-1.203 9.607a51.406 51.406 0 0 1-.267 2.072s-.665-1.119-1.337.019c-.729 1.138-1.885 2.659-4.093 1.938zm4.06-25.065l-1.466 10.55s1.168.548 1.364 2.99c.108 1.126.555.555.742.365.244-.756.063-2.257.063-2.257l.638-7.343s-1.27-3.366-1.341-4.305z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M310.145 298.749l-.213 2.635s1.003-.014 1.675-1.152c.784-1.14 1.068-2.835 1.068-2.835s-.776-1.118-1.337.018c-.542.948-1.193 1.334-1.193 1.334zm1.8-10.556c.542-.948.715-2.642.623-2.829l-.682.572c.22 1.125.06 2.257.06 2.257z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M315.247 287.13a4.4 4.4 0 0 0-1.24-1.486l-1.488 11.867s-.419 3.014-2.279 3.793c0 0 1.06 10.327 4.414 7.459.484-.383 1.09-3.588.891-5.466-.234-2.065-.782-4.878-.834-6.005-.032-1.316.154-2.649.476-4.722.133-.753.523-2.406.598-2.595.187-.191-.04-1.723-.538-2.844z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.86 285.306s.906.928 1.073.925c.223-.003-2.353 19.352-2.353 19.352s.097-2.029-.655-5.97c-.61-3.2.177-7.498.866-9.56 0 0 .813-.606 1.068-4.747z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M312.572 278.786s-.502 5.46-.619 7.154c0 0 1.699-2.469 2.137-.218l.382-3.202s-1.478-2.424-1.9-3.734z",
    fill: "#f7e214",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M311.27 287.81s-.557-6.116-3.52-1.792c-.114.002-.271 2.43-.101 3.01.093.778.913 1.74 1.255 2.318.648.964 1.34-.214 1.34-.214s.674-.982 1.027-3.322z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M287.8 236.938c-.11-3.48-1.205-9.27-1.26-13.239l-12.006-12.234s-1.482 9.912-5.84 15.58l19.105 9.9",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M288.666 237.35c.506-2.42 1.113-5.144 1.515-10.207l-7.729-7.615c.031 3.177-3.568 8.094-3.812 14.032",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M295.331 244.682c.887-4.247-1.287-4.774 1.946-10.75l-7.142-6.848c-1.33 4.027-2.227 6.62-2.11 10.1l6.084 4.33",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M267.551 270.082c-1.446-4.298.518-12.73.3-18.134-.164-3.485 2.399-16.591 2.344-20.556l-14.115-8.815s-.615 14.324-2.24 29.927c-1.46 8.014-1.451 15.337-.401 21.454 1.5 8.695 2.975 12.265 6.487 15.943 6.234 6.451 19.658 2.724 19.658 2.724 11.308-2.34 17.822-9.463 17.822-9.463s-3.678.869-9.638 1.475c-13.06-.915-18.205 2.349-18.611-11.052",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M305.379 278.765l.218-.094c-2.448.916-5.862 1.928-5.862 1.928l-7.958.612c-17.262.404-15.101-10.285-14.417-27.529.164-6.544 1.461-14.785 1.127-17.703l-11.572-6.629c-3.774 10.664-2.598 18.124-3.353 23.579-.395 5.876-1.648 17.352.258 22.359 2.697 11.649 11.818 11.174 24.165 10.15 6.125-.508 9.42-2.083 9.42-2.083l7.967-4.584",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M305.604 278.531c-2.394 1.24-5.917 2.155-5.917 2.155l-8.066.796c-12.514 1.062-19.84-7.728-18.236-27.605.01-7.022.235-10.141 2.658-19.495l6.878 4.035v.647c-.389 2.1-1.373 7.01-1.373 9.256 0 15.959 10.09 28.217 23.838 30.298l.218-.093",
    fill: "#007a3d",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M259.92 230.547c1.166 1.96 8.13 12.568 12.031 14.574m-10.858-7.644c1.167 2.007 9.692 13.954 13.532 14.626m-15.483 3.632c1.951 2.34 3.895 6.976 9.692 9.982m-6.963 3.299c3.894 3.632 13.532 11.614 22.835 11.942m-22.835-5.966c1.95 2.34 6.18 13.283 24.008 8.317m-26.737-6.31c1.167 2.625 10.081 17.252 25.96 11.608",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M277.75 264.83c-1.446-4.298.517-12.73.299-18.134-.164-3.485 1.48-15.54 1.426-19.505l-13.196-9.866s-.615 14.324-2.24 29.927c-1.461 8.014-2.575 17.83-1.492 23.942 1.772 10.001 6.581 12.814 7.45 13.588 6.74 6.006 21.958 5.416 23.47 4.875 10.874-3.886 15.611-10.795 15.611-10.795s-5.152-.083-11.111.523c-13.06-.915-19.657-.37-20.064-13.771",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M315.578 273.513l.218-.094c-2.448.916-5.863 1.928-5.863 1.928l-7.958.612c-17.262.404-15.1-10.284-14.416-27.528.164-6.544.389-12.422.054-15.34l-10.346-7.548c-3.774 10.664-2.751 16.68-3.507 22.134-.394 5.877-1.647 17.352.258 22.36 2.697 11.648 11.819 11.174 24.166 10.15 6.125-.509 9.42-2.084 9.42-2.084l7.967-4.584",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M315.884 273.357c-2.394 1.24-5.916 2.155-5.916 2.155l-8.067.796c-12.514 1.062-19.84-7.728-18.236-27.605.01-7.022-.224-7.515 2.199-16.869 3.833 2.484 11.16 8.739 11.16 8.739s-1.993 2.806-1.526 6.729c0 15.959 6.421 24.06 20.168 26.142l1.508-13.034",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M270.119 225.296c1.166 1.96 8.13 12.567 12.031 14.573m-10.858-7.643c1.166 2.006 9.692 13.953 13.532 14.626m-15.483 3.631c1.95 2.34 3.895 6.977 9.692 9.983m-6.964 3.298c3.895 3.632 13.532 11.615 22.836 11.942m-22.836-5.966c1.951 2.34 6.18 13.283 24.009 8.317m-26.737-6.31c1.167 2.626 10.081 17.252 25.96 11.608",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M256.173 223.963s-.584 5.083-.64 5.995c-.269 4.408-.145 7.743.063 9.82-.014.224.849 5.498.552 5.78-1.013 1.156-1.05 1.284-2.117.428-.153-.176.46-5.576.506-6.319.104-.797.27-7.106.384-9.857.012-1.088.947-6.443.947-6.443s.124-1.14.3.582",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M256.173 223.963s-.584 5.083-.64 5.995c-.269 4.408-.138 7.744.063 9.82-.014.224 1.03 7.565.705 5.786-1.013 1.157-1.221 1.593-2.29.737-.152-.176.48-5.891.526-6.634.104-.797.27-7.106.384-9.857.012-1.088.947-6.443.947-6.443s.124-1.14.3.582l.005.015z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M256.063 222.181s-1.15 6.09-1.255 9.585c-.15 4.239-.332 5.437-.265 7.909.045.169-.413 3.192-.548 4.507-.096.677.099.173-.014.224-.866.53-1.454.104-1.982-.314-.157-.119 1.4-3.782 1.445-4.524.821-10.757 2.381-17.061 2.381-17.061s-.622 3.816.238-.326",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M256.063 222.181s-1.15 6.09-1.248 9.585c-.15 4.239-.332 5.438-.265 7.909.045.17-.413 3.193-.548 4.507-.096.678.098.174-.014.224-.866.53-1.454.104-1.982-.314-.157-.118 1.399-3.781 1.445-4.531.821-10.757 2.374-17.061 2.374-17.061s-.622 3.816.239-.326v.007zm-.498 17.315s-.913.414-1.015.179m-.04-1.254s.78-.02.903-.24m-.045-1.049s-.576.375-.732.136m.717-1.682l-.554.024m.591-1.52l-.61.022m.515-2.148s-.344.153-.385-.073m.493-1.7l-.497-.022m-.475 9.563s-.896.128-.995-.158m1.066-1.905s-.892.073-.93-.211m.966-1.277s-.725.023-.776-.035m.919-1.4l-.722-.032m.718-1.69l-.494-.078m.694-1.402s-.45.093-.545-.136m.595-1.59s-.405.263-.388-.018m-.049 8.958s-.888.01-.872-.264m12.754-19.782s-.584 5.083-.64 5.994c-.27 4.408-.145 7.744.062 9.82-.013.224.85 5.498.553 5.78-1.014 1.156-1.05 1.284-2.117.429-.154-.176.46-5.577.506-6.32.103-.797.27-7.106.384-9.857.012-1.088.947-6.443.947-6.443s.124-1.14.299.582",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M266.372 218.712s-.584 5.083-.64 5.994c-.27 4.408-.138 7.744.063 9.82-.014.224 1.03 7.565.705 5.787-1.014 1.156-1.222 1.592-2.29.736-.153-.176.48-5.89.526-6.633.103-.798.27-7.107.384-9.858.012-1.088.947-6.443.947-6.443s.124-1.14.299.582l.006.015z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M266.262 216.93s-1.15 6.09-1.255 9.584c-.15 4.239-.332 5.438-.265 7.909.045.17-.414 3.193-.548 4.507-.097.678.098.174-.014.224-.866.53-1.455.104-1.982-.314-.157-.118 1.399-3.781 1.444-4.524.822-10.757 2.382-17.06 2.382-17.06l.238-.327",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M266.262 216.93s-1.15 6.09-1.248 9.584c-.15 4.24-.333 5.438-.265 7.91.044.169-.414 3.192-.549 4.506-.096.678.099.174-.013.225-.866.53-1.455.103-1.982-.314-.157-.119 1.399-3.782 1.444-4.532.822-10.757 2.375-17.061 2.375-17.061l.239-.326v.007zm-.498 17.314s-.913.414-1.015.18m-.04-1.255s.78-.02.903-.24m-.045-1.049s-.576.376-.732.137m.717-1.683l-.555.024m.592-1.519l-.61.021m.515-2.148s-.344.154-.385-.073m.493-1.7l-.497-.022m-.476 9.564s-.895.127-.994-.158m1.066-1.906s-.892.073-.93-.21m.966-1.278s-.725.023-.776-.035m.919-1.4l-.722-.032m.718-1.69l-.494-.077m.693-1.403s-.45.093-.545-.136m.596-1.59s-.405.264-.388-.018m-.05 8.959s-.888.009-.87-.264",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M274.333 211.261s.459 5.14.178 8.043c-.326 3.523-.277 4.532-.627 6.573-.056.137.061 2.679.041 3.778.015.57-.116.136-.011.187.803.51 1.435.206 2.008-.097.224-.083-.97-3.247-.932-3.866.385-8.979-.463-14.328-.463-14.328l-.201-.29",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M274.333 211.261s.464 5.14.171 8.043c-.324 3.523-.277 4.531-.627 6.573-.056.136.061 2.678.041 3.778.015.569-.116.136-.01.187.802.51 1.434.205 2.007-.097.224-.083-.97-3.248-.931-3.873.384-8.978-.457-14.327-.457-14.327l-.2-.29zm-.337 14.673s.877.18 1.008-.049m-.787-1.663s.88.134.895-.101m-.819-1.137s.712.078.776.035m-.764-1.236l.722.033m-.526-1.459l.5-.024m-.472-1.216s.376.112.503-.07m-.415-1.366s.368.251.382.017m-.954 7.425s.883.08.897-.147",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M306.013 221.647l.797.06s-1.233-.09-.797-.06z",
    fill: "#005000",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M316.724 256.4s-.371-.159-.464 0c0 .08.093.16.185.16.093 0 .28-.16.28-.16zm-1.022 1.115s1.58-.159 2.137-.159",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M292.19 284.203c-.228 3.057-7.355 6.571-12.68.12-5.689-4.503-4.458-11.391.063-12.345l54.614-53.263c2.191-1.197 2.402-2.337 3.493-3.502 2.293 2.433 7.039 6.803 9.628 8.914-1.575 1.317-2.855 2.565-3.204 3.593l-51.914 56.483z",
    fill: "#e8a30e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.124
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M337.818 215.05c2.607-3.577 12.77 5.717 10.054 8.603-2.715 2.885-12.456-4.992-10.054-8.603z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M346.963 222.96c-1.914 1.452-9.281-4.786-8.062-7.144 2.033-2.21 10.138 5.71 8.062 7.143z",
    fill: "#cccccf",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M344.029 227.873c-4.578-1.46-7.821-4.506-9.875-9.058m-22.97 44.925c-5.757-1.779-9.7-5.532-11.475-11.644m9.14 14.326c-5.756-1.779-9.698-5.532-11.474-11.644m-2.11 25.795c-5.757-1.778-10.38-5.994-12.155-12.106m9.754 14.79c-5.756-1.779-10.448-6.06-12.223-12.173",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M279.346 285.02c-.285 1.36-1.029 1.783-2.068 1.367m13.75-1.919c-2.16 3.4-4.563 2.377-6.573 2.412",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M276.39 285.201c0 .91.769 1.644 1.719 1.643.95 0 1.723-.737 1.728-1.646.005-.91-.76-1.648-1.71-1.651-.949-.004-1.718 1.004-1.729 1.913",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 284.856c-.285 1.359-1.029 1.783-2.068 1.367m13.586-1.755c-2.16 3.4-4.563 2.377-6.573 2.412",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M331.832 290.315l.922 9.039s-1.399-1.712-1.735-2.281c-.336-.57-1.549-2.09-1.808-7.36 0 0 .947-2.912 1.393-2.906.741-.366 1.228 3.508 1.228 3.508zm-2.223-20.15s2.427 14.512 2.673 15.832c0 .451-1.232 1.648-2.122-1.158l-1.466-10.551s.66-2.811.915-4.124z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M324.123 284.565c.592-.744 1.332-1.673 1.405-2.048l.382 3.202s-2.02 1.475-1.731 4.3l-.392-.57-.227-1.131s-.415-1.886-.419-3.015c0 0 .427-.182.982-.738z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M332.754 299.352s-3.353-2.868-3.543-9.64l-.415-1.886s-.07 1.504-.742.366c-.655-1.514-.622-2.83-.622-2.83s-1.213-1.52-1.578.354c0 0 1.126 8.854 1.203 9.607.096.941.267 2.072.267 2.072s.665-1.119 1.337.019c.729 1.138 1.885 2.659 4.093 1.938zm-4.06-25.065l1.466 10.55s-1.168.548-1.364 2.99c-.108 1.126-.555.555-.742.365-.244-.756-.063-2.257-.063-2.257l-.638-7.343s1.27-3.366 1.341-4.305z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M329.855 298.749l.213 2.635s-1.003-.014-1.675-1.152c-.784-1.14-1.068-2.835-1.068-2.835s.776-1.118 1.337.018c.542.948 1.193 1.334 1.193 1.334zm-1.8-10.556c-.542-.948-.715-2.642-.623-2.829l.682.572c-.22 1.125-.06 2.257-.06 2.257z",
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M324.753 287.13a4.4 4.4 0 0 1 1.24-1.486l1.488 11.867s.419 3.014 2.279 3.793c0 0-1.06 10.327-4.414 7.459-.484-.383-1.09-3.588-.891-5.466.234-2.065.782-4.878.834-6.005.032-1.316-.154-2.649-.476-4.722-.133-.753-.523-2.406-.598-2.595-.187-.191.04-1.723.538-2.844z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M323.14 285.306s-.906.928-1.073.925c-.223-.003 2.353 19.352 2.353 19.352s-.097-2.029.655-5.97c.61-3.2-.177-7.498-.866-9.56 0 0-.813-.606-1.068-4.747z",
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M327.428 278.786s.502 5.46.619 7.154c0 0-1.699-2.469-2.137-.218l-.382-3.202s1.478-2.424 1.9-3.734z",
    fill: "#f7e214",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M328.73 287.81s.557-6.116 3.52-1.792c.114.002.271 2.43.101 3.01-.093.778-.913 1.74-1.255 2.318-.648.964-1.34-.214-1.34-.214s-.674-.982-1.027-3.322z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M352.2 236.938c.11-3.48 1.205-9.27 1.26-13.239l12.006-12.234s1.482 9.912 5.84 15.58l-19.105 9.9",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M351.334 237.35c-.506-2.42-1.113-5.144-1.515-10.207l7.729-7.615c-.031 3.177 3.568 8.094 3.812 14.032",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M344.669 244.682c-.887-4.247 1.287-4.774-1.946-10.75l7.142-6.848c1.33 4.027 2.227 6.62 2.11 10.1l-6.084 4.33",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M372.449 270.082c1.446-4.298-.518-12.73-.3-18.134.164-3.485-2.399-16.591-2.344-20.556l14.115-8.815s.615 14.324 2.24 29.927c1.46 8.014 1.451 15.337.401 21.454-1.5 8.695-2.975 12.265-6.487 15.943-6.234 6.451-19.658 2.724-19.658 2.724-11.308-2.34-17.822-9.463-17.822-9.463s3.678.869 9.638 1.475c13.06-.915 18.205 2.349 18.611-11.052",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M334.621 278.765l-.218-.094c2.448.916 5.862 1.928 5.862 1.928l7.958.612c17.262.404 15.101-10.285 14.417-27.529-.164-6.544-1.461-14.785-1.127-17.703l11.572-6.629c3.774 10.664 2.598 18.124 3.353 23.579.395 5.876 1.648 17.352-.258 22.359-2.697 11.649-11.818 11.174-24.165 10.15-6.125-.508-9.42-2.083-9.42-2.083l-7.967-4.584",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M334.396 278.531c2.394 1.24 5.917 2.155 5.917 2.155l8.066.796c12.514 1.062 19.84-7.728 18.236-27.605-.01-7.022-.235-10.141-2.658-19.495l-6.878 4.035v.647c.389 2.1 1.373 7.01 1.373 9.256 0 15.959-10.09 28.217-23.838 30.298l-.218-.093",
    fill: "#007a3d",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M380.08 230.547c-1.166 1.96-8.13 12.568-12.031 14.574m10.858-7.644c-1.167 2.007-9.692 13.954-13.532 14.626m15.483 3.632c-1.951 2.34-3.895 6.976-9.692 9.982m6.963 3.299c-3.894 3.632-13.532 11.614-22.835 11.942m22.835-5.966c-1.95 2.34-6.18 13.283-24.008 8.317m26.737-6.31c-1.167 2.625-10.081 17.252-25.96 11.608",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25 264.83c1.446-4.298-.517-12.73-.299-18.134.164-3.485-1.48-15.54-1.426-19.505l13.196-9.866s.615 14.324 2.24 29.927c1.461 8.014 2.575 17.83 1.492 23.942-1.772 10.001-6.581 12.814-7.45 13.588-6.74 6.006-21.958 5.416-23.47 4.875-10.874-3.886-15.611-10.795-15.611-10.795s5.152-.083 11.111.523c13.06-.915 19.657-.37 20.064-13.771",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M324.422 273.513l-.218-.094c2.448.916 5.863 1.928 5.863 1.928l7.958.612c17.262.404 15.1-10.284 14.416-27.528-.164-6.544-.389-12.422-.054-15.34l10.346-7.548c3.774 10.664 2.751 16.68 3.507 22.134.394 5.877 1.647 17.352-.258 22.36-2.697 11.648-11.819 11.174-24.166 10.15-6.125-.509-9.42-2.084-9.42-2.084l-7.967-4.584",
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M324.116 273.357c2.394 1.24 5.916 2.155 5.916 2.155l8.067.796c12.514 1.062 19.84-7.728 18.236-27.605-.01-7.022.224-7.515-2.199-16.869-3.833 2.484-11.16 8.739-11.16 8.739s1.993 2.806 1.526 6.729c0 15.959-6.421 24.06-20.168 26.142l-1.508-13.034",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M369.881 225.296c-1.166 1.96-8.13 12.567-12.031 14.573m10.858-7.643c-1.166 2.006-9.692 13.953-13.532 14.626m15.483 3.631c-1.95 2.34-3.895 6.977-9.692 9.983m6.964 3.298c-3.895 3.632-13.532 11.615-22.836 11.942m22.836-5.966c-1.951 2.34-6.18 13.283-24.009 8.317m26.737-6.31c-1.167 2.626-10.081 17.252-25.96 11.608",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M383.827 223.963s.584 5.083.64 5.995c.269 4.408.145 7.743-.063 9.82.014.224-.849 5.498-.552 5.78 1.013 1.156 1.05 1.284 2.117.428.153-.176-.46-5.576-.506-6.319-.104-.797-.27-7.106-.384-9.857-.012-1.088-.947-6.443-.947-6.443s-.124-1.14-.3.582",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M383.827 223.963s.584 5.083.64 5.995c.269 4.408.138 7.744-.063 9.82.014.224-1.03 7.565-.705 5.786 1.013 1.157 1.221 1.593 2.29.737.152-.176-.48-5.891-.526-6.634-.104-.797-.27-7.106-.384-9.857-.012-1.088-.947-6.443-.947-6.443s-.124-1.14-.3.582l-.005.015z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M383.937 222.181s1.15 6.09 1.255 9.585c.15 4.239.332 5.437.265 7.909-.045.169.413 3.192.548 4.507.096.677-.098.173.014.224.866.53 1.454.104 1.982-.314.157-.119-1.4-3.782-1.445-4.524-.821-10.757-2.381-17.061-2.381-17.061s.622 3.816-.238-.326",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M383.937 222.181s1.15 6.09 1.248 9.585c.15 4.239.332 5.438.265 7.909-.045.17.413 3.193.548 4.507.096.678-.098.174.014.224.866.53 1.454.104 1.982-.314.157-.118-1.399-3.781-1.445-4.531-.821-10.757-2.374-17.061-2.374-17.061s.622 3.816-.239-.326v.007zm.498 17.315s.913.414 1.015.179m.04-1.254s-.78-.02-.903-.24m.045-1.049s.576.375.732.136m-.717-1.682l.554.024m-.591-1.52l.61.022m-.515-2.148s.344.153.385-.073m-.493-1.7l.497-.022m.475 9.563s.896.128.995-.158m-1.066-1.905s.892.073.93-.211m-.966-1.277s.725.023.776-.035m-.919-1.4l.722-.032m-.718-1.69l.494-.078m-.694-1.402s.45.093.545-.136m-.595-1.59s.405.263.388-.018m.049 8.958s.888.01.872-.264",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M373.628 218.712s.584 5.083.64 5.994c.27 4.408.145 7.744-.063 9.82.014.224-.849 5.498-.552 5.78 1.014 1.156 1.05 1.284 2.117.429.153-.176-.46-5.577-.506-6.32-.103-.797-.27-7.106-.384-9.857-.012-1.088-.947-6.443-.947-6.443s-.124-1.14-.299.582",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M373.628 218.712s.584 5.083.64 5.994c.27 4.408.138 7.744-.063 9.82.014.224-1.03 7.565-.705 5.787 1.014 1.156 1.222 1.592 2.29.736.153-.176-.48-5.89-.526-6.633-.103-.798-.27-7.107-.384-9.858-.012-1.088-.947-6.443-.947-6.443s-.124-1.14-.299.582l-.006.015z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M373.738 216.93s1.15 6.09 1.255 9.584c.15 4.239.332 5.438.265 7.909-.045.17.414 3.193.548 4.507.097.678-.098.174.014.224.866.53 1.455.104 1.982-.314.157-.118-1.399-3.781-1.444-4.524-.822-10.757-2.382-17.06-2.382-17.06l-.238-.327",
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M373.738 216.93s1.15 6.09 1.248 9.584c.15 4.24.333 5.438.265 7.91-.044.169.414 3.192.549 4.506.096.678-.099.174.013.225.866.53 1.455.103 1.982-.314.157-.119-1.399-3.782-1.444-4.532-.822-10.757-2.375-17.061-2.375-17.061l-.239-.326v.007zm.498 17.314s.913.414 1.015.18m.04-1.255s-.78-.02-.903-.24m.045-1.049s.576.376.732.137m-.717-1.683l.555.024m-.592-1.519l.61.021m-.515-2.148s.344.154.385-.073m-.493-1.7l.497-.022m.476 9.564s.895.127.994-.158m-1.066-1.906s.892.073.93-.21m-.966-1.278s.725.023.776-.035m-.919-1.4l.722-.032m-.718-1.69l.494-.077m-.693-1.403s.45.093.545-.136m-.596-1.59s.405.264.388-.018m.05 8.959s.888.009.87-.264M365.667 211.261s-.459 5.14-.178 8.043c.326 3.523.277 4.532.627 6.573.056.137-.061 2.679-.041 3.778-.015.57.116.136.011.187-.803.51-1.435.206-2.008-.097-.224-.083.97-3.247.932-3.866-.385-8.979.463-14.328.463-14.328l.201-.29",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M365.667 211.261s-.464 5.14-.171 8.043c.324 3.523.277 4.531.627 6.573.056.136-.061 2.678-.041 3.778-.015.569.116.136.01.187-.802.51-1.434.205-2.007-.097-.224-.083.97-3.248.931-3.873-.384-8.978.457-14.327.457-14.327l.2-.29zm.337 14.673s-.877.18-1.008-.049m.787-1.663s-.88.134-.895-.101m.819-1.137s-.712.078-.776.035m.764-1.236l-.722.033m.526-1.459l-.5-.024m.472-1.216s-.376.112-.503-.07m.415-1.366s-.368.251-.382.017m.954 7.425s-.883.08-.897-.147",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M333.987 221.647l-.797.06s1.233-.09.797-.06z",
    fill: "#005000",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M323.276 256.4s.371-.159.464 0c0 .08-.093.16-.185.16-.093 0-.28-.16-.28-.16zm1.022 1.115s-1.58-.159-2.137-.159",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M291.666 215.475c-.028-2.1 1.95-3.315 2.254-3.52.97-.656 1.63-1.224 3.722-1.497 0 0 .143.433.135.805-.007.372-.462 1.658-2.07 2.745-1.638 1.107-4.04 1.467-4.04 1.467z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M291.643 214.674l29.644 38.48 1.409-1.388-30.24-39.086-.813 1.994z",
    fill: "#a05a2c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M291.184 207.16s3.207-.334 2.783-2.167c-.453-1.813-2.613-1.778-3.515-1.863-.932-.062-3.873.622-4.746 1.497-.902.895-2.745 2.425-2.148 4.997s1.354 4.342 2.3 5.944c.94 1.648.704 3.233.453 3.932-.076.297-.372 1.27.431 1.625 1.182.505 1.477.508 2.5-.631 1.048-1.115 2.452-2.92 2.422-5.02-.028-2.099 1.95-3.314 2.254-3.52.97-.655 1.63-1.223 3.722-1.496 0 0-.742-1.21-1.856-1.15-1.137.035-3.395-.966-4.6-2.149z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M291.184 207.16s3.207-.334 2.783-2.167c-.453-1.813-2.613-1.778-3.515-1.863-.932-.062-3.873.622-4.746 1.497-.902.895-2.745 2.425-2.148 4.997s1.354 4.342 2.3 5.944c.94 1.648.704 3.233.453 3.932-.076.297-.372 1.27.431 1.625 1.182.505 1.477.508 2.5-.631 1.048-1.115 2.452-2.92 2.422-5.02-.028-2.099 1.95-3.314 2.254-3.52.97-.655 1.63-1.223 3.722-1.496 0 0-.742-1.21-1.856-1.15-1.137.035-3.395-.966-4.6-2.149z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M291.184 207.16c-.432.006-1.712-.555-2.599-.24-.864.339-2.654 1.385-2.366 2.903m10.428-.202s-1.85.761-3.153 1.642c-.547.37-2.359 2.043-3.527 3.24-1.031 1.023-1.26 2.4-3.474 3.896m8.988-9.049c-.38.338-.76.675-1.411 1.035-.621.338-.82.88-1.213 1.309",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M347.81 284.203c.228 3.057 7.355 6.571 12.68.12 5.689-4.503 4.458-11.391-.063-12.345l-54.614-53.263c-2.191-1.197-2.402-2.337-3.493-3.502-2.293 2.433-7.039 6.803-9.628 8.914 1.575 1.317 2.855 2.565 3.204 3.593l51.914 56.483z",
    fill: "#e8a30e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.124
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M302.182 215.05c-2.607-3.577-12.77 5.717-10.054 8.603 2.715 2.885 12.456-4.992 10.054-8.603z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M293.037 222.96c1.914 1.452 9.281-4.786 8.062-7.144-2.033-2.21-10.138 5.71-8.062 7.143z",
    fill: "#cccccf",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M295.971 227.873c4.578-1.46 7.821-4.506 9.875-9.058m22.97 44.925c5.757-1.779 9.7-5.532 11.475-11.644m-9.14 14.326c5.756-1.779 9.698-5.532 11.474-11.644m2.11 25.795c5.757-1.778 10.38-5.994 12.155-12.106m-9.754 14.79c5.756-1.779 10.448-6.06 12.223-12.173",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M360.654 285.02c.285 1.36 1.029 1.783 2.068 1.367m-13.75-1.919c2.16 3.4 4.563 2.377 6.573 2.412",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M363.61 285.201c0 .91-.769 1.644-1.719 1.643-.95 0-1.723-.737-1.728-1.646-.005-.91.76-1.648 1.71-1.651.949-.004 1.718 1.004 1.729 1.913",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M360.49 284.856c.285 1.359 1.029 1.783 2.068 1.367m-13.586-1.755c2.16 3.4 4.563 2.377 6.573 2.412",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M339.65 175.519c1.774 2.84 4.406 7.962 5.125 11.887 1.325 7.239-.746 15.265-7.053 20.936-5.138 4.621-13.202 6.05-16.569 6.74-3.359.69-5.789 1.77-6.344 2.512-.028-.523-.105-1.046.455-1.568 1.596-.703 4.184-1.12 7.793-1.863 7.251-1.495 14.87-4.213 19.02-12.126 5.411-10.318 2.187-18.427-2.501-26.476l.074-.042z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M341.642 206.232a.434.567 49.857 0 1-.625-.603.434.567 49.857 1 1 .625.603z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M346.576 204.94c-1.079.64-2.147.807-3.004 1.093-.661.221-1.8.58-2.193.728-.375.14-.96.405-1.46.631-.794.36-1.653 1.356-1.653 1.356s1.208 1.266 2.65 1.087c1.13-.14 1.7-.45 2.267-.727.59-.286.576-.612 1.425-1.224.939-.677 1.597-2.013 1.968-2.945zm-5.651 1.196c-.346.542-1.173.5-1.646.425l-.213.27c.649.01 1.536.017 1.98-.567-.011-.088-.064-.129-.121-.128z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M346.561 204.988c-.976.951-2.798 2.009-4.627 2.79-1.83.782-3.97 1.033-5 1.026l-.271.287c1.482-.138 3.437-.406 5.094-1.086 2.16-.886 3.933-2.025 4.818-2.96l-.014-.057zm-2.378 4.575c-1.947-.068-3.019.538-4.828.933-1.691.37-3.669-.51-4.763 1.118 4.406 2.856 7.588.934 9.591-2.05z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M340.22 213.565c-.84-.72-8.05-3.16-9.202-.433 1.715 1.897 6.736 2.32 9.201.433z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M338.51 215.485c-.761-.12-1.659-.297-2.536-.399-.881-.102-1.227-.254-1.878-.344-1.065-.147-2.285-1.642-6.04-.501 1.453 3.35 6.415 4.052 10.454 1.244zm1.624-1.866c-3.842.767-8.357-.002-10.142-1.055l-.284.19c4.115 1.754 8.114 1.523 10.426.865zm3.988-4.056c-2.262 1.517-5.178 2.648-11.423 1.812l-.086.216c8.558.734 9.405-.835 11.51-2.028z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M338.482 215.512c-2.986.106-4.667 1.436-10.26-1.317-.457-.225-1.067-.381-1.42-.549l-.513.19c.39.173 1.018.168 1.368.323 6.984 3.082 6.788 1.64 10.825 1.353z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M327.252 211.606a.427.576 66.176 1 0 .438.737.427.576 66.176 0 0-.438-.737z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M327.147 212.253c-.644.166-.83.932-.885 1.384l-.333.12c.17-.594.407-1.406 1.122-1.65.085.035.113.094.096.146z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M345.92 186.814a.444.554 15.75 1 1-.864-.206.444.554 15.75 0 1 .865.206z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M341.622 203.154c-.14-2.086-1.152.805-3.197-3.856-.595-1.354-.59-2.218-.993-4.252 1.113 1.758 2.975 2.232 3.73 3.59.744 1.336.554 3.484.46 4.518z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M337.472 195.2s1.008 2.351 2.458 4.015c1.459 1.673 1.732 3.71 1.732 3.71",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M338.47 197.197c1.282 1.727 3.007 3.775 3.088 5.924l.2.075c-.298-2.827-1.97-4.133-3-5.559l-.289-.44zm10.847 2.668c-.94.772-1.927 1.052-2.7 1.434-.597.295-1.098.687-1.45.88-.337.184-.885.269-1.33.554-.704.452-2.082 2.032-2.082 2.032s1.307 1.07 2.116.895c2.355-.456 3.042-1.391 4.23-2.256.918-.751.979-2.535 1.216-3.54z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M340.695 204.836l-.221.325c1.351-.133 3.504-1.43 4.94-2.153 1.93-.971 3.012-1.71 3.826-3.093-.922 1.382-2.126 2.166-3.94 3.043-1.522.736-3.686 1.98-4.605 1.878z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M350.118 195.297c-.787.912-1.71 1.347-2.404 1.848-.535.387-.96.854-1.272 1.1-.299.236-.824.409-1.21.761-.614.559-1.525 2.19-1.525 2.19s.653.697 1.42.393c2.374-.294 3.071-1.42 3.954-3.445.494-1.05.983-1.82 1.037-2.847z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M341.539 199.448a.557.442 61.956 1 0 .81-.352.557.442 61.956 0 0-.81.352z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M342.51 201.586l-.16.356c2.846-1.298 6.58-3.914 7.801-6.578-1.737 2.874-4.608 4.769-7.64 6.222zm8.257-10.686c-.676.95-1.515 1.44-2.133 1.98-.477.416-.843.904-1.12 1.167-.264.252-.747.457-1.086.83-.538.59-1.279 2.254-1.279 2.254s.869.817 1.57.467c.7-.35 1.64-1.146 2.105-1.561.484-.432.603-1.475 1.171-2.27.662-.924.796-1.854.772-2.867z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M348.718 193.839c-1.38 1.572-3.079 3.07-4.669 3.756l-.125.36c2.59-1.467 3.68-2.794 4.826-4.066l-.032-.05zm1.07-5.646c-.472.922-1.178 1.47-1.666 2.027-.377.431-.637.907-.852 1.176-.206.257-.626.505-.88.878-.405.59-.81 2.142-.81 2.142s.588.626 1.189.22c.6-.406 1.46-1.235 1.826-1.663.381-.445.573-1.41.97-2.181.462-.899.424-1.724.223-2.6zm-4.37-1.094c-.25.541-.35 1.071-.512 1.63l-.064-.4c.133-.437.24-.896.448-1.298.043-.009.086-.011.128.068z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M348.37 191.04c-1.026 1.564-2.366 3.112-3.748 3.939l-.055.33c2.188-1.65 2.985-2.96 3.843-4.23l-.04-.04zm-5.62 9.896c-.114-.5-.206-.892-.533-1.34-.05-.003-.084.012-.095.059.298.483.424.906.507 1.49l.121-.21z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M341.886 181.318a.43.328 39.522 0 1-.488.442.43.328 39.522 0 1 .488-.442z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M343.15 182.53c-.357-.31-.8-.588-1.249-.863-.051.017-.057.053-.042.098.517.327.97.644 1.354 1.006l-.064-.24zm5.522.356c-1.13 2.386-3.85 4.052-2.76 7.552 2.81 2.539 2.991-4.542 2.76-7.552z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M346.094 177.666c-.463 2.438-2.627 4.455-1.209 7.686 3.985 1.002 2.086-4.368 1.209-7.686z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M343.737 174.014c2.002 3.723 2.483 5.876.12 8.317 0 0-1.24-1.165-1.536-3.31-.25-1.815 1.23-3.987 1.416-5.007z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M340.413 171.853c.532 2.36-1.511 3.442 1.41 6.482 2.085-2.48 1.09-3.1-1.41-6.482z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M339.628 175.983c-3.368.36-2.056-2.56-3.016-5.255 1.983 1.479 4.67 2.073 3.016 5.255zm2.195 4.455c-.947-4.39-3.968-2.673-5.64-4.608.865 2.832 2.135 4.765 5.64 4.608zm1.36 4.085c-2.632-.173-4.766-1.469-6.183-4.38 2.7 1.205 5.692 1.327 6.182 4.38z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M343.581 188.336c-1.038-1.192-1.064-1.96-1.46-2.755-.653-1.316-1.348-2.48-3.041-3.708.012 3.106.454 6.537 4.501 6.463z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M344.18 191.581c-1.616-2.25-3.113-4.163-5.556-5.733 1.014 2.21.545 6.298 5.555 5.733z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M343.723 196.043c-4.957-.14-4.488-4.816-4.53-7.004.896 1.34 1.991 2.503 2.807 3.466.89 1.052 1.748 2.24 1.723 3.538z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M343.125 198.828c-.4-1.014-.093-1.424-.978-2.315-.956-.962-2.79-2.685-3.75-4.662-.14 1.748-.162 4.447 1.192 5.35 1.025.683 1.918.875 3.536 1.627zm-4.33 7.247c-3.89-3.026-1.551-5.58-1.225-7.842.989 2.552 3.771 4.752 1.225 7.842zm1.595-29.177c-1.25-2.346-2.009-3.631-3.677-6.078 1.925 2.783 2.756 4.55 3.863 6.457",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M338.852 206.832c.159-3.082-.68-5.737-1.225-8.518.514 2.937 1.244 5.892.969 8.761l.256-.243zm4.618-7.388c-.405-1.884-4.118-3.135-5.045-7.512.76 4.352 4.524 5.449 4.903 7.898l.142-.386zm.831-2.562l-.1.478c-.55-2.95-4.015-4.402-5.016-8.336 1.463 4.263 4.288 4.826 5.116 7.858zm.685-4.417c-1.705-2.6-4.09-3.582-6.345-6.635 2.11 3 4.77 4.407 6.385 7.037l-.04-.402zm-.06-3.422c-1.877-.803-3.824-3.055-5.862-7.17 1.336 3.045 3.03 5.8 5.862 7.629v-.46z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M344.06 185.027c-2.19-1.731-5.03-2.88-7.071-4.914 1.697 1.936 4.956 3.288 7.13 5.201l-.06-.287zm-1.693-4.302c-2.212-1.503-4.344-1.972-6.184-4.818 1.478 2.785 3.83 3.49 6.265 5.029l-.08-.21zm6.305 2.218c-.793 3.073-1.463 6.302-3.565 8.375l.02-.402c.961-.537 2.48-3.739 3.545-7.973zm-2.558-5.162c-.144 3.175-.09 6.534-1.732 8.336l-.121-.363c1.675-1.357 1.536-4.946 1.853-7.973zm-2.256-3.614c.562 2.795.603 5.38-.141 9.56l-.161-.306c.467-2.463.996-4.986.302-9.254zm-3.384-2.218c1.123 2.37 1.983 4.77 1.249 7.342l-.202-.287c.87-2.351-.147-4.703-1.047-7.055zM336.131 203.153c1.328 3.195-.428 5.516-2.503 6.86-1.616-4.643 1.75-4.123 2.503-6.86z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M336.187 203.143c.228 1.977-1.921 4.19-2.587 7.534l-.3.272c.987-4.078 3.07-5.647 2.887-7.806z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M343.718 181.215a.328.43 1.848 1 1-.647-.116.328.43 1.848 0 1 .647.116z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M343.526 182.955c.029-.471-.022-.991-.079-1.515-.045-.03-.077-.013-.103.027.057.608.082 1.16.03 1.686l.152-.198z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M342.818 180.881a.264.383 1.944 0 1-.504.25.264.383 1.944 0 1 .504-.25z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M343.156 182.354c-.109-.387-.288-.77-.473-1.153-.04 0-.06.031-.068.076.208.45.378.871.484 1.313l.057-.236z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M344.702 186.875a.43.328 80.536 1 1-.658.013.43.328 80.536 0 1 .658-.013z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M344.857 188.62c-.065-.469-.216-.97-.375-1.472-.05-.02-.078.003-.096.047.175.585.309 1.122.361 1.648l.11-.224z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M343.61 187.228a.443.331 57.082 1 1-.457.491.443.331 57.082 0 1 .457-.49z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M344.796 188.575c-.334-.345-.75-.654-1.173-.959-.048.02-.053.06-.04.11.486.362.912.714 1.273 1.116l-.06-.267z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M343.352 199.13a.328.43 12.73 1 1-.614-.235.328.43 12.73 0 1 .614.236z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M342.839 200.804c.117-.458.165-.979.208-1.504-.039-.038-.074-.026-.107.007-.058.608-.137 1.156-.287 1.663l.186-.166z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M343.98 199.876a.328.43 50.478 1 0 .487.442.328.43 50.478 1 0-.487-.442z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M342.716 201.089c.357-.31.8-.589 1.249-.864.051.018.057.054.042.099-.517.326-.97.643-1.354 1.006l.063-.241z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M340.713 204.911a.328.43 40.348 1 1-.435-.493.328.43 40.348 0 1 .435.493z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M339.48 206.158c.316-.352.6-.79.882-1.236-.017-.051-.053-.057-.098-.043-.334.512-.657.96-1.025 1.34l.242-.06z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M338.843 204.513a.445.552 10.023 0 0 .886.1.445.552 10.023 1 0-.886-.1z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M339.378 205.072c-.234.603-.067.838.072 1.1l-.147.309c-.207-.346-.285-.729-.102-1.448.086-.033.15-.009.177.04zM327.265 214.455c-.665.057-.998-.314-1.215-.72l-.356-.002c.376.502.775.898 1.534.891.068-.06.072-.125.037-.169z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M327.31 215.146a.58.424 9.459 0 1 .196-.826.58.424 9.459 1 1-.195.826z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M332.694 206.08c.503 3.082-1.295 5.587-4.006 6.364-.886-3.974 2.777-4.116 4.006-6.364z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M332.7 206.105c-.996 2.418-2.343 4.67-4.756 7.15l-.519.068c2.686-2.125 4.16-4.885 5.274-7.218z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M327.8 213.302a.509.378 9.82 1 1-.401-.729.509.378 9.82 0 1 .4.729z",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M325.91 213.793c.494-.156.973-.415 1.45-.682-.006-.06-.05-.086-.11-.099-.56.301-1.092.546-1.658.7l.319.081zM328.536 208.8c-.13 1.237-1.104 2.351-2.002 3.22-.898.869-.998 1.194-2.264 1.57-1.218-2.77 2.853-3.32 4.266-4.79z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M328.524 208.77c-1.358 2.54-3.519 3.79-4.697 5.43l-.167-.016c1.687-2.225 3.122-2.647 4.864-5.413z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M300.422 175.519c-1.774 2.84-4.406 7.962-5.125 11.887-1.325 7.239.746 15.265 7.053 20.936 5.138 4.621 13.202 6.05 16.569 6.74 3.359.69 5.789 1.77 6.344 2.512.028-.523.105-1.046-.455-1.568-1.596-.703-4.184-1.12-7.793-1.863-7.251-1.495-14.87-4.213-19.02-12.126-5.411-10.318-2.187-18.427 2.501-26.476l-.074-.042z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M314.103 213.58c-.222.414-4.011 3.738-7.457 3.49-2.523-.183-2.94-.791-2.94-.791s-.235-.626 2.005-1.084c2.263-.463 6.186-2.009 8.392-1.614z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M303.83 216.295c2.709.306 5.468-.788 7.63-1.613",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M311.19 208.651c.292.05 3.401 1.643 4.599 3.735.876 1.53.734 1.898.734 1.898s-.222.262-1.31-.976c-1.098-1.25-3.373-3.272-4.023-4.657z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M316.483 214.207c-.886-1.666-2.49-3.086-3.73-4.205",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M300.265 175.85c-.073-.306.296-3.427 2.048-4.415 1.283-.724 1.745-.517 1.745-.517s.383.277-.488 1.27c-.879 1.003-2.082 3.163-3.305 3.663z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M303.992 170.95c-1.425.714-2.268 2.237-2.942 3.412",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M299.381 177.437c-.156-.208-1.02-2.948-.232-4.731.577-1.306.95-1.397.95-1.397s.346.01.132 1.304c-.216 1.307-.233 3.734-.85 4.824z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M300.067 171.372c-.672 1.378-.68 3.086-.703 4.417",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M299.374 177.463c.22.004 2.716-.73 3.882-2.093.854-.999.8-1.287.8-1.287s-.125-.223-1.092.532c-.977.762-2.922 1.925-3.59 2.848z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M304.017 174.134c-.88 1.095-2.25 1.912-3.312 2.558",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M298.181 179.59c-.165-.207-1.303-3.113-.867-5.222.32-1.543.633-1.704.633-1.704s.303-.045.298 1.427c-.005 1.487.321 4.187-.064 5.498z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M297.928 172.739c-.393 1.639-.16 3.539.007 5.021",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M297.301 181.576c-.255-.173-2.279-2.918-2.08-5.223.144-1.688.528-1.933.528-1.933s.393-.122.65 1.412c.26 1.55 1.175 4.282.902 5.744z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M295.738 174.503c-.225 1.805.423 3.726.91 5.229",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M296.213 184.14c-.22-.145-2.188-2.567-2.413-4.708-.165-1.568.084-1.817.084-1.817s.275-.134.718 1.27c.448 1.417 1.579 3.89 1.61 5.256z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M293.889 177.693c.124 1.68.923 3.42 1.533 4.78",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M298.237 179.617c.26.062 3.19-.248 4.544-1.718.992-1.077.925-1.465.925-1.465s-.151-.321-1.28.41c-1.141.737-3.416 1.747-4.19 2.773z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M303.66 176.49c-1.02 1.196-2.624 1.903-3.866 2.469",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M297.287 181.59c.254.08 3.2-.017 4.657-1.386 1.067-1.003 1.028-1.395 1.028-1.395s-.128-.331-1.307.316c-1.19.654-3.533 1.497-4.378 2.465z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M302.922 178.862c-1.104 1.119-2.754 1.709-4.034 2.184",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M296.358 184.174c.275.074 3.423-.155 4.924-1.681 1.099-1.118 1.04-1.536 1.04-1.536s-.15-.35-1.384.393c-1.247.75-3.717 1.752-4.58 2.824z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M302.27 181.015c-1.133 1.244-2.873 1.946-4.223 2.508",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M296.834 183.01s-.285-.553-.29-1.066c-.003-.513.128-.778.128-.778l-.2-.123s-.1.55-.099.814c.001.265.01.332.01.332s-.36-.308-.438-.483c-.078-.174-.178-.434-.178-.434l-.175.078s.163.542.301.648c.483.37.777 1.111.777 1.111",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.595 180.305a.543.369 83.534 1 1 .123 1.08.543.369 83.534 1 1-.123-1.08z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.838 180.298a.369.543 19.29 1 1-.359 1.025.369.543 19.29 1 1 .36-1.025z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M296.727 182.952s.57-.249.897-.644c.327-.396.392-.684.392-.684l.233.03s-.27.49-.437.694c-.168.205-.217.252-.217.252s.473-.013.644-.099c.17-.086.413-.225.413-.225l.086.171s-.468.318-.643.313c-.608-.017-1.304.372-1.304.372",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.394 181.634a.369.543 45.57 1 0-.776.761.369.543 45.57 1 0 .776-.76z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.443 180.848a.369.543 19.818 1 0-.368 1.022.369.543 19.818 1 0 .368-1.022z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M295.445 186.87c-.238-.136-2.444-2.525-2.819-4.736-.275-1.619-.032-1.893-.032-1.893s.277-.158.83 1.272c.559 1.444 1.898 3.94 2.021 5.358z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M292.604 180.32c.24 1.74 1.185 3.495 1.91 4.87",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M295.598 186.894c.291.06 3.549-.386 5.008-2.072 1.07-1.235.981-1.665.981-1.665s-.18-.353-1.414.5c-1.246.862-3.748 2.066-4.575 3.237z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M301.537 183.22c-1.096 1.369-2.86 2.213-4.225 2.886",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M295.173 189.627c.285.005 3.517-.923 5.028-2.65 1.107-1.264 1.038-1.63 1.038-1.63s-.163-.282-1.416.673c-1.266.966-3.785 2.438-4.65 3.607z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M301.187 185.412c-1.14 1.387-2.914 2.42-4.29 3.239",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M295.081 189.627c-.333-.103-3.379-2.249-3.836-4.54-.335-1.678.018-2.016.018-2.016s.399-.22 1.135 1.206c.743 1.44 2.556 3.859 2.683 5.35z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M291.275 183.155c.281 1.812 1.562 3.513 2.542 4.848",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M295.174 193.072c.29-.049 3.387-1.598 4.594-3.638.883-1.494.745-1.852.745-1.852s-.217-.257-1.307.95c-1.1 1.219-3.375 3.189-4.032 4.54z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M300.473 187.657c-.894 1.624-2.497 3.009-3.737 4.099",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M295.024 193.187c-.336-.043-3.619-1.681-4.458-3.965-.615-1.672-.338-2.09-.338-2.09s.342-.303 1.294 1.032c.963 1.348 3.118 3.504 3.502 5.023z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M290.254 187.217c.587 1.822 2.108 3.337 3.278 4.531",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M295.075 191.604s-.449-.51-.59-1.052c-.14-.541-.072-.857-.072-.857l-.244-.077s.04.608.112.888c.072.28.098.349.098.349s-.462-.23-.59-.395c-.13-.164-.306-.413-.306-.413l-.164.13s.317.53.492.605c.61.264 1.118.97 1.118.97",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.019 189.057a.593.402 69.444 1 1 .416 1.11.593.402 69.444 1 1-.416-1.11z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.33 188.72a.402.593 5.202 1 1-.107 1.182.402.593 5.202 1 1 .108-1.181z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M295.04 191.554s.537-.416.778-.921c.24-.505.233-.828.233-.828l.255-.03s-.156.59-.279.851c-.123.261-.162.324-.162.324s.497-.139.655-.276c.158-.136.377-.347.377-.347l.137.158s-.412.46-.597.501c-.649.144-1.282.74-1.282.74",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.525 189.454a.402.593 31.485 1 0-.62 1.011.402.593 31.485 1 0 .62-1.011z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.293 188.866a.402.593 5.73 1 0-.118 1.18.402.593 5.73 1 0 .118-1.18z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M295.429 196.224c-.324-.054-3.793-1.79-5.145-4.075-.99-1.672-.835-2.074-.835-2.074s.243-.287 1.464 1.064c1.233 1.365 3.78 3.572 4.516 5.085z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M289.494 190.16c1.002 1.819 2.797 3.37 4.185 4.59",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M295.651 196.166c.368-.047 3.964-1.842 4.884-4.342.674-1.832.37-2.288.37-2.288s-.374-.332-1.418 1.129c-1.054 1.476-3.415 3.837-3.836 5.5z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M300.877 189.628c-.644 1.995-2.31 3.654-3.592 4.962",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M296.59 199.248c.34-.087 3.672-2.236 4.537-4.77.633-1.854.356-2.263.356-2.263s-.344-.28-1.317 1.257c-.983 1.552-3.178 4.113-3.577 5.776z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M301.456 192.308c-.607 2.01-2.156 3.81-3.348 5.225",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M296.337 199.249c-.413.022-4.714-1.23-6.222-3.788-1.103-1.874-.862-2.435-.862-2.435s.345-.439 1.78.955c1.45 1.409 4.511 3.528 5.304 5.268z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M289.303 193.122c1.104 2.059 3.262 3.546 4.928 4.725",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M300.152 205.69c.265-.178 2.593-3.074 2.78-5.565.137-1.823-.18-2.1-.18-2.1s-.347-.143-.834 1.503c-.493 1.663-1.785 4.579-1.766 6.163z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M302.749 198.115c-.083 1.953-.995 4.004-1.692 5.609",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M299.952 205.62c-.428.131-5.3.02-7.6-2.132-1.683-1.575-1.585-2.198-1.585-2.198s.24-.528 2.138.482c1.918 1.02 5.728 2.324 7.047 3.848z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M290.846 201.372c1.735 1.76 4.419 2.673 6.5 3.407",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M298.161 203.082c-.379.02-4.724-1.028-6.81-3.207-1.527-1.594-1.45-2.074-1.45-2.074s.205-.377 1.914.807c1.727 1.196 5.145 2.992 6.346 4.474z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M289.973 197.882c1.576 1.753 3.984 3.014 5.851 4.013",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M298.4 202.952c.359-.131 3.568-2.794 3.935-5.58.268-2.04-.138-2.442-.138-2.442s-.45-.258-1.172 1.484c-.73 1.76-2.573 4.728-2.625 6.538z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M302.189 195.032c-.202 2.202-1.505 4.289-2.5 5.927",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M297.442 201.461s-.69-.322-1.076-.815c-.387-.494-.458-.848-.458-.848l-.285.03s.314.606.512.861c.199.256.257.314.257.314s-.577-.03-.783-.14c-.206-.111-.498-.288-.498-.288l-.11.206s.562.403.775.402c.743-.002 1.582.495 1.582.495",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.22 199.783a.664.45 45.889 1 1 .924.953.664.45 45.889 1 1-.924-.953z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.416 198.848a.664.45 71.645 1 1 .418 1.26.664.45 71.645 1 1-.418-1.26z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M297.531 201.438s.366-.667.387-1.294c.021-.626-.13-.954-.13-.954l.247-.145s.105.675.095.999c-.01.323-.022.404-.022.404s.449-.364.55-.575c.1-.211.231-.526.231-.526l.211.1s-.216.658-.388.783c-.602.437-.985 1.333-.985 1.333",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.133 198.173a.45.664 7.93 1 0-.183 1.315.45.664 7.93 1 0 .183-1.315z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.616 198.121a.664.45 72.174 1 0 .407 1.264.664.45 72.174 1 0-.407-1.264z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M301.771 207.593c-.303.192-4.25 1.066-6.767-.238-1.843-.955-1.958-1.483-1.958-1.483s.028-.48 1.867-.03c1.859.455 5.324.766 6.858 1.751z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M293.135 205.923c1.942 1.096 4.381 1.31 6.281 1.499",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M302.01 207.524c.213-.137 1.953-2.571 1.878-4.86-.055-1.677-.356-1.968-.356-1.968s-.313-.17-.579 1.304c-.268 1.489-1.11 4.053-.943 5.524z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M303.538 200.779c.115 1.802-.48 3.606-.93 5.019",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M305.54 210.337c-.374.229-5.108 1.462-7.981.244-2.104-.891-2.199-1.451-2.199-1.451s.07-.518 2.21-.17c2.16.352 6.233.43 7.97 1.377z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M295.461 209.178c2.21 1.036 5.077 1.087 7.308 1.149",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M305.764 210.31c.204-.3 1.22-3.828 0-5.651-.892-1.335-1.419-1.311-1.419-1.311s-.482.133-.096 1.58c.39 1.463.58 4.313 1.515 5.381z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M304.394 203.41c1.03 1.387 1.16 3.395 1.282 4.953",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M303.341 208.648s-.582.456-1.207.094c-.625-.363-.852-.712-.852-.712l-.293.154s.595.515.917.703c.321.188.409.226.409.226s-.63.215-.899.185c-.267-.03-.655-.095-.655-.095l-.03.268s.756.114 1.001.098c.246-.016 1.531-.515 1.531-.515",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.464 208.734a.765.52 24.117 1 1 1.397.625.765.52 24.117 1 1-1.397-.625z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.339 207.227a.765.52 49.87 1 1 .986 1.17.765.52 49.87 1 1-.986-1.17z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M303.452 209.033s.491-.553.168-1.199c-.323-.646-.658-.895-.658-.895l.172-.283s.477.627.645.96c.168.332.2.422.2.422s.255-.617.24-.886c-.013-.269-.053-.66-.053-.66l.269-.014s.067.763.036 1.007c-.031.243-.61 1.496-.61 1.496",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.72 205.138a.765.52 69.449 1 0 .537 1.433.765.52 69.449 1 0-.537-1.433zM302.156 205.923a.765.52 43.692 1 0 1.107 1.057.765.52 43.692 1 0-1.107-1.057z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M308.308 211.854c-.26.35-4.218 2.93-7.387 2.302-2.32-.46-2.629-1.061-2.629-1.061s-.136-.596 2.006-.752c2.164-.157 6.012-1.104 8.01-.489z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M298.406 213.123c2.476.595 5.185-.078 7.301-.576",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M310.771 212.546s-.467.712-1.282.548c-.816-.165-1.193-.462-1.193-.462l-.262.276s.84.342 1.26.429c.42.086.53.095.53.095s-.61.468-.913.533c-.303.066-.75.139-.75.139l.066.303s.868-.154 1.13-.262c.26-.108 1.479-1.127 1.479-1.127",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.57 214.057a.881.598 5.412 1 1 1.754.166.881.598 5.412 1 1-1.754-.166zM306.97 212.085a.881.598 31.167 1 1 1.507.912.881.598 31.167 1 1-1.508-.912z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M309.477 212.209c.18-.323.764-3.944-.898-5.577-1.218-1.196-1.806-1.101-1.806-1.101s-.522.197.143 1.573c.672 1.39 1.34 4.178 2.56 5.105z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M306.837 205.586c1.381 1.228 1.845 3.192 2.23 4.714",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M311.364 213.077s.22-.823-.447-1.32c-.667-.498-1.14-.581-1.14-.581l.03-.38s.815.397 1.16.653c.345.255.425.33.425.33s-.058-.765-.211-1.035c-.154-.27-.398-.65-.398-.65l.27-.154s.464.75.558 1.016c.094.267.148 1.854.148 1.854",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.67 208.927a.881.598 42.736 1 0 1.294 1.197.881.598 42.736 1 0-1.294-1.197zM308.467 210.543a.881.598 16.98 1 0 1.686.515.881.598 16.98 1 0-1.686-.515z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M319.105 208.988s-2.341 5.437-1.533 5.976c0 0 2.376-4.22 4.46-5.817 1.085-1.023 1.744.009 1.884-.89.14-.9-2.853-2.19-2.853-2.19l-1.916 2.696",
    fill: "#452c25"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M319.105 208.988s-2.341 5.437-1.533 5.976c0 0 2.376-4.22 4.46-5.818 1.085-1.022 1.744.01 1.884-.89.14-.899-2.853-2.189-2.853-2.189l-1.916 2.696",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.164
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M310.565 213.128s-3.403 5.923-2.51 5.993c.892.07 4.53-7.553 4.53-7.553l-1.24.212-.78 1.348z",
    fill: "#452c25"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M310.565 213.128s-3.403 5.923-2.51 5.993c.892.07 4.53-7.553 4.53-7.553l-1.24.212-.78 1.348z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M311.593 211.477s-3.557 5.828-2.667 5.922c.89.094 4.727-7.427 4.727-7.427l-1.246.179-.814 1.326z",
    fill: "#452c25"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M311.593 211.477s-3.557 5.828-2.667 5.922c.89.094 4.727-7.427 4.727-7.427l-1.246.179-.814 1.326z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M312.312 210.463s-4.05 5.482-3.171 5.657c.878.174 5.354-6.969 5.354-6.969l-1.256.065-.927 1.247z",
    fill: "#452c25"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M312.312 210.463s-4.05 5.482-3.171 5.657c.878.174 5.354-6.969 5.354-6.969l-1.256.065-.927 1.247z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M313.395 209.5s-4.742 4.868-3.895 5.163c.846.295 6.232-6.16 6.232-6.16l-1.253-.11-1.084 1.107z",
    fill: "#452c25"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M313.395 209.5s-4.742 4.868-3.895 5.163c.846.295 6.232-6.16 6.232-6.16l-1.253-.11-1.084 1.107z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M313.564 207.73s-4.138 5.412-3.263 5.602c.875.189 5.467-6.877 5.467-6.877l-1.257.043-.947 1.231z",
    fill: "#452c25"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M313.564 207.73s-4.138 5.412-3.263 5.602c.875.189 5.467-6.877 5.467-6.877l-1.257.043-.947 1.231z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M312.509 212.38s-4.05 5.483-3.172 5.658c.878.174 5.355-6.969 5.355-6.969l-1.257.065-.926 1.247z",
    fill: "#452c25"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M312.509 212.38s-4.05 5.483-3.172 5.658c.878.174 5.355-6.969 5.355-6.969l-1.257.065-.926 1.247z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M314.788 211.297s-2.371 4.463-2.1 4.648c.27.184 3.15-2.545 4.572-5.2 1.423-2.656-2.574.442-2.574.442",
    fill: "#452c25"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M314.788 211.297s-2.371 4.463-2.1 4.648c.27.184 3.15-2.545 4.572-5.2 1.423-2.656-2.574.442-2.574.442",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M315.041 210.855s-2.34 5.436-1.532 5.976c0 0 2.937-3.28 3.704-5.886.766-2.607 0-.18 0-.18l-.213-2.831-1.916 2.696",
    fill: "#452c25"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M315.041 210.855s-2.34 5.436-1.532 5.976c0 0 2.937-3.28 3.704-5.886.766-2.607 0-.18 0-.18l-.213-2.831-1.916 2.696",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.164
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M313.826 210.38s-4.742 4.868-3.896 5.163c.846.295 6.233-6.16 6.233-6.16l-1.254-.11-1.083 1.106z",
    fill: "#452c25"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M313.826 210.38s-4.742 4.868-3.896 5.163c.846.295 6.233-6.16 6.233-6.16l-1.254-.11-1.083 1.106z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M314.202 211.04s-4.742 4.868-3.895 5.163c.847.295 6.232-6.16 6.232-6.16l-1.253-.11-1.084 1.106z",
    fill: "#452c25"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M314.202 211.04s-4.742 4.868-3.895 5.163c.847.295 6.232-6.16 6.232-6.16l-1.253-.11-1.084 1.106z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M314.579 211.809s-4.742 4.868-3.895 5.163c.846.295 6.232-6.16 6.232-6.16l-1.253-.11-1.084 1.107z",
    fill: "#452c25"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M314.579 211.809s-4.742 4.868-3.895 5.163c.846.295 6.232-6.16 6.232-6.16l-1.253-.11-1.084 1.107z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M314.933 205.125s-3.522 4.5-3.015 5.274c.509.775 3.726-2.066 4.743-4.057 1.016-1.992-1.694-1.365-1.694-1.365",
    fill: "#452c25"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M314.933 205.125s-3.522 4.5-3.015 5.274c.509.775 3.726-2.066 4.743-4.057 1.016-1.992-1.694-1.365-1.694-1.365",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82 209.904s-3.02 5.78-2.24 5.447c.779-.332 3.84-4.678 4.178-5.637.34-.959.225-1.96.225-1.96l-2.337 1.438.2 1.12",
    fill: "#452c25"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82 209.904s-3.02 5.78-2.24 5.447c.779-.332 3.84-4.678 4.178-5.637.34-.959.225-1.96.225-1.96l-2.337 1.438.2 1.12",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M314.841 208.003s2.506-4.606-.017.868c-2.523 5.474-3.467 4.57-3.467 4.57-.195-.311 2.194-4.02 2.194-4.02s1.773-2.854 2.198-3.125",
    fill: "#452c25"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M314.841 208.003s2.506-4.606-.017.868c-2.523 5.474-3.467 4.57-3.467 4.57-.195-.311 2.194-4.02 2.194-4.02s1.773-2.854 2.198-3.125",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.113
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M317.528 207.392s2.787-4.575-.007.868c-2.794 5.444-3.883 4.524-3.883 4.524-.227-.316 2.44-3.993 2.44-3.993s1.979-2.83 2.46-3.096",
    fill: "#452c25"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M317.528 207.392s2.787-4.575-.007.868c-2.794 5.444-3.883 4.524-3.883 4.524-.227-.316 2.44-3.993 2.44-3.993s1.979-2.83 2.46-3.096",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.121
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M316.506 205.46s-3.523 4.5-3.015 5.275c.508.775 3.726-2.066 4.742-4.057 1.016-1.992-1.694-1.364-1.694-1.364",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M352.821 251.076a32.82 36.922 0 1 1-65.638 0 32.82 36.922 0 1 1 65.638 0z",
    fill: "#e8a30e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.699 251.074c0-17.152 12.068-30.316 26.298-30.316 14.231 0 26.3 13.164 26.3 30.316",
    style: {
      lineHeight: "normal",
      InkscapeFontSpecification: "Sans",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb",
      marker: "none"
    },
    fontWeight: 400,
    overflow: "visible",
    color: "#000",
    fontFamily: "Sans",
    fill: "none",
    stroke: "#390",
    strokeWidth: 0.82
  }), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M287.223 253.01c.895 19.491 15.227 34.986 32.775 34.986 17.549 0 31.878-15.495 32.773-34.986h-65.548z",
    fill: "#007934",
    stroke: "#eee",
    strokeWidth: 0.082
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M352.821 251.075a32.82 36.922 0 1 1-65.638 0 32.82 36.922 0 1 1 65.638 0z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.369
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.506 225.364c-.36 1.405.037 2.562.724 3.652.53.843.88 1.742.863 2.707a7.866 7.866 0 0 0-.694.44l-5.55-3.686 3.726 5.49a7.948 7.948 0 0 0-.195.283c-1.057-.476-2.05-.57-2.995-.388-1.336.259-2.471-.021-3.656-.727.74 1.248 1.843 1.785 3.1 2.07.973.222 1.853.61 2.525 1.306a7.94 7.94 0 0 0-.18.798l-6.533 1.325 6.519 1.247c.018.112.04.224.062.335-1.084.41-1.855 1.044-2.394 1.842-.763 1.128-1.758 1.733-3.095 2.071 1.406.36 2.56-.041 3.65-.728.844-.531 1.742-.88 2.707-.864.137.242.283.472.441.695l-3.684 5.555 5.492-3.733c.091.066.184.135.279.197-.477 1.057-.569 2.054-.386 2.999.258 1.337-.023 2.467-.73 3.651 1.248-.74 1.786-1.843 2.071-3.1.221-.973.609-1.853 1.306-2.524.263.073.527.133.798.179l1.324 6.533 1.247-6.518c.112-.018.224-.04.336-.063.41 1.085 1.044 1.856 1.842 2.395 1.127.762 1.732 1.757 2.07 3.094.36-1.405-.04-2.56-.728-3.65-.532-.845-.877-1.74-.858-2.709.24-.135.468-.282.69-.439l5.554 3.685-3.728-5.494c.066-.09.13-.184.192-.277 1.058.477 2.054.569 3 .386 1.336-.259 2.466.023 3.651.73-.74-1.249-1.841-1.782-3.098-2.067-.972-.22-1.851-.616-2.522-1.312.073-.262.129-.527.174-.796l6.536-1.32-6.52-1.252a7.861 7.861 0 0 0-.063-.336c1.085-.41 1.855-1.043 2.394-1.841.763-1.128 1.76-1.728 3.097-2.066-1.406-.36-2.563.036-3.653.723-.844.532-1.74.877-2.708.859a7.864 7.864 0 0 0-.44-.69l3.687-5.55-5.496 3.723a8.041 8.041 0 0 0-.277-.192c.477-1.057.57-2.049.388-2.994-.258-1.337.021-2.472.728-3.657-1.248.74-1.781 1.842-2.066 3.098-.222.975-.616 1.858-1.315 2.53a7.939 7.939 0 0 0-.794-.182l-1.32-6.535-1.251 6.52c-.112.018-.224.04-.336.063-.41-1.085-1.043-1.856-1.842-2.395-1.127-.762-1.727-1.759-2.066-3.096z",
    style: {
      marker: "none"
    },
    overflow: "visible",
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.123
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: 330,
    width: 330,
    transform: "rotate(22.502 -417.893 955.825) scale(.14262)",
    fill: "#fcbf49",
    strokeWidth: 1.112
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    height: 330,
    width: 330,
    transform: "matrix(-.14262 0 0 .14262 333.956 232.69)",
    fill: "#fcbf49",
    strokeWidth: 1.112
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M325.847 236.704c-1.64-1.426-3.708-1.64-4.849-.57-.828 1.107-.754 2.41.214 3.779a.54.54 0 0 0-.285.143c-.72-1.37-.843-2.78-.357-4.065 1.57-1.284 3.709-1.426 5.277.713",
    fill: "#000"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M323.28 236.276c-.927 0-1.14.214-1.569.57-.427.357-.641.286-.713.357-.07.071 0 .285.143.214.143-.071.428-.214.856-.57.428-.357.855-.357 1.283-.357 1.284 0 1.997 1.07 2.14.998.142-.07-.714-1.212-2.14-1.212",
    fill: "#000"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M324.92 237.488c-.927-.998-2.638-1.07-3.351.072h.285c.713-1.141 2.425-.642 2.567-.143v.143",
    fill: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.642,
    cy: 237.417,
    cx: 323.138,
    fill: "#000"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M321.569 237.56c.713.641 2.282.713 3.351-.072l-.499-.07c-.713.784-1.854.712-2.567.142v-.143",
    fill: "#000"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M324.992 237.845c-1.213.927-2.425.856-3.138.428-.713-.428-.713-.57-.57-.57.142 0 .285.142.855.427.57.285 1.426.285 2.853-.285m-3.494 2.14a.428.428 0 1 1-.571.427c-.071.143-.357.57-.927.57h-.143l.143.214c.143 0 .57 0 .856-.213a.642.642 0 1 0 .642-.999m.855 2.995c-.642-.428-.927-1.07-1.64-1.07-.143 0-.428.072-.713.214h-.143l.143.214c.285 0 .713-.356 1.212-.07.5.284.785.57 1.141.712m-.214 0c-1.426-.428-1.711-.142-2.139-.142h-.143l.143.285c.57 0 .856-.428 2.14-.143",
    fill: "#000"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M322.353 242.98c-1.569-.143-1.07.784-2.353.784h-.143l.143.214c1.569 0 .856-.856 2.353-.999M314.152 236.704c1.64-1.426 3.708-1.64 4.85-.57.827 1.107.753 2.41-.215 3.779a.54.54 0 0 1 .285.143c.72-1.37.843-2.78.357-4.065-1.569-1.284-3.708-1.426-5.277.713",
    fill: "#000"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M316.72 236.276c.926 0 1.14.214 1.568.57.428.357.642.286.713.357.071.071 0 .285-.142.214a4.102 4.102 0 0 1-.856-.57c-.428-.357-.856-.357-1.284-.357-1.283 0-1.996 1.07-2.139.998-.143-.07.713-1.212 2.14-1.212",
    fill: "#000"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M315.08 237.488c.926-.998 2.638-1.07 3.35.072h-.285c-.713-1.141-2.424-.642-2.567-.143v.143",
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1 1)",
    r: 0.642,
    cy: 237.417,
    cx: -316.862,
    fill: "#000"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M318.43 237.56c-.712.641-2.281.713-3.35-.072l.498-.07c.713.784 1.854.712 2.567.142v-.143",
    fill: "#000"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M315.008 237.845c1.212.927 2.424.856 3.137.428.714-.428.714-.57.57-.57-.142 0-.284.142-.855.427-.57.285-1.426.285-2.852-.285m3.494 2.14a.428.428 0 1 0 .57.427c.072.143.357.57.927.57h.143l-.143.214c-.142 0-.57 0-.855-.213a.642.642 0 1 1-.642-.999m-.856 2.995c.642-.428.927-1.07 1.64-1.07.143 0 .428.072.713.214h.143l-.143.214c-.285 0-.713-.356-1.212-.07-.499.284-.784.57-1.14.712m.213 0c1.426-.428 1.712-.142 2.14-.142h.142l-.143.285c-.57 0-.855-.428-2.139-.143",
    fill: "#000"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M317.646 242.98c1.57-.143 1.07.784 2.353.784h.143l-.143.214c-1.568 0-.855-.856-2.353-.999",
    fill: "#000"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M323.217 258.424c1.602.203 3.278.154 4.726-.298 1.325-.46 2.768-.769 4.196-.622.007-.2.429-.34.193-.498-.523-.323-1.183-.29-1.83-.618-1.058-.49-1.681-1.328-2.736-1.925-.116-.047-.582-.32-.573-.576 2.22 3.196 7.466 1.564 11.959 1.212.413.114 1.498-.2 2.4-.476 1.087-.368 3.702-.079 4.375-.518.11-.04-1.107-.795-1.34-1.01-.626-.782-2.245-.68-3.05-1.524-1.262-1.416-3.215-1.837-4.799-3.013-.351-.212-1.07-.145-1.6-.269-.652-.55-.015-.532-4.994-4.634-4.508-1.856-4.242-3.265-7.04-4.344-.993-.489-1.9-1.363-2.742-1.134-1.505.405-4.768 2.073-6.23 2.942-1.216.721-2.74 2.017-3.785 2.85-.274.218-3.448 2.909-7.043 4.884-3.595 1.974-8.799 4.68-9.246 4.715 8.113-.406-7.255 2.3 29.159 4.856z",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M303.308 249.078c2.055-1.116 9.917-5.42 12.357-8.448-.333.023.66.942.58 1.317.761-.028.37-.855 1.004-.886.486.016.843-.184 1.267-.335.49-.09.198.218.193.383-.665 1.222-2.082 1.929-3.233 2.863.133.11.266.22.193.384.408.06.894.076 1.185-.173.07-.05.075-.215.079-.321.413.173.257.492.113.705-.295.639-1.48.54-1.85 1.123-.43.627-.867 1.155-1.515 1.623.5-.413 1.074-.937 1.707-.969.977-.073 1.349-.709 2.193-.892.912-.182 1.492-.923 2.212-1.495-.288.42-.864.779-.667 1.275a.582.582 0 0 0 .572.114c-.652.844-1.949 1.454-2.401 2.465-.413-.173-.697.135-.98.179-.416.145-.3.797-.59 1.006-1.202.66-1.803 1.779-2.322 2.727-.072.104-.995.615-1.348.71-.633.25-4.597 3.313-4.651 2.881-.342-2.062-4.348 1.66-13.292-1.552m30.548-.085c-.065-.082-.2-.126-.2-.165.148-.316-.474-.378-.463-.703 1.041.035 1.84 1.227 2.495.523.142-.159-.26-.409.362-.59.138-.03-.131-.163-.06-.245-.342-.011-.625.019-.836-.063-.27-.088-.413-.172-.752-.267-.339-.09-.472-.456.02-.563.91-.133 1.863.502 2.575.165.564-.263 1.122-.323 1.684-.507.275-.07 1.187.005.896.267-.21.156-.695.096-.98.165-.491.142-.918.37-1.411.556.343-.028.261.37.683.265.63-.176 1.27-.397 1.964-.458-.063-.16.147-.277.152-.44l.205.007c-.326-.49.632-.256.996-.65-.003.08.057.082.132.124-.493.181-.29.51-.435.752-.07.077-.277.11-.213.235.267.207.279-.149.49-.063.203.046.482.135.62.1.341.011.697-.135.493-.429-.265-.246-.54-.458-.53-.779.001-.04-.065-.08-.2-.125.554.019.967.196 1.164.44.265.25.322.613.746.712.824.146.769-.257.782-.661.622.06 1.52.332 1.372.648-.068.235-.57.421-1.058.45-.342.023-.146.276-.352.31-.41-.015-.908.048-1.05.206-.144.238.045.724.312.895.404.212 1.25-.037 1.879.063.072-.359.502-.462.86-.698.418-.223-.19-.446-.534-.62-.27-.089-.063-.161.08-.359.213-.23.838-.011.913-.207.145-.237-.117-.607.162-.76.21-.152.483.134.4.334.273-.025.347-.186.63-.216.343-.028.547.256.4.335-.42.267-.776.453-.653.863-.007.202-.496.265-.288.435.4.295.39.577.525.903.125.364.89.47 1.587.335-.25-.692 1.337-.357 2.044-.536.06.002.064-.116.005-.158-.335-.208-.4-.29-.323-.574.001-.035-.124-.123-.2-.165 1.031.356 2.86.844 3.609 1.472-.98.165-2.81-.278-3.792-.069-1.19.282-2.39.642-3.653.6-.555-.02-1.102-.274-1.657-.293m-11.216-.696c.136.039-.34-.05-.407-.093",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M321.17 259.149c1.938-.11 2.242 1.395 3.512.08 1.161.213 2.237-.176 2.253-.343 2.705.567 11.109-.212 10.554-.806-.866-.99-2.275-1.363-3.385-2.213-.249-.157-.767-.24-1.148-.348-.637-.194-1.483-.047-2.025-.33-.872-.49-1.797-.914-2.57-1.53-.488-.348-.655-.904-1.189-1.327-.571-.422-1.396-.503-1.983-.763-.884-.354-1.371-1.209-2.193-1.829-.284-.226-.77-.207-1.099-.408-.705-.37-1.247-1.165-1.87-1.056-1.113.19-1.77 1.1-2.87 1.598-.915.412-1.337 1.177-2.131 1.671-.209.13-2.628 1.736-5.327 2.852-2.699 1.116-6.238 2.467-6.566 2.467 0 0 2.384 1.755 7.933 1.52l3.393 1.093 1.897-.334s4.724-.004 4.814.005z",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M309.758 254.841c1.246-.598 6.017-2.905 7.488-4.525-.203.012.408.503.36.703.464-.015.222-.457.608-.475.296.008.513-.098.77-.18.299-.048.122.117.12.205-.4.654-1.259 1.033-1.956 1.533.082.06.164.118.12.205.249.032.545.04.721-.093.043-.027.045-.115.047-.172.252.092.159.263.072.377-.176.342-.899.29-1.121.602-.26.335-.523.618-.916.869.303-.222.65-.502 1.036-.52.595-.04.818-.38 1.332-.478.554-.098.904-.495 1.34-.8-.173.224-.522.416-.4.681.042.03.204.18.377.124-.393.452-1.208.716-1.478 1.256-.253-.092-.424.073-.597.097-.252.077-.179.426-.354.538-.73.354-1.09.952-1.401 1.46-.044.055-.604.329-.819.38-.384.134-2.785 1.775-2.82 1.544-.218-1.102-2.55.524-8.018-1.186",
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.123
  })), /*#__PURE__*/React.createElement("path", {
    overflow: "visible",
    fontWeight: 400,
    style: {
      lineHeight: "normal",
      InkscapeFontSpecification: "Sans",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      blockProgression: "tb",
      marker: "none"
    },
    d: "M319.997 214.153c-18.125 0-32.819 16.53-32.819 36.921 0 20.392 14.694 36.922 32.82 36.922 18.125 0 32.819-16.53 32.819-36.922 0-20.39-14.694-36.921-32.82-36.921zm0 8.246c13.214 0 24.658 12.287 24.658 28.675 0 16.389-11.444 28.674-24.658 28.674-13.213 0-24.658-12.285-24.658-28.674 0-16.388 11.445-28.675 24.658-28.675z",
    color: "#000",
    fontFamily: "Sans",
    fill: "#00a6de",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M324.726 266.791c.004.201-.07.209-.448.26-.37.05-.441.051-.446-.14-.004-.201.078-.21.448-.26.35-.047.441-.072.446.14z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M324.806 266.78c.005.126-.237.157-.527.196-.291.039-.52.066-.526-.053-.006-.127.236-.158.527-.197.29-.039.52-.078.526.054zm-2.831 8.983c.795-2.128 1.004-3.736-.134-6.018 1.89-1.803 3.277-1.178 4.53.103-1.193 2.253-.88 3.859-.2 5.93-1.481.784-2.772.762-4.196-.015z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M324.064 268.624a2.32 2.32 0 0 0-.118.005c.132 2.587.02 5.155-.003 7.724.052.002.105.003.157.003-.009-2.586.14-5.09-.03-7.733h-.007z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M324.422 268.65c-.334 2.356-.458 4.736-.377 7.706l.138-.001c-.02-2.93.083-5.313.37-7.679l-.13-.026zm.641-2.463c-.335.37-.52.367-.352.94.371-.253.361-.462.352-.94z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M324.318 266.435c.22.23.54.35.336.974-.4-.346-.348-.38-.336-.974z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M324.25 267.071c.29.211.556.255.357.799-.254-.304-.365-.279-.357-.799z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M324.17 267.41c.22.227.541.346.338.956-.4-.34-.348-.373-.338-.956z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M324.042 267.905c.257.222.63.342.402.93-.445-.375-.226-.462-.402-.93z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M323.993 268.404c.24.216.62.342.405.911-.343-.314-.387-.364-.405-.911zm1.292-1.696c-.175.146-.578.131-.594.754.496-.286.491-.231.594-.754z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M325.258 267.15c-.186.135-.617.119-.63.702.529-.263.524-.211.63-.701z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M325.195 267.551c-.193.146-.639.129-.654.758.549-.284.542-.23.654-.758z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M325.162 268.102c-.203.075-.676-.074-.68.707.405-.108.377-.346.68-.707z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M324.937 268.577c-.283.119-.443.095-.495.723.41-.277.405-.225.495-.723zm.31.37c-.715 2.048-.865 3.986-.794 7.39l.173-.022c-.035-3.375.094-5.242.75-7.293a2.77 2.77 0 0 0-.13-.075zm1.165-2.256c-.408.289-.587.247-.544.84.418-.166.452-.372.544-.84z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M325.628 266.775c.167.272.456.456.124 1.02-.319-.422-.26-.445-.124-1.02z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M325.427 267.38c.24.266.491.365.18.853-.184-.351-.298-.349-.18-.853z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M325.277 267.693c.167.268.458.45.128 1.002-.32-.415-.262-.438-.128-1.002z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M325.045 268.146c.206.272.546.467.198.991-.357-.459-.123-.497-.198-.991z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M324.89 268.622c.193.26.538.465.206.973-.27-.38-.303-.437-.205-.973zm1.63-1.376c-.203.105-.595.005-.744.607.548-.171.531-.12.744-.607z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M326.4 267.671c-.212.092-.631-.017-.768.549.575-.143.559-.096.768-.549z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M326.253 268.047c-.22.101-.654-.01-.803.6.599-.161.581-.11.803-.6z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M326.103 268.576c-.215.03-.647-.215-.817.544.42-.02.444-.256.817-.544z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M325.78 268.991c-.301.055-.453-.002-.637.597.461-.18.445-.132.637-.597zm.137.43c-.929 1.862-1.126 3.567-.664 6.747.067-.02.136-.044.204-.069-.46-3.036-.279-4.737.574-6.577a3.263 3.263 0 0 0-.114-.1zm1.55-2.226c-.444.232-.618.167-.652.76.437-.111.5-.31.651-.76z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M326.676 267.174c.13.29.394.512-.01 1.025-.263-.458-.202-.473.01-1.025z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M326.397 267.747c.204.295.44.426.07.867-.138-.37-.252-.383-.07-.867z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M326.207 268.038c.133.287.397.506 0 1.007-.266-.452-.205-.467 0-1.007z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M325.92 268.456c.168.296.48.532.067 1.006-.296-.5-.057-.509-.067-1.006z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M325.704 268.906c.157.284.474.53.077.99-.217-.41-.243-.472-.077-.99zm1.796-1.148c-.214.076-.591-.073-.817.503.567-.099.544-.05.817-.503z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M327.327 268.162c-.222.063-.626-.098-.835.442.59-.066.569-.02.835-.442z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M327.132 268.515c-.232.07-.649-.096-.876.488.616-.081.592-.032.876-.488z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M326.915 269.018c-.218.002-.615-.297-.883.432.42.036.474-.196.883-.432z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M326.54 269.387c-.308.015-.45-.06-.71.508.481-.12.458-.072.71-.508zm-2.975-.699c-.042.01-.085.023-.128.035.306 2.357.503 4.736.465 7.628.039.002.078.004.117.004.102-2.95-.105-5.315-.454-7.667zm-.645-2.55c.333.385.518.39.346.957-.37-.27-.359-.48-.346-.956z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M323.663 266.42c-.221.221-.543.327-.343.96.402-.328.351-.366.343-.96z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M323.727 267.06c-.293.196-.559.23-.364.782.257-.294.366-.262.364-.783z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M323.804 267.402c-.222.218-.543.32-.346.94.404-.32.352-.357.346-.94z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M323.928 267.901c-.258.213-.632.315-.408.914.447-.355.228-.452.408-.914z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M323.974 268.404c-.243.204-.623.313-.412.893.345-.3.389-.348.412-.893zm-1.28-1.755c.174.153.577.158.59.781-.496-.308-.49-.254-.59-.78z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M322.717 267.093c.185.143.617.146.626.73-.528-.286-.522-.236-.626-.73z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M322.778 267.496c.191.155.637.158.649.789-.546-.31-.541-.256-.649-.79z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M322.807 268.048c.203.085.677-.043.675.738-.405-.126-.375-.363-.675-.738z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M323.029 268.534c.282.13.44.115.489.744-.408-.294-.403-.242-.49-.744zm-.251.483a3.799 3.799 0 0 0-.127.08c.662 2.032.905 3.912.847 7.212.05.008.102.015.153.021.093-3.337-.16-5.277-.873-7.313zm-1.211-2.435c.407.307.586.273.54.865-.417-.187-.451-.394-.54-.865z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M322.351 266.7c-.168.265-.46.436-.132 1.015.323-.407.265-.433.132-1.015z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M322.547 267.314c-.242.256-.494.344-.187.845.187-.342.301-.335.187-.845z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M322.696 267.634c-.17.261-.461.43-.137.996.324-.4.266-.425.137-.996z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M322.922 268.098c-.206.263-.548.442-.204.982.36-.443.127-.491.204-.982z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M323.073 268.58c-.192.253-.54.441-.211.964.272-.367.305-.422.211-.963zm-1.616-1.448c.201.113.594.032.738.64-.547-.196-.53-.145-.738-.64z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M321.573 267.562c.21.101.631.012.763.583-.574-.169-.559-.12-.763-.583z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M321.716 267.945c.22.11.655.02.799.636-.597-.188-.58-.136-.799-.636z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M321.862 268.48c.215.04.65-.186.813.58-.42-.038-.44-.275-.813-.58z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M322.181 268.91c.302.068.454.019.634.626-.46-.203-.444-.152-.634-.627zm-.063.585a4.112 4.112 0 0 0-.103.09c.84 1.886.977 3.503.703 6.51l.038.022.132.045c.312-3.05.159-4.7-.77-6.667zm-1.607-2.457c.44.251.615.194.644.79-.435-.132-.496-.334-.644-.79z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M321.301 267.053c-.133.285-.398.493.001 1.025.266-.446.205-.464-.001-1.025z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M321.575 267.637c-.207.286-.445.407-.076.865.141-.364.254-.371.076-.865z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M321.762 267.937c-.134.28-.4.487-.006 1.007.27-.44.21-.457.006-1.007z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M322.047 268.369c-.17.288-.485.51-.075 1.003.3-.487.061-.506.075-1.003z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M322.259 268.828c-.159.276-.478.509-.085.986.221-.4.247-.46.085-.986zm-1.788-1.23c.214.087.593-.045.813.54-.566-.124-.542-.074-.813-.54z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M320.642 268.01c.222.073.626-.07.831.481-.59-.093-.567-.047-.83-.48z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M320.835 268.372c.23.082.648-.066.871.528-.615-.109-.591-.059-.871-.528z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M321.048 268.886c.217.01.618-.27.879.471-.42.017-.473-.217-.88-.471z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M321.419 269.27c.308.03.45-.038.708.541-.481-.14-.46-.093-.708-.54zm2.179-3.171c.311.402.495.418.29.972-.352-.29-.33-.498-.29-.972z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M324.325 266.421c-.233.209-.561.295-.397.937.42-.304.371-.344.397-.937z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M324.353 267.062c-.303.181-.572.198-.407.76.272-.278.38-.24.407-.76z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M324.41 267.408c-.234.205-.56.29-.397.919.42-.297.371-.337.397-.919z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M324.507 267.914c-.271.197-.65.277-.46.887.468-.328.254-.438.46-.887z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M324.525 268.417c-.255.19-.641.279-.463.867.361-.28.41-.323.463-.867zm-1.182-1.821c.166.162.567.189.546.811-.478-.335-.475-.28-.546-.811z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M323.342 267.04c.177.153.608.18.585.762-.512-.316-.51-.264-.585-.762z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M323.38 267.444c.182.166.628.193.604.823-.528-.34-.527-.284-.604-.823z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M323.377 267.997c.199.096.68-.005.635.774-.398-.15-.355-.383-.635-.774z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M323.572 268.494c.275.147.435.14.447.77-.391-.317-.388-.265-.447-.77zm-.375.315a2.69 2.69 0 0 0-.14.06c.586 2.393.723 4.601.672 7.47a.822.822 0 0 1 .05.005l.067-.013c.085-2.56 0-5.061-.649-7.523zm-1-2.39c.387.332.57.31.485.897-.406-.213-.425-.421-.484-.897z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M322.973 266.587c-.185.253-.486.405-.196 1.003.348-.385.292-.415.196-1.003z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M323.131 267.212c-.258.24-.516.311-.242.83.21-.33.322-.314.242-.83z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M323.258 267.54c-.186.25-.488.4-.2.984.35-.378.293-.407.2-.983z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M323.456 268.018c-.225.248-.577.405-.268.965.39-.418.159-.483.268-.965z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M323.576 268.508c-.21.239-.569.404-.274.947.296-.349.332-.402.274-.947zm-1.524-1.548c.194.126.592.07.697.686-.533-.231-.52-.178-.697-.686z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M322.14 267.396c.205.114.63.052.727.63-.564-.205-.551-.155-.726-.63z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M322.261 267.786c.212.126.651.062.756.686-.585-.226-.57-.173-.756-.686z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M322.371 268.33c.213.053.662-.144.777.63-.418-.064-.424-.302-.777-.63z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M322.663 268.779c.297.087.452.048.593.664-.446-.23-.434-.18-.593-.664zm-.77.916a2.459 2.459 0 0 0-.052.05c.693 1.39.888 2.53.753 3.69v.001c-.025.76-.14 1.576-.334 2.473.05.024.099.045.147.067l.028.008c.546-2.567.494-4.464-.541-6.29z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M322.483 269.21c-.043.031-.088.063-.13.096.792 2.12.901 4.075.787 6.926l.105.028.046.01c.15-2.902.053-4.93-.808-7.06zm-1.434-2.403c.43.272.607.222.61.817-.43-.15-.48-.354-.61-.817z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M321.838 266.858c-.144.278-.42.475-.043 1.024.286-.434.225-.454.043-1.024z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M322.088 267.455c-.22.275-.463.385-.116.858.159-.357.271-.36.116-.858z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M322.261 267.76c-.147.275-.422.47-.05 1.006.288-.427.229-.447.05-1.005z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M322.527 268.205c-.183.279-.508.487-.119.997.32-.473.084-.502.12-.997z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M322.718 268.673c-.17.268-.499.486-.127.98.239-.39.267-.449.127-.98zm-1.732-1.307c.21.096.594-.02.789.576-.56-.15-.54-.1-.79-.576z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M321.139 267.785c.218.083.628-.043.81.516-.587-.12-.567-.072-.81-.516z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M321.315 268.154c.227.093.652-.037.849.566-.61-.136-.59-.085-.85-.566z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M321.505 268.677c.218.02.63-.242.859.509-.422-.002-.463-.238-.86-.509z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M321.86 269.078c.306.043.452-.02.684.57-.475-.162-.455-.114-.684-.57zm-1.902-1.64c.47.192.634.113.74.7-.448-.073-.533-.266-.74-.7z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M320.742 267.35c-.095.3-.33.542.133 1.02.207-.479.143-.49-.133-1.02z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M321.09 267.896c-.17.31-.388.462.035.87.092-.382.204-.403-.036-.87z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M321.312 268.17c-.096.296-.332.536.125 1.001.209-.472.146-.482-.125-1.001z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M321.65 268.561c-.131.31-.414.571.055 1.007.233-.523-.004-.51-.054-1.007z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M321.92 268.991c-.122.295-.407.567.042.99.167-.426.185-.488-.043-.99zm-1.928-.992c.223.059.58-.121.874.433-.576-.05-.545-.004-.874-.433z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M320.215 268.387c.228.045.61-.15.883.37-.595-.016-.567.028-.883-.37z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M320.451 268.722c.24.052.635-.15.931.412-.623-.029-.593.018-.931-.412z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M320.728 269.205c.217-.017.577-.347.931.355-.414.07-.495-.155-.93-.355z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M321.145 269.54c.308-.01.441-.098.77.446-.494-.078-.466-.034-.77-.446zm3.786-.745c-.673 2.45-.768 4.984-.703 7.558a2.47 2.47 0 0 0 .156-.01c-.028-2.897.086-5.1.688-7.486a2.763 2.763 0 0 0-.14-.062zm1-2.292c-.389.315-.57.284-.49.876.406-.195.428-.403.49-.876z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M325.154 266.636c.184.262.484.427.19 1.012-.347-.4-.29-.428-.19-1.012z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M324.992 267.254c.257.251.515.334.236.84-.208-.337-.32-.328-.236-.84z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M324.863 267.577c.184.257.485.421.193.992-.347-.394-.29-.42-.193-.992z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M324.662 268.044c.221.26.573.432.26.978-.386-.435-.155-.489-.26-.978z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M324.539 268.53c.206.249.565.43.266.959-.293-.362-.33-.417-.266-.96zm1.534-1.48c-.195.118-.592.044-.702.655.536-.207.522-.155.702-.654z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M325.98 267.483c-.204.105-.63.024-.73.597.566-.18.552-.13.73-.597z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M325.859 267.869c-.213.114-.653.03-.763.65.587-.2.573-.147.763-.65z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M325.743 268.406c-.212.044-.66-.174-.78.596.418-.047.426-.284.78-.596z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M325.448 268.841c-.297.075-.452.028-.598.638.449-.21.436-.16.598-.638zm.189.358c-.928 2.1-1.053 4.132-.836 7.085.07-.014.14-.03.209-.047-.24-2.988-.12-4.9.741-6.952a4.056 4.056 0 0 0-.114-.086zm1.44-2.255c-.433.252-.608.194-.617.789.432-.13.484-.333.617-.789z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M326.287 266.958c.143.286.417.495.037 1.027-.283-.447-.223-.466-.037-1.027z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M326.035 267.544c.216.286.458.406.107.864-.154-.365-.268-.372-.107-.864z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M325.857 267.843c.145.28.418.487.044 1.007-.285-.441-.225-.457-.044-1.007z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M325.589 268.273c.181.289.504.512.111 1.003-.316-.487-.08-.505-.111-1.003z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M325.394 268.734c.168.276.495.508.12.985-.235-.4-.263-.46-.12-.985zm1.742-1.229c-.21.086-.593-.046-.793.54.56-.124.54-.075.793-.54z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M326.98 267.918c-.218.072-.627-.072-.813.479.587-.093.566-.047.813-.48z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M326.801 268.278c-.228.082-.65-.065-.852.527.611-.107.589-.058.852-.527z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M326.607 268.792c-.218.011-.628-.27-.862.47.422.017.465-.216.862-.47z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M326.25 269.177c-.306.03-.453-.04-.688.54.475-.141.455-.094.688-.54zm.015.564c-1.084 1.903-.992 3.927-.544 6.253.055-.023.11-.048.167-.074-.191-1.005-.314-1.928-.31-2.802v-.005c-.056-1.016.148-2.045.794-3.265l-.107-.107zm1.898-2.118c-.471.172-.635.085-.745.668.449-.054.536-.244.745-.668z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M327.38 267.5c.093.305.326.557-.142 1.014-.201-.488-.14-.495.142-1.013z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M327.03 268.03c.164.318.383.48-.044.868-.09-.385-.2-.412.043-.867z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M326.802 268.294c.095.3.33.55-.13.996-.207-.481-.143-.489.13-.996z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M326.463 268.67c.13.314.41.59-.063 1.004-.228-.533.009-.51.063-1.004z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M326.19 269.088c.12.3.403.586-.05.988-.165-.433-.181-.497.05-.988zm1.935-.904c-.223.047-.579-.148-.878.392.576-.024.547.02.878-.392z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M327.9 268.561c-.229.034-.609-.178-.887.33.596.011.567.053.886-.33z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M327.66 268.886c-.24.04-.632-.18-.934.37.624-.002.593.044.934-.37z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M327.38 269.355c-.217-.027-.574-.373-.934.313.413.09.497-.132.934-.313z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M326.96 269.671c-.308-.024-.44-.118-.773.411.495-.056.467-.013.773-.41zm-3.488 2.737l1.139.026c.69.015 1.243.172 1.241.353 0 .18-.554.313-1.244.297l-1.138-.026c-.69-.015-1.243-.172-1.242-.353.001-.18.555-.313 1.244-.297z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M322.683 272.39l-.34.573c.052.045.12.073.194.075l.206.004.382-.642-.442-.01zm.887.02l-.382.642.441.01.383-.643-.442-.009zm.888.02l-.383.642.441.01.383-.642-.441-.01zm.886.02l-.382.642.442.01.336-.564a.316.316 0 0 0-.206-.084l-.19-.004z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.041
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M316.534 268.808c.009-.002.261 1.784.463 2.652.024.107.15.165.186.268.038.112.011.234.02.351 0 .013.003.026.002.04-.008.16-.129.311-.089.47.023.091.132.135.173.22.237.492.245 1.087.376 1.59.056.213-.04-.04.365.557.041.06.197.063.197.063l.156.006.158.156-.202.22-.67.086-.32-.198s.08-.177.017-.263c-.046-.06-.188-.015-.201-.09-.024-.14-.07-.516-.074-.517-.012 0-.008-.024-.016-.034 0 0-.542-.59-.742-.939-.103-.18-.116-.406-.228-.58-.072-.112-.215-.164-.275-.283-.496-.99-1.068-2.908-1.069-2.897m-6.383-1.118l1.784.419-.482 2.61c-.307.828-.277.858-.177 1.09.207.445.365 1.116 1.089 2.17.252.266.52.291.619.4.047.115.26.286.44.354l.56-.015c.093-.135.094-.091.118-.193-.041-.121-.307-.072-.496-.235-.1-.316-.517-.794-.577-1.127-.23-.726-.167-.749-.117-1.492.024-.383.329-1.234.44-1.696.262-.497.52-1.357.476-1.973l-.771-1.7-.45-.69m-1.684-1.087c-2.846.918-1.633 3.54-.825 3.568m9.196-8.111l.42-.954.027-.348-.04-.073-.755.92-.01.06",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M319.18 262.395c.182.068.413.135.453.027.05-.134.073-.229-.067-.332-.068-.06.035-.152-.044-.322-.5-.35-.843-.358-.966-.637l-.02-.193c-.025-.244-.742-.345-.917-.464 0 0-.303-.15-.463-.185-.068-.015-.208-.01-.208-.01-.73-.006-1.063.76-1.185 1.227 0 0-.143 2.125-.497 3.087a.71.71 0 0 1-.146.233c-.06.065-.124.16-.211.155-2.02-.14-3.395-.23-4.215-.2-.82.03-1.757.666-1.814.736 0 0-.913.598-1.113 1.575-.067.326.013.71.141 1.094.908 2.579 1.803-.01 2.129.02l.4.038c.47.045 1.335 1.489 2.655 1.778 3.985.871 5.078-1.213 4.993-5.845l.048-.067-.013-.158.203-.368-.038-.513-.072-.243.007-.095 1.123-.145.193-.09",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M317.246 261.081l.481-1.091.032-.399-.047-.083-.864 1.053-.01.069m-8.93 7.556c.255.765.715 1.525.682 1.807-.049.422-.286.617-.303.657-.017.036-.105.09-.133.117-.123.114-.204.345-.26.51a1.318 1.318 0 0 0-.083.586c.084.74.51 2.263.531 2.285 0 0 .242.143.31.283.071.143.048.281.039.438-.012.215-.133.694-.133.694s.009.093.036.12c.076.077.334.21.334.21l.54-.014s-.302-.304-.324-.372a.358.358 0 0 1-.017-.22c.038-.16.19-.348.24-.443.054-.102-.005-.369-.005-.369-.005-.097-.084-.142-.09-.183a8.258 8.258 0 0 1-.078-.87c-.012-.282.035-1.124.035-1.124s.128-.109.18-.176c.045-.062.11-.206.11-.206s.653-.376.933-.628c.332-.3.87-1.035.87-1.035s.155-.299.178-.467a.513.513 0 0 0-.014-.175 3.813 3.813 0 0 0-.332-.903 3.205 3.205 0 0 0-.52-.771c-.021-.023-.075-.055-.075-.055m5.94 1.862c-.535.355-1.801.646-1.821.902 0 0-.038 1.605-.22 2.245-.073.252-.192.326-.286.57-.097.252-.09.446-.175.698-.09.27-.252.51-.276.978l.014.388.388.23-.403.137-.63-.251-.052-.591.139-.613.007-.099-.156-.37-.101-1.333.107-.995-.14-3.658m4.677-5.345c.253.203.587.335 1.348.088.146.093.3.21.625-.239m-.343-.525c.005-.006.147.098.2.098.04 0 .091-.084.058-.112-.037-.03-.105-.064-.137-.041-.047.032-.12.064-.121.055z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M317.778 261.415s.072.002.099.062c.09.203.31.238.483.024a.333.333 0 0 1 .083-.065c-.036-.003-.059 0-.087-.028-.194-.193-.394-.03-.46-.016-.044.009-.075.017-.118.023z",
    fill: "#000"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M329.132 272.906l.001.005a1.913 1.913 0 0 0-.014.744c-.054.27-.058.532-.014.75a1.945 1.945 0 0 0-.012.715 2.006 2.006 0 0 0-.01.677c.246.188.945.21 1.258.04a2.209 2.209 0 0 0-.002-.71c.046-.237.04-.475-.003-.715.047-.218.046-.479-.004-.75.043-.205.05-.446-.005-.744a2.255 2.255 0 0 0-.005-.775c.041-.233.043-.48-.006-.747a2.226 2.226 0 0 0-.006-.775v-.007c.037-.23.038-.489-.005-.782a2.382 2.382 0 0 0-.006-.791c.038-.241.04-.497-.006-.783.045-.229.044-.482-.006-.782.064-.243.039-.549-.008-.79v-.003c.04-.283.037-.54-.004-.78a2.32 2.32 0 0 0-.006-.782 3.247 3.247 0 0 0-.006-.791 2.89 2.89 0 0 0-.009-.781c.03-.237.032-.493-.009-.781a2.569 2.569 0 0 0 0-.794 2.678 2.678 0 0 0-.009-.783c.036-.242.038-.5-.01-.78.043-.282.034-.534-.009-.767.034-.26.032-.45.001-.709a1.98 1.98 0 0 0-.008-.307l-.789-.012c-.033.055-.043.164-.021.311-.04.113-.038.6.008.713a2.305 2.305 0 0 0-.019.766c-.05.28-.051.538-.02.781a2.677 2.677 0 0 0-.018.783 2.57 2.57 0 0 0-.01.793 2.914 2.914 0 0 0-.02.781c-.04.27-.048.523-.018.78-.037.27-.044.533-.016.792-.05.26-.053.521-.016.782a2.47 2.47 0 0 0-.013.78c-.05.24-.08.547-.018.793-.054.3-.058.552-.016.782-.05.284-.05.54-.016.782a2.381 2.381 0 0 0-.016.79 2.631 2.631 0 0 0-.015.79 2.216 2.216 0 0 0-.016.774 2.09 2.09 0 0 0-.015.747 2.25 2.25 0 0 0-.017.77z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M329.124 273.647c.29.135 1.033.112 1.208.022m-1.215-.769c.278.118.941.112 1.21.023m-1.173-.805c.27.135.907.1 1.168.023m-1.152-.765c.297.135.945.098 1.146.02m-1.132-.785c.32.091.88.087 1.126.003m-1.11-.786c.329.079.842.082 1.105.004m-1.09-.797c.3.077.88.082 1.084.005m-1.07-.782c.262.083.811.076 1.064 0m-1.041-.785c.333.08.794.088 1.036.003m-1.02-.797c.338.08.819.07 1.013.006m-1.002-.786c.335.075.86.048.997.004m-.978-.766c.312.057.839.027.972-.016m-.956-.794c.307.083.818.045.95.002m-.93-.765c.293.075.754.044.925-.017m-.9-.78c.287.063.768.04.894-.002m-.883-.785c.287.06.753.034.877-.007m-.85-.773c.313.038.71.034.83-.004m-.811-.795c.26.055.69.05.805.013m-.788-.779c.282.045.673.042.784.006m-.815-.715c.212.022.732.037.819.008m-1.11 15.454c.294.134 1.048.11 1.225.021m-1.24.69c.299.135 1.063.111 1.243.022",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinejoin: "round"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M331.51 257.073c.477-.105 1.163-.12 2.11-.144a13.677 13.677 0 0 0-.86-.256c.553-.077 1.87-.06 2.209-.063a4.93 4.93 0 0 0-.948-.394c.725-.12 1.59-.005 2.2.092-.284-.16-.606-.365-1.014-.476.87-.06 1.216.01 2.023.119a2.617 2.617 0 0 0-.882-.484c.967-.177 1.51-.215 2.457-.138-2.738-1.253-6.06-.602-8.06.777.2-.315.633-.792 1.055-1.152a2.525 2.525 0 0 0-.693.039c.293-.322.844-.75 1.218-.899-.273-.014-.503-.02-.748.028.367-.34.92-.7 1.39-.94a3.107 3.107 0 0 0-.84.02c.37-.437 1.019-.884 1.592-1.156a3.977 3.977 0 0 0-.936.072c.476-.434 1.113-.89 1.951-1.313-3.32.372-5.154 2.766-5.31 4.794-.885-1.908-3.296-3.733-6.614-3.594.99.302 1.778.67 2.39 1.042a4.362 4.362 0 0 0-1.006.076c.674.19 1.47.546 1.972.937a3.381 3.381 0 0 0-.892.116c.556.172 1.231.455 1.704.748-.27-.01-.512.032-.796.09.431.094 1.121.448 1.512.733-.305-.007-.52.02-.74.072.998.39 1.062.565 1.282.697-2.071-.443-5.065.241-7.367 2.916.334-.282 1.76-.813 2.212-.935-.236.283-.317.431-.504.785.517-.418 1.299-.763 2.044-1.06a4.805 4.805 0 0 0-.405.745c.542-.337.708-.385 1.819-.913-.08.135-.302.43-.407.71.34-.193 1.146-.488 1.693-.685.038-.013-.33.3-.495.677.125-.047.884-.322.912-.33-1.751 1.223-3.057 3.275-2.792 5.771.1-.39.563-1.51.826-1.959-.03.298.038.79.093 1.01.258-.744.541-1.339.964-1.984-.035.398-.025.838.03 1.018.235-.551.422-1.024 1-2.045-.037.152-.045.583-.01.963.192-.42.637-1.248 1.072-1.86-.022.225-.062.606-.045.765.046-.08.183-.306.342-.559.25-.393.553-.85.652-.924.076.077.148.171.216.28.272.437.467 1.105.528 1.797.145-.34.208-.686.227-.869.31.695.66 1.783.686 2.382.104-.318.158-.516.196-1.014.324.52.605 1.8.632 2.355.126-.217.23-.489.306-.895.317.716.442 1.607.519 2.221.813-2.96-.354-4.873-1.778-6.333.358.194.811.592 1.254 1.072a4.875 4.875 0 0 0-.264-.874c.526.374 1.301 1.145 1.517 1.367-.037-.293-.079-.447-.233-.82.62.43 1.175 1.166 1.489 1.572a5.426 5.426 0 0 0-.205-.942c.567.423 1.13 1.273 1.387 1.753-.007-.328-.098-.675-.175-1.032.77.652 1.056 1.342 1.3 1.758.005-2.672-3.088-5.077-5.962-5.327z",
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#e7e7e7",
    strokeWidth: 0.123
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M330.319 257.1c3.134-.448 7.16 2.251 7.153 5.3-.244-.416-.53-1.106-1.3-1.758.077.357.169.704.175 1.032-.257-.48-.82-1.33-1.387-1.753.13.403.18.755.205.942-.315-.406-.869-1.143-1.49-1.573.155.374.197.528.234.821-.216-.222-.991-.993-1.517-1.367.1.225.223.65.264.874-.443-.48-.896-.878-1.254-1.072m-1.785-1.483c-1.876-1.21-5.858-.99-8.748 2.369.334-.282 1.76-.813 2.212-.935-.236.283-.318.431-.504.785.517-.418 1.299-.763 2.044-1.06a4.782 4.782 0 0 0-.405.744c.542-.336.708-.384 1.819-.912-.08.135-.302.43-.407.71.339-.193 1.146-.488 1.693-.685.037-.013-.33.3-.495.677.125-.047.884-.322.912-.33",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M329.743 256.586c-.399-2.206-3.041-4.744-6.933-4.581.99.302 1.778.67 2.39 1.042a4.348 4.348 0 0 0-1.006.076c.673.19 1.47.546 1.972.937a3.383 3.383 0 0 0-.893.116c.557.172 1.232.455 1.705.748-.27-.011-.512.032-.796.09.431.094 1.12.448 1.511.733-.304-.007-.52.02-.74.072.998.39 1.063.565 1.283.698m1.48.94c-2.608.795-5.128 3.361-4.77 6.74.1-.39.563-1.51.826-1.958-.03.297.038.79.093 1.01.258-.745.541-1.34.964-1.986-.035.399-.025.839.03 1.02.235-.552.421-1.025 1-2.046-.037.152-.045.582-.01.963a13.31 13.31 0 0 1 1.072-1.86c-.022.225-.062.606-.046.765.119-.206.832-1.362.995-1.483m-1.623.163a8.729 8.729 0 0 0-.388 1.452m-.565-.8a9.718 9.718 0 0 0-.466 1.826m-.492-.913a8.912 8.912 0 0 0-.564 1.889",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str2",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.123,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M329.869 258.622l.01-.602"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M332.57 261.25c.08.475.119.726.09 1.408m-1.082-3.054c.103.531.146.883.145 1.594m-1.068-2.66c.115.327.184.749.185 1.293m4.748-.396c.348.447.517.949.584 1.207m-1.994-2.186c.34.4.673 1.114.782 1.464m-1.966-1.86c.293.381.493.786.681 1.23m-10.594-.793a4.665 4.665 0 0 1 1.73-1.195m-.19.92c.388-.491.587-.8 1.604-1.243m-.19 1.075c.32-.41.834-.874 1.614-1.151m-.328 1.176c.508-.464.977-.71 1.6-.975m-3.72-4.057c.67.074 1.597.307 2.163.68m-1.198.333c.61.011 1.445.193 1.873.427m-1.06.437c.603.011 1.36.26 1.98.615m-1.266.208c.81.071 1.364.365 1.725.586m.841.144c1.91-1.624 5.572-2.51 8.546-1.148-.948-.077-1.49-.04-2.457.138.396.113.771.385.882.484-.808-.109-1.153-.179-2.023-.12.408.112.73.318 1.014.477-.61-.098-1.475-.212-2.2-.092.15.03.719.254.947.394-.338.003-1.655-.014-2.209.063.38.1.633.18.862.256-.948.025-1.634.039-2.111.144m4.838-1.606c-.589-.239-1.617-.346-2.145-.313m1.004.678c-1.04-.345-2.03-.327-2.527-.251m1.34.635c-.915-.258-1.988-.265-2.485-.19m1.224.647c-.88-.212-1.512-.183-2.009-.108m.836 1.07c.36.306.618.665.806 1.11",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M329.424 255.599c.156-2.028 1.99-4.422 5.31-4.794-.838.423-1.475.879-1.951 1.313.333-.065.562-.078.936-.072-.573.272-1.221.719-1.592 1.155.277-.05.561-.045.84-.019-.47.24-1.023.6-1.39.94.245-.048.475-.042.748-.028-.374.148-.925.577-1.218.899.276-.05.48-.056.693-.039-.422.36-.854.837-1.055 1.151m2.037-3.987c-.485.134-1.1.39-1.546.711m.89.372a4.523 4.523 0 0 0-1.399.515m.85.406c-.476.084-1.017.351-1.47.694m1 .177a3.215 3.215 0 0 0-1.445.792m-.452 2.395a6.022 6.022 0 0 0-.29 1.16m1.17-2.01c1.849 1.615 4.149 3.695 3.09 7.549-.077-.615-.203-1.505-.52-2.22-.075.405-.18.677-.306.894-.026-.555-.308-1.835-.631-2.355a3.529 3.529 0 0 1-.196 1.014c-.026-.6-.376-1.687-.687-2.382-.018.183-.08.53-.226.87-.076-.864-.36-1.69-.745-2.078",
    fill: "none",
    stroke: "#e7e7e7",
    strokeWidth: 0.123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.296 233.51l1.26.684.306-.564c.157-.288.204-.515.142-.68-.062-.167-.23-.325-.504-.474-.303-.164-.545-.226-.725-.184-.184.04-.334.169-.45.385-.152.279-.226.471-.223.577.005.103.07.188.194.255m1.644.893l1.62.88c.124.067.235.072.333.016.099-.059.215-.212.349-.458.127-.235.211-.432.253-.592.04-.164.034-.299-.017-.406a.714.714 0 0 0-.182-.253 1.884 1.884 0 0 0-.333-.218c-.756-.41-1.309-.29-1.66.362l-.363.669m-2.598-.772c.092-.17.208-.392.349-.668.14-.276.229-.447.264-.513a3.25 3.25 0 0 1 .553-.766c.196-.198.385-.325.567-.381.18-.057.345-.082.495-.073.15.009.293.05.427.122.187.102.33.275.428.52.1.242.143.49.13.745.288-.29.596-.486.925-.588.328-.1.653-.064.975.11.356.194.582.528.678 1.002.092.473-.04 1.039-.398 1.699-.123.225-.255.46-.397.705-.14.243-.256.446-.345.61l-.311.625-.025-.004c-.358-.27-.823-.561-1.396-.872l-1.764-.958c-.554-.3-1.051-.532-1.491-.695l-.014-.026c.144-.232.26-.43.35-.594m8.881-10.827c-.717.599-.593 1.478.374 2.636.488.585.974.93 1.46 1.036.483.105.922-.008 1.316-.336.356-.298.507-.657.452-1.077-.055-.42-.318-.912-.788-1.476-.543-.65-1.036-1.035-1.48-1.155-.444-.123-.889 0-1.334.372m3.729-.184c.528.633.758 1.315.689 2.044-.07.726-.438 1.368-1.107 1.926-.625.522-1.303.767-2.032.735-.729-.031-1.339-.341-1.83-.93-.522-.625-.754-1.317-.695-2.076.06-.76.406-1.403 1.04-1.932.668-.558 1.36-.814 2.077-.768.716.042 1.336.375 1.858 1m8.003-2.606c.15.538.265.872.346 1.002.316-.088.658-.199 1.026-.332.37-.133.66-.246.87-.338l.317-.133.024.026c.013.088.05.24.11.456.021.075.057.184.108.328l-.009.027c-.13.02-.29.056-.48.11l-2.405.669-.646.205-.018-.02c-.048-.372-.168-.907-.36-1.605l-.538-1.934a11.935 11.935 0 0 0-.53-1.557l.013-.029c.241-.05.45-.1.628-.15l.65-.206.014.021c.045.362.166.897.363 1.604l.517 1.857m9.246-2.864a12.19 12.19 0 0 0 .082-1.643l.019-.022c.258.044.48.076.666.097l.68.05.005.024c-.114.423-.206.964-.278 1.623l-.217 1.995a11.875 11.875 0 0 0-.078 1.644l-.019.022c-.258-.045-.48-.077-.666-.097l-.68-.05-.005-.025c.114-.433.205-.974.273-1.622l.218-1.996m9.85 5.236c1.65-1.309 2.7-2.202 3.148-2.68.051.046.187.128.409.247.174.093.293.148.357.164-2.294 1.737-3.851 2.933-4.673 3.589l-.498-.267a316.2 316.2 0 0 1 .21-2.06c.097-.92.176-1.703.24-2.35.064-.651.1-1.113.111-1.387.075.059.315.196.72.414.284.153.47.244.558.272-.24 1.114-.435 2.467-.582 4.058m8.466 3.845c.466-.425.849-.817 1.15-1.178l.028-.004c.164.205.31.376.435.514l.477.488-.013.022c-.364.242-.792.586-1.281 1.032l-1.484 1.351c-.46.42-.843.813-1.147 1.18l-.029.004c-.164-.204-.31-.375-.435-.514l-.477-.487.013-.022c.372-.25.799-.594 1.279-1.035l1.484-1.351m4.985 10.005c.518-.532.96-1.004 1.325-1.416l-.022-.047-1.946.061c.088.216.204.477.347.784.072.155.17.361.296.618m-1.146-1.38c-.852.043-1.494.103-1.926.18a1.858 1.858 0 0 0-.134-.344 2.615 2.615 0 0 0-.216-.408c2.773-.017 4.739-.042 5.899-.075l.31.669c-2.01 2.11-3.32 3.547-3.928 4.31-.025-.091-.123-.321-.294-.69a5.364 5.364 0 0 0-.303-.592c.374-.318.84-.759 1.4-1.323a34.96 34.96 0 0 0-.334-.746c-.13-.28-.288-.608-.474-.981",
    style: {
      lineHeight: "125%",
      InkscapeFontSpecification: "'Linux Biolinum Bold'",
      textAlign: "center"
    },
    fontSize: 100,
    fontWeight: 700,
    letterSpacing: 60,
    fontFamily: "Linux Biolinum",
    wordSpacing: 0,
    textAnchor: "middle",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123
  }), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M324.923 280.609l-.768 2.208-2.337.048 1.863 1.412-.677 2.238 1.92-1.335 1.918 1.335-.677-2.238 1.863-1.412-2.337-.048zM334.06 276.717l-.769 2.208-2.337.048 1.863 1.412-.677 2.238 1.92-1.335 1.918 1.335-.677-2.238 1.863-1.412-2.337-.048zM348.17 251.757l-.768 2.208-2.337.048 1.863 1.412-.677 2.238 1.919-1.335 1.919 1.335-.677-2.238 1.863-1.412-2.338-.048zM341.47 269.564l.768 2.208 2.338.048-1.863 1.412.677 2.238-1.92-1.335-1.919 1.335.677-2.238-1.863-1.412 2.338-.048zM346.204 261.422l.768 2.209 2.337.047-1.863 1.413.677 2.238-1.919-1.336-1.92 1.336.678-2.238-1.863-1.413 2.337-.047zM315.077 280.609l.768 2.208 2.337.048-1.863 1.412.677 2.238-1.92-1.335-1.918 1.335.677-2.238-1.863-1.412 2.337-.048zM305.94 276.717l.769 2.208 2.337.048-1.863 1.412.677 2.238-1.92-1.335-1.918 1.335.677-2.238-1.863-1.412 2.337-.048zM291.83 251.757l.768 2.208 2.338.048-1.863 1.412.677 2.238-1.92-1.335-1.918 1.335.677-2.238-1.863-1.412 2.337-.048zM298.53 269.564l-.768 2.208-2.338.048 1.863 1.412-.677 2.238 1.92-1.335 1.919 1.335-.677-2.238 1.863-1.412-2.338-.048zM293.796 261.422l-.768 2.209-2.337.047 1.863 1.413-.677 2.238 1.919-1.336 1.92 1.336-.678-2.238 1.863-1.413-2.337-.047z",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.123,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M321.077 248.093l-.003-.483h.067l-.827-.476h-.665l-.823.476h.066l.003.482h2.182",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M321.077 248.093l-.003-.483h.067l-.827-.476-.062-.725h-.54l-.063.725-.823.475h.066l.003.483h2.182zm.255.633v.15l-2.664-.002-.001-.15 2.665.002",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M321.332 248.726v.15l-2.664-.002-.001-.15 2.665.002zm-2.487-.01l-.002-.51h.108l-.006.517.007-.513-.156-.004v-.11l2.381.003.001.108h-.147l.003.517-.005-.517h.11l.002.511",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M318.845 248.717l-.002-.51.108-.001-.006.517.007-.513-.156-.004v-.11l2.381.003.001.108h-.147l.003.517-.005-.517h.11l.002.511",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M319.357 248.591l-.002-.356h-.32l.002.356h.32",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M319.122 248.31l.001.206h.147l-.001-.207h-.147m1.797.283l-.002-.356h-.318v.356h.32",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M320.685 248.31l.002.207h.146v-.206h-.147m.232-.299l-.002-.356h-.32l.002.356h.32z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M320.683 247.731v.207h.147v-.207h-.147m-1.329.28l-.002-.355h-.32l.002.355h.32z",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M319.12 247.73v.206h.147l-.001-.206h-.146m.813.282l-.001-.356h-.32l.001.356h.32",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M319.698 247.73l.001.206.146.001v-.207h-.147m.68.282l-.002-.356h-.319l.001.356h.32",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M320.144 247.73l.001.207h.146v-.206h-.147",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M320.458 247.903l.004.82h-.926l-.003-.82h.925",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M320.458 247.903l.004.82h-.926l-.003-.82h.925zm-.93.234l.93.001m-.815.586l-.003-.58m.709.58l-.003-.58m.45-.59l-.521-.34h-.586l-.517.338 1.624.001m-1.06-.413h.492m-.36-.156v.103h.227l-.001-.103h-.226",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M319.576 247.926h.067l-.02.032s.033.038.001.08l.018.03h-.065l.017-.028s-.033-.05.001-.082l-.02-.032m.138 0h.067l-.02.032s.033.037 0 .08l.018.03h-.065l.018-.028s-.033-.05.002-.082l-.02-.032m.15 0h.067l-.02.032s.033.038 0 .08l.018.03h-.064l.017-.028s-.033-.05.001-.081l-.02-.033zm.169 0h.068l-.02.033s.032.037 0 .08l.018.03h-.065l.017-.029s-.032-.05.002-.08l-.02-.034zm.15 0h.067l-.02.033s.033.037 0 .08l.019.03h-.065l.017-.028s-.033-.05.003-.082l-.02-.032m.149 0h.067l-.02.032s.033.037.001.08l.017.03h-.065l.018-.028s-.033-.05.002-.082l-.02-.032",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.043
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M319.842 246.03h.321v.375h-.32v-.375z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.032
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M320.006 245.572l-.006.478",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.074
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M319.828 245.75l.35.005",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.093
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M317.14 210.305s-2.341 5.437-1.532 5.976c0 0 2.937-3.28 3.703-5.886.766-2.606 0-.18 0-.18l-.213-2.83-1.915 2.695",
    fill: "#452c25"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M317.14 210.305s-2.341 5.437-1.532 5.976c0 0 2.936-3.28 3.703-5.886.766-2.606 0-.18 0-.18l-.213-2.83-1.915 2.695",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.164
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M317.635 207.706s-2.813 5.988-2.17 6.43c0 0 2.337-2.692 2.947-4.83.61-2.14 0-.148 0-.148l.781-3.849",
    fill: "#452c25"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M317.635 207.706s-2.813 5.988-2.17 6.43c0 0 2.337-2.692 2.947-4.83.61-2.14 0-.148 0-.148l.781-3.849",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M320.533 206.372s-2.813 5.988-2.17 6.431c0 0 2.337-2.692 2.947-4.832.61-2.139 0-.147 0-.147l.781-3.85",
    fill: "#452c25"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M320.533 206.372s-2.813 5.988-2.17 6.431c0 0 2.337-2.692 2.947-4.832.61-2.139 0-.147 0-.147l.781-3.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M356.838 195.606l3.34 1.895s.814.676-.974.278c-1.789-.398-5.603-1.714-12.808-6.351-3.258-2.097-4.286-2.038-4.286-2.038l4.541.124 10.187 6.092z",
    fill: "#452c25"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M356.838 195.606l3.34 1.895s.814.676-.974.278c-1.789-.398-5.603-1.714-12.808-6.351-3.258-2.097-4.286-2.038-4.286-2.038l4.541.124 10.187 6.092z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M357.942 194.782l3.34 1.895s.814.676-.975.278c-1.788-.398-5.602-1.714-12.807-6.351-3.258-2.097-.637 1.73-.637 1.73l.552-2.516 10.527 4.964z",
    fill: "#452c25"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M357.942 194.782l3.34 1.895s.814.676-.975.278c-1.788-.398-5.602-1.714-12.807-6.351-3.258-2.097-.637 1.73-.637 1.73l.552-2.516 10.527 4.964z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M363.498 196.606s-3.989-.74-5.44-1.804c0 0 .254.459-1.696-.43 0 0 .752 1.71-4.74-2.03-5.49-3.74-3.57-1.86-3.57-1.86l1.536-.397s8.43 3.368 9.354 3.72c.925.353 4.556 2.801 4.556 2.801",
    fill: "#452c25"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M363.498 196.606s-3.989-.74-5.44-1.804c0 0 .254.459-1.696-.43 0 0 .752 1.71-4.74-2.03-5.49-3.74-3.57-1.86-3.57-1.86l1.536-.397s8.43 3.368 9.354 3.72c.925.353 4.556 2.801 4.556 2.801z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.117
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M342.645 198.1l1.336 1.906s-.444 1.786-5.083-1.69c-4.638-3.475-4.394-3.188-4.394-3.188l2.562-.357 5.626 3.193",
    fill: "#452c25"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M342.645 198.1l1.336 1.906s-.444 1.786-5.083-1.69c-4.638-3.475-4.394-3.188-4.394-3.188l2.562-.357 5.626 3.193",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M336.62 199.056s2.154 2.818 1.675 3.169c-.48.35-3.024.2-4.84-2.559-1.817-2.758-.039-.14-.039-.14l.169-4.46 3.082 3.853",
    fill: "#452c25"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M336.62 199.056s2.154 2.818 1.675 3.169c-.48.35-3.024.2-4.84-2.559-1.817-2.758-.039-.14-.039-.14l.169-4.46 3.082 3.853",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M338.832 197.758s2.074 2.677 1.848 3.084c-.226.407-3.15.148-5.48-2.493-2.33-2.64-.347-3.484-.347-3.484l3.942 2.753",
    fill: "#452c25"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M338.813 197.688s2.093 2.747 1.867 3.154c-.226.407-3.15.148-5.48-2.493-2.33-2.64-.347-3.484-.347-3.484l3.96 2.823z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M350.651 196.178s5.911 2.543 1.527 2.377c0 0-8.588-2.313-13.03-6.119l1.256-1.661 10.178 5.255",
    fill: "#452c25"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M350.651 196.178s5.911 2.543 1.527 2.377c0 0-8.588-2.313-13.03-6.119l1.256-1.661 10.178 5.255",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M353.753 195.445s3.2 1.941 3.438 2.679c.238.738-9.943-1.902-15.313-6.374l2.398-1.174 9.477 4.869z",
    fill: "#452c25"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M353.753 195.445s3.2 1.941 3.438 2.679c.238.738-9.943-1.902-15.313-6.374l2.398-1.174 9.477 4.869z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M344.46 197.203s2.314 1.9 2.052 2.12c-.263.22-4.955-.481-8.639-3.316l.441-1.694 6.192 2.8",
    fill: "#452c25"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M344.46 197.203s2.314 1.9 2.052 2.12c-.263.22-4.955-.481-8.639-3.316l.441-1.694 6.192 2.8",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M348.418 197.042s2.282 1.575 1.81 1.74c-.474.166-2.265 1.573-10.76-3.403l-1.002-.55 1.349-2.12 8.607 4.195",
    fill: "#452c25"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M348.42 196.973s2.28 1.644 1.807 1.81c-.473.165-2.264 1.572-10.76-3.404l-1.001-.55 1.349-2.12 8.605 4.264z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M339.698 192.38s2.762 2.474 2.41 2.83c-.353.355-3.64-.428-5.09-1.505-1.45-1.078-2.505-2.459-2.505-2.459l3.08-.664 2.105 1.799z",
    fill: "#452c25"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M339.698 192.38s2.762 2.474 2.41 2.83c-.353.355-3.64-.428-5.09-1.505-1.45-1.078-2.505-2.459-2.505-2.459l3.08-.664 2.105 1.799z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M336.406 188.25l5.031 3s4.106 2.898 3.673 3.158c-.435.26-3.67-.753-5.965-2.004-2.293-1.25-4.954-3.945-4.954-3.945",
    fill: "#452c25"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M336.406 188.25l5.031 3s4.106 2.898 3.673 3.158c-.435.26-3.67-.753-5.965-2.004-2.293-1.25-4.954-3.945-4.954-3.945",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M333.231 202.433s.937 2.398.377 2.606c-.56.209-1.947-.218-3.062-2.393-1.114-2.174.971-1.255.971-1.255l1.714 1.042z",
    fill: "#452c25"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M333.231 202.433s.937 2.398.377 2.606c-.56.209-1.947-.218-3.062-2.393-1.114-2.174.756-1.207.756-1.207l1.929.994z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M334.9 200.882s1.406 2.325 1.1 2.59c-.307.265-2.162 1.068-4.183-1.93-2.02-2.998 2.08-2.367 2.08-2.367l1.003 1.707z",
    fill: "#452c25"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M334.9 200.882s1.406 2.325 1.1 2.59c-.307.265-2.162 1.068-4.183-1.93-2.02-2.998 2.08-2.367 2.08-2.367l1.003 1.707z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M330.696 190.392s4.798 9.265 4.4 9.758c-.4.492-2.296-.002-3.358-2.451-1.062-2.45-1.93-5.631-1.93-5.631l.888-1.676z",
    fill: "#452c25"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M330.696 190.392s4.798 9.265 4.4 9.758c-.4.492-2.296-.002-3.358-2.451-1.062-2.45-1.93-5.63-1.93-5.63l.888-1.677z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M336.286 192.75s4.004 3.403 3.182 3.832c-.822.429-2.415-.192-4.757-2.51-2.342-2.316 1.537-1.463 1.537-1.463",
    fill: "#452c25"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M336.267 192.68s4.023 3.473 3.201 3.902c-.822.429-2.415-.192-4.757-2.51-2.342-2.316 1.556-1.393 1.556-1.393z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M334.345 192.807s2.862 5.255 2.505 5.75c-.357.494-2.504-1.307-3.563-2.646-1.058-1.339-1.859-3.285-1.859-3.285",
    fill: "#452c25"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M334.345 192.807s2.862 5.255 2.505 5.75c-.357.494-2.504-1.307-3.563-2.646-1.058-1.339-1.859-3.285-1.859-3.285",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M312.9 203.599s-.17 3.097 0 3.329c.17.23 1.74.23 1.825-2.08.085-2.313-.34-2.405-.34-2.405l-1.528 1.063",
    fill: "#452c25"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M312.9 203.599s-.17 3.097 0 3.329c.17.23 1.74.23 1.825-2.08.085-2.313-.34-2.405-.34-2.405l-1.528 1.063",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M313.84 199.866s-1.104 3.467-.043 4.161c1.062.693 1.911-3.422 1.953-4.346.043-.925-1.91.185-1.91.185",
    fill: "#452c25"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M313.84 199.866s-1.104 3.467-.043 4.161c1.062.693 1.911-3.422 1.953-4.346.043-.925-1.91.185-1.91.185z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M314.598 204.292s.212 3.237.807 3.375c.594.14 1.57-.924 1.57-1.757 0-.832-1.018-2.774-1.018-2.774l-1.402 1.018",
    fill: "#452c25"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M314.598 204.292s.212 3.237.806 3.375c.595.14 1.571-.924 1.571-1.757 0-.832-1.019-2.774-1.019-2.774l-1.4 1.018",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M314.626 200.416s-1.104 3.468-.042 4.161c1.061.694 1.91-3.421 1.953-4.346.043-.924-1.91.185-1.91.185z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M314.712 194.851s-1.614 1.665-1.57 2.59c.041.924 2.377-1.249 2.59-1.665.211-.416-1.02-.925-1.02-.925",
    fill: "#452c25"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M314.712 194.851s-1.614 1.665-1.57 2.59c.041.924 2.377-1.249 2.59-1.665.211-.416-1.02-.925-1.02-.925z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M313.603 193.919s-1.274 2.358-.935 3.097c.34.74 1.571-.554 2.166-1.387.595-.832-1.231-1.71-1.231-1.71",
    fill: "#452c25"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M313.603 193.919s-1.274 2.358-.935 3.097c.34.74 1.571-.554 2.166-1.387.595-.832-1.231-1.71-1.231-1.71z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M331.51 190.795s2.034 3.831 1.475 4.04c-.56.208-1.419-.753-2.271-1.898-.853-1.146.796-2.142.796-2.142",
    fill: "#452c25"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M331.51 190.795s2.034 3.831 1.475 4.04c-.56.208-1.419-.753-2.271-1.898-.853-1.146.796-2.142.796-2.142z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M331.557 198.63s.738 3.224.09 3.52c-1.267.583-1.974-2.29-2.05-3.369-.086-1.206 1.96-.15 1.96-.15zm-2.535 5.11s.171 2.414-.177 2.63c-.347.218-1.199.275-2.148-1.753-.95-2.029-.508-1.27-.508-1.27l2.334-1.154.507 1.317",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M331.356 203.189s.273 2.556-.24 2.627c-.512.072-1.875-.792-2.469-2.322-.684-1.764 2.38-1.244 2.38-1.244l.33.939z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M328.953 195.35s2.623 5.87 2.201 6.706c-.826 1.637-3.21-3.575-3.93-5.61-.805-2.275 1.729-1.096 1.729-1.096z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M327.736 196.33s3.577 6.462 2.068 6.612c-1.508.15-4.25-4.686-4.71-5.81-.46-1.124 2.642-.801 2.642-.801z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M327.522 197.672s1.76 6.192.627 5.644c-1.134-.547-2.5-5.211-2.685-6.218-.187-1.006 2.058.574 2.058.574zm6.183-8.804s2.713 4.143 1.833 4.266c-.88.123-4.097-2.768-4.126-3.247-.03-.479 2.293-1.02 2.293-1.02z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M332.01 189.042s3.458 4.721 2.415 4.961c-1.043.24-1.121-.498-1.121-.498s-2.76-2.488-2.946-3.117c-.185-.63 1.55-1.407 1.55-1.407m3.528.134s2.379 2.454 1.754 3.284c-.623.831-3.928-3.106-4.377-3.606-.45-.501 2.881.226 2.881.226m-6.025 3.505s3.83 7.462 3.125 8.22c-.705.759-4.962-5.594-5.11-6.515-.148-.921 2.024-1.844 2.024-1.844",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M327.466 193.2s1.532 2.334 1.445 3.592c-.086 1.257-2.315-1.8-2.507-2.376-.193-.576 1.062-1.217 1.062-1.217z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.155
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M330.617 191.99s1.191 2.409.826 3.134c-.365.725-1.988-1.463-2.553-2.32-.566-.855 1.727-.814 1.727-.814z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M325.09 194.358s1.87 2.074 1.78 3.18c-.09 1.105-2.804-1.614-3.042-2.123-.237-.509 1.263-1.057 1.263-1.057z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.16
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M337.175 188.374s2.83 2.538 2.39 2.937c-.439.398-4.267-2.344-4.843-2.876-.577-.533 2.453-.061 2.453-.061z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M334.782 188.19l2.213 1.864s2.056 1.375 1.704 1.73c-.352.356-3.573-1.118-4.144-1.79-.572-.67-.505-1.362-.505-1.362l.732-.442zm7.294.587s8.38 3.398 8.054 4.218c-.326.82-8.786-2.721-10.114-3.655-1.327-.934 1.934-.615 1.934-.615",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M342.378 189.853s6.294 3.544 5.56 3.884c-.735.34-5.24-.863-7.564-2.439-2.325-1.576-3.315-2.45-3.315-2.45l2.87-.669 2.45 1.674zm-15.493 4.307s1.192 2.41.826 3.135c-.365.725-1.55-.62-2.115-1.475-.566-.857 1.29-1.66 1.29-1.66zm.283 5.432s.983 3.511-.101 4.16c-1.085.65-1.791-3.497-1.802-4.423-.01-.926 1.903.263 1.903.263z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M322.296 193.81s3.5-1.537 4.12-1.414c0 0 .734-.185 1.129-.492s1.298-1.044 1.298-1.044-.62-4.24 3.838-3.81c4.458.43 10.327.983 11.513 1.167 1.185.184 5.53 1.414 6.546 1.905 1.016.492 7.635 3.488 8.99 3.98.802.29 2.572 1.397 3.881 2.252.903.588-.027.167-.027.167s-10.72-5.691-14.51-6.452c-.948-.19.065 1.086.065 1.086s-2.462-.971-3.478-1.402c-1.016-.43-1.863-.614-2.822-.553a5.798 5.798 0 0 1-2.257-.307c-.565-.184-3.782-.307-4.346-.369a7.321 7.321 0 0 1-1.016-.184l.226.369-1.58-.246-.452.676s-1.524.307-1.637-.185c-.112-.491-.903 2.213-1.298 3.012-.395.799-1.862.798-2.314 1.29-.451.492-.733.8-.959.922-.226.123-1.354.799-1.75.799-.395 0-2.82.184-2.82.184l-.622-.983.282-.369zm4.6 9.936s.063 3.102-.115 3.326c-.178.225-1.747.16-1.752-2.154-.005-2.313.422-2.388.422-2.388l1.49 1.125",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M327.274 201.366s-.297-1.343-.51-1.529c-.212-.185.085-.37.085-.37s-.552-1.344-.891-1.575c-.34-.232.042-.417.042-.417s-.595-.927-1.02-1.204c-.424-.278 0-.325 0-.325s-.443-1.244-1.478-1.814c0 0-.686-.721-1.385-.92-.7-.199-2.436-.383-4.534-.345-2.21.04-3.147 1.572-3.147 1.572l-.14 1.777.318-.217-.468 2.213c-.074.506.397 1.385.423 2.443.008.335.029.685.066 1.044.1.949.323 1.956.754 2.885.034.073.065.288.107.218.108-.185.35.627.568.918 0 0 .13 1.104.235.695.041-.16.396.625.614 1.117.08.18.498 1.395.482.841-.017-.605.368 1.29.368 1.562l.51-.741.254.834.424-.047-.127.788s1.189-.973 1.232-1.344c.042-.37.084-.648.084-.648l.382-.37.595-.927s1.487 1.158 1.656 1.575c.17.417.34.787.34.787l.382-.37.34.833.212-.416.206.579.018-.036.136.382c.103.096.34.145.786-.601.637-1.065.595-1.9.637-2.085.043-.185.297.325.297.325s.553-1.02.467-1.668c-.085-.648.34-.417.34-.417s.085-1.714 0-2.13c-.085-.417.297-.325.297-.325s-.127-2.038-.254-2.27c-.128-.231.297-.277.297-.277z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M324.298 196.65c.3.09.446.428.575.69-.008-.016.019-.092.003-.124-.129-.263-.278-.605-.578-.695.002 0-.02.123 0 .13m.27 1.28c.555.468.602 1.107.571 1.807 0 .02.007.145.011.065.033-.74.024-1.49-.581-2.001.014.012-.025.107 0 .129m1.15.655c.305.502.334 1.055.334 1.634 0 .074.013.074.013 0 0-.615-.016-1.219-.344-1.758.008.013-.02.095-.003.124m.404 2.42c-.034.358-.099.71-.168 1.062a.435.435 0 0 0 .006.112c.07-.36.136-.719.17-1.084.003-.016-.003-.141-.008-.09m-.373 1.856c.029.235.059.468.034.705-.002.017.004.142.009.091.032-.298.003-.59-.034-.887-.006-.05-.01.074-.009.091m-.713-2.33c0 .396.003.792.035 1.188.004.05.011-.075.01-.092-.03-.365-.032-.73-.032-1.096 0-.073-.013-.073-.013 0m-.303 2.572c.03.377.031.754.031 1.132 0 .073.013.073.013 0 0-.408-.002-.816-.036-1.223-.004-.05-.01.075-.009.091m1.7-.327c.163.173.264.377.3.614.005.025.009-.019.01-.023a.435.435 0 0 0-.002-.088 1.164 1.164 0 0 0-.308-.632c.015.016-.025.103 0 .13m-.102-2.597c.168.14.305.312.44.484-.015-.02.024-.099 0-.128a3.102 3.102 0 0 0-.44-.485c.014.011-.025.108 0 .129m-1.396 1.943a5.88 5.88 0 0 1-.098 1.052.439.439 0 0 0 .006.111c.072-.384.102-.772.105-1.163 0-.073-.012-.073-.013 0m-.743.773c.029.316.029.63 0 .947 0 .017.005.141.009.09a6.23 6.23 0 0 0 0-1.129c-.004-.05-.01.075-.009.092"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M310.74 194.326s-.85 3.19-.213 3.514c1.247.633 2.052-2.208 2.166-3.283.127-1.202-1.954-.23-1.954-.23",
    fill: "#452c25"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M310.74 194.326s-.85 3.19-.213 3.514c1.247.633 2.052-2.208 2.166-3.283.127-1.202-1.954-.23-1.954-.23z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M312.577 194.3s-1.614 1.665-1.57 2.59c.041.925 2.377-1.248 2.589-1.665.213-.416-1.02-.924-1.02-.924",
    fill: "#452c25"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M312.577 194.3s-1.614 1.665-1.57 2.59c.041.925 2.377-1.248 2.589-1.665.213-.416-1.02-.924-1.02-.924z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M285.056 194.535s-3.334 1.674-3.626 2.39c-.292.715 10.056-1.085 15.742-5.104l-2.306-1.366-9.81 4.08z",
    fill: "#452c25"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M285.056 194.535s-3.334 1.674-3.626 2.39c-.292.715 10.056-1.085 15.742-5.104l-2.306-1.366-9.81 4.08z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M288.953 195.208s-6.034 2.194-1.646 2.283c0 0 8.695-1.81 13.327-5.35l-1.17-1.732-10.435 4.655",
    fill: "#452c25"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M288.991 195.136s-6.072 2.266-1.684 2.355c0 0 8.695-1.81 13.327-5.35l-1.17-1.732-10.473 4.727z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M297.91 189.08s-6.411 3.283-5.69 3.653c.722.37 5.266-.648 7.644-2.127 2.378-1.48 3.397-2.312 3.397-2.312l-2.845-.786-2.506 1.572z",
    fill: "#452c25"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M297.91 189.08s-6.411 3.283-5.69 3.653c.722.37 5.266-.648 7.644-2.127 2.378-1.48 3.397-2.312 3.397-2.312l-2.845-.786-2.506 1.572z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M295.49 196.28s-2.292 1.918-2.026 2.137c.265.218 4.949-.52 8.598-3.383l-.462-1.69-6.158 2.847",
    fill: "#452c25"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M295.49 196.28s-2.292 1.918-2.026 2.137c.265.218 4.949-.52 8.598-3.383l-.462-1.69-6.158 2.847",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M291.502 195.983s-2.2 1.68-1.72 1.824c.481.143 2.342 1.462 10.579-3.91l.972-.598-1.453-2.052-8.39 4.598",
    fill: "#452c25"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M291.497 195.914s-2.195 1.75-1.715 1.893c.481.143 2.342 1.462 10.579-3.91l.972-.598-1.453-2.052-8.383 4.667z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M289.802 189.592c-6.927 2.424-13.874 7.25-13.874 7.25.68-.23 17.826-7.133 17.826-7.133M305 200.408s-1.486 2.266-1.189 2.543c.298.277 2.124 1.156 4.247-1.757 2.123-2.913-1.996-2.45-1.996-2.45L305 200.407z",
    fill: "#452c25"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M305.001 200.408s-1.486 2.266-1.189 2.543c.298.277 2.124 1.156 4.247-1.757 2.123-2.913-1.996-2.45-1.996-2.45L305 200.407z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M306.615 202.027s-1.019 2.358-.467 2.589c.552.231 1.953-.139 3.142-2.266 1.19-2.127-.552-1.063-.552-1.063l-2.123.74zm-3.27-3.514s-2.25 2.728-1.783 3.097c.467.37 3.015.324 4.926-2.358 1.91-2.681.042-.138.042-.138l-.552-2.45-2.675 1.71",
    fill: "#452c25"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M306.615 202.027s-1.019 2.358-.467 2.589c.552.231 1.953-.139 3.142-2.266 1.19-2.127-.552-1.063-.552-1.063l-2.123.74zm-3.27-3.514s-2.25 2.728-1.783 3.097c.467.37 3.015.324 4.926-2.358 1.91-2.681.042-.138.042-.138l-.552-2.45-2.675 1.71",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M301.18 197.125s-2.166 2.59-1.954 3.006c.213.416 3.143.277 5.563-2.266s.467-3.468.467-3.468l-4.033 2.59",
    fill: "#452c25"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M301.18 197.125s-2.166 2.59-1.954 3.006c.213.416 3.143.277 5.563-2.266s.467-3.468.467-3.468l-4.033 2.59",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M297.358 197.31l-1.401 1.85s.382 1.803 5.138-1.48 4.501-3.005 4.501-3.005l-2.548-.462-5.733 2.959",
    fill: "#452c25"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M297.337 197.241l-1.38 1.919s.382 1.803 5.138-1.48 4.501-3.005 4.501-3.005l-2.548-.462-5.711 3.028z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M282.19 194.478l-3.015 1.355s-.681.597 1.09.642c1.77.044 5.428-.445 11.791-4.053 2.877-1.632 4.7-3.187 4.7-3.187l-2.319-.861-12.247 6.104z",
    fill: "#452c25"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M282.19 194.478l-3.015 1.355s-.681.597 1.09.642c1.77.044 5.428-.445 11.791-4.053 2.877-1.632 4.7-3.187 4.7-3.187l-2.319-.861-12.247 6.104z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M277.027 196.38s4.337-.472 6.06-1.602c0 0-.352.527 1.866-.34 0 0-1.104 1.987 5.362-1.95 6.467-3.936.053-.079.053-.079l7.182-4.115-.42-.82s-13.722 5.877-14.76 6.204c-1.038.328-5.343 2.701-5.343 2.701",
    fill: "#452c25"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M290.342 192.449l7.208-4.155-.42-.82s-13.722 5.877-14.76 6.204c-1.038.328-5.343 2.701-5.343 2.701s4.337-.471 6.06-1.601c0 0-.352.527 1.866-.34 0 0-1.078 1.947 5.389-1.99z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M308.526 201.927s-.425 3.437.085 3.564c.51.128 1.953-.954 2.548-3.055.594-2.1-2.335-1.846-2.335-1.846l-.425 1.21",
    fill: "#452c25"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M308.526 201.927s-.425 3.437.085 3.564c.51.128 1.953-.954 2.548-3.055.594-2.1-2.335-1.846-2.335-1.846l-.425 1.21",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M310.776 203.506s-.254 2.404.085 2.636c.34.23 1.19.323 2.208-1.665 1.02-1.988.552-1.248.552-1.248l-2.293-1.249-.552 1.295",
    fill: "#452c25"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M310.776 203.39s-.254 2.52.085 2.752c.34.23 1.19.323 2.208-1.665 1.02-1.988.552-1.248.552-1.248l-2.293-1.249-.552 1.41z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M311.413 199.021s-1.868 4.07-.806 4.023c1.061-.046 2.505-3.098 2.717-3.792.212-.693-1.91-.23-1.91-.23",
    fill: "#452c25"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M311.413 199.021s-1.868 4.07-.806 4.023c1.06-.046 2.505-3.098 2.717-3.792.213-.693-1.91-.23-1.91-.23z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M311.251 198.985s-.703 4.484.3 4.105c1.004-.38 1.572-3.757 1.59-4.488.019-.73-1.89.383-1.89.383",
    fill: "#452c25"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M311.251 198.985s-.703 4.484.3 4.105c1.004-.38 1.572-3.757 1.59-4.488.019-.73-1.89.383-1.89.383z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M312.772 199.437s-1.104 3.468-.042 4.161c1.061.694 1.91-3.421 1.953-4.346.042-.924-1.91.185-1.91.185",
    fill: "#452c25"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M312.772 199.437s-1.104 3.468-.042 4.161c1.061.694 1.91-3.421 1.953-4.346.042-.924-1.91.185-1.91.185z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M308.42 198.296s-1.062 3.19-.425 3.514c1.246.633 2.264-2.209 2.378-3.283.127-1.202-1.953-.231-1.953-.231zm-7.92-6.58s-2.844 2.358-2.505 2.728c.34.37 3.652-.278 5.138-1.295 1.486-1.017 2.08-1.572 2.08-1.572l-2.547-1.572-2.165 1.71z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M303.006 189.311s-1.826 1.48-1.486 1.85c.34.37 3.609-.971 4.203-1.618.595-.648.552-1.341.552-1.341l-3.27 1.11z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M304.874 189.08s-2.463 2.035-1.868 2.774c.594.74 4.034-2.543 4.5-2.959.468-.416-2.887.093-2.887.093",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M303.77 188.156l-4.968 2.358s-4.204 2.728-3.78 3.005c.425.278 3.695-.601 6.03-1.757 2.336-1.156 4.926-3.098 4.926-3.098m-.824 2.175s-5.375 4.622-4.568 5.084c.806.462 4.401-1.473 6.821-3.693",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M305.836 192.361s-3.042 5.134-2.703 5.643c.34.508 2.548-1.202 3.652-2.497s1.972-3.207 1.972-3.207",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M307.584 192.814s-3.296 6.126-2.914 6.635c.383.508 2.293.092 3.44-2.312 1.146-2.405 1.048-3.956 1.048-3.956l-1.574-.367z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M309.5 193.108s-3.664 7.56-2.942 8.3c.722.74 4.778-5.734 4.964-6.648.327-1.608-2.065-1.79-2.065-1.79m-7.683-4.86s-3.312 1.571-2.632 1.895c.679.324 3.779-1.063 4.203-1.202.426-.139-1.57-.694-1.57-.694z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M302.284 188.618s-2.038 1.618-1.613 2.034c.424.417 3.524-1.248 4.118-1.757.594-.508-2.505-.277-2.505-.277z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M306.56 188.747s-2.785 3.745-1.932 3.893c.854.148 4.089-2.414 4.134-2.858.045-.444-2.202-1.035-2.202-1.035z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.141
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M307.804 189.589s-2.972 3.745-2.123 3.976c.85.231.934-.37.934-.37s2.335-1.942 2.505-2.45c.17-.509-1.231-1.202-1.231-1.202",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M308.739 190.467s-2.166 3.746-1.614 3.977c.552.231 1.443-.694 2.335-1.804.892-1.109-.721-2.173-.721-2.173z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M309.29 192.178s-1.274 2.358-.934 3.098c.34.74 1.571-.555 2.166-1.387.594-.832-1.232-1.71-1.232-1.71zm.535 6.546s-.85 3.19-.213 3.514c1.247.633 2.052-2.208 2.166-3.283.127-1.202-1.953-.23-1.953-.23z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M315.66 194.41s-.85-.278-1.487-.278c0 0-1.868-1.48-2.887-1.618-1.019-.14-.149-.162-.149-.162s-.106-2.428-.403-2.612c0 0-.17-2.497-1.741-2.682-1.571-.185-5.096.138-5.733-.093-.636-.231-2.588-1.045-6.284-.046-3.782 1.023-11.223 4.364-11.605 4.456-.382.093 8.548-1.959 11.053-3.069 0 0 2.505-.185 3.27-.416 0 0-2.845 1.387-.213.786 2.633-.601 2.038 0 2.038 0s-.254.601 1.232.278c1.486-.324 1.486 0 1.486 0s1.699.6 3.015-.186c0 0 .68 2.359 1.529 2.682 0 0 1.009 2.16 3.132 2.577 0 0 1.009.715 1.22.854l1.2.393 1.284-1.003",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M298.25 188.017s-8.492 3.051-8.195 3.884c.297.832 8.874-2.358 10.233-3.237 1.36-.878-1.91-.693-1.91-.693",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M321.76 194.597c.194.033.358.12.532.21.005.003.08.049.093.03.014-.02-.052-.078-.056-.082a1.539 1.539 0 0 0-.362-.268c-.222-.115-.438-.234-.687-.275-.05-.008.134.167.147.177.089.072.216.189.333.208m-6.612 6.412c.126.242.145.52.272.762-.008-.016.019-.093.003-.125-.126-.24-.146-.52-.272-.761.008.015-.02.093-.004.124m1.154-6.54c.284-.1.585-.103.881-.138.014-.002.005-.13 0-.13-.296.036-.597.038-.881.14-.02.006.004.127 0 .128m1.694-.138c.27-.128.555-.139.847-.139a.314.314 0 0 0 0-.129c-.292 0-.577.011-.847.139-.023.01.007.125 0 .129m-2.948 1.498c-.035.006-.037.035-.04.066a.327.327 0 0 0 .004.089c.004.024.008-.02.008-.024-.002.024.013 0 .028-.003.016-.003.003-.13 0-.129m-.176 4.565c0 .238.002.477.037.713.004.025.01-.02.01-.023a.376.376 0 0 0-.004-.088c-.03-.2-.03-.4-.03-.602 0-.073-.013-.073-.013 0"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M316.587 213.894s-.96.743-1.069 1.093a3.78 3.78 0 0 0-.138.687s.86-.103.754.37c0 0 .28.161.723-.868.443-1.03.862-1.474 1.176-1.444.315.03.715.336.917.55.202.216.48.376.83.275 0 0-.367-.56-.135-.682.232-.123.585-.099.585-.099s-.293-.698-.923-.799c-.63-.1-1.066-.276-.917-.55.15-.274.956-2.403.956-2.403l-1.068-1.568-.428 1.365s.14.806.145 1.013c.006.206-.85 1.97-.964 2.071-.115.103-2.404.988-2.677 1.075-.272.087-.842.765-.842.765l-.065.509s.384-.314.507-.127c0 0 .265-.336.504-.21.238.126.2.174.2.174s.424-.28.499-.416c.075-.138.095-.12.095-.12s.214-.057.526-.11",
    fill: "#bd8759"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M316.587 213.894s-.96.743-1.069 1.093a3.78 3.78 0 0 0-.138.687s.86-.103.754.37c0 0 .28.161.723-.868.443-1.03.862-1.474 1.176-1.444.315.03.715.336.917.55.202.216.48.376.83.275 0 0-.367-.56-.135-.682.232-.123.585-.099.585-.099s-.293-.698-.923-.799c-.63-.1-1.066-.276-.917-.55.15-.274.956-2.403.956-2.403l-1.068-1.568-.428 1.365s.14.806.145 1.013c.006.206-.85 1.97-.964 2.071-.115.103-2.404.988-2.677 1.075-.272.087-.842.765-.842.765l-.065.509s.384-.314.507-.127c0 0 .265-.336.504-.21.238.126.2.174.2.174s.424-.28.499-.416c.075-.138.095-.12.095-.12s.214-.057.526-.11",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M323.117 209.17s.04 1.806.04 2.142c0 .336-.04.84-.232 1.134-.193.294-.386.462-.694.462-.31 0-1.119-.042-1.273.252-.155.294-.27.462-.27.462s.501-.294.578 0c.077.294-.192.546-.192.546s.462.084.886-.168.656-.294.849-.294c.193 0 .347.21.347.21s.116.63.077 1.008c-.039.378-.116 1.134.309 1.134 0 0 .154-.378.308-.42.154-.042.579.377.502.503 0 0 .077-.797-.078-1.26a6.735 6.735 0 0 1-.231-.965s1.311.462 1.427.63c.116.168.424.462.54.42.116-.042 0-.42.231-.504.232-.084.347.126.347.126s-.385-.882-.964-1.176c-.578-.294-.964-.294-1.195-.546-.232-.252-.27-.546-.309-.84-.038-.294.01-2.833.01-2.833l-.974-.19",
    fill: "#bd8759"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M323.137 209.038s.02 1.938.02 2.274c0 .336-.04.84-.232 1.134-.193.294-.386.462-.694.462-.31 0-1.119-.042-1.273.252-.154.294-.27.462-.27.462s.501-.294.578 0c.077.294-.192.546-.192.546s.462.084.886-.168.656-.294.849-.294c.193 0 .347.21.347.21s.116.63.077 1.008c-.039.377-.116 1.134.309 1.134 0 0 .154-.378.308-.42.154-.042.579.377.502.503 0 0 .077-.797-.078-1.26-.154-.461-.231-.965-.231-.965s1.311.462 1.427.63c.116.168.424.462.54.42.116-.042 0-.42.231-.504.232-.084.347.126.347.126s-.385-.882-.964-1.176c-.578-.294-.964-.294-1.195-.546-.232-.252-.27-.546-.309-.84-.038-.294.01-2.833.01-2.833l-.993-.155z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M315.069 197.32s-.128-1.287.233-1.426c0 0 .128-1.179 1.699-1.017 0 0 .53-.879 1.38-.416 0 0 .806-.393 1.274-.162.467.231 1.04.624 1.082.717 0 0 .68-.14.998.115.319.255.17 1.087.17 1.087s.764.585.828 1.102c.063.516.063.724-.107.863 0 0 .34.277.277.67-.064.393-.383.963-.446.963-.064 0 .042 1.025-.297 1.372-.34.347-.659.417-.807.463-.149.046-.53.6-.892.67-.36.07-.849-.555-.891-.74-.043-.185-.531-.393-.531-.393s-1.104 1.18-1.847.994c-.743-.184-1.104-.809-1.168-.924-.064-.116-.276-.971-.276-.971s-.828-.486-.764-.948c.063-.462.403-1.017.403-1.017l-.318-1.002z",
    fill: "#dcddde"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M317.828 211.94c-.1.019-.17.004-.236-.042m.604-.89a.8.8 0 0 1-.317-.113m-.063.592c.071.04.154.056.237.043m-1.021 1.417c.045.032.1.052.158.056m6.429-.935c.157.027.3.111.463.126m-.193-.588c-.125.03-.231.006-.308-.084m.385-.462a.863.863 0 0 1-.424-.042m-.116 1.89c.147.02.283.092.424.126m-.385.462a.217.217 0 0 1 .193.042m-.077 1.553a.402.402 0 0 1 .27.042m-5.092-2.104a.34.34 0 0 0-.268.211m1.054-.137c-.169.098-.32.235-.341.431m-4.536.435c.131.119.325.189.439.299m9.9-.94a.352.352 0 0 0-.192.252m.732-.085a.185.185 0 0 0-.115.169",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M313.45 215.074l.551-.143.053.022s-.36.697-.263.866c.099.169-.492-.306-.34-.745",
    fill: "#d9c0b9"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M313.45 215.074l.551-.143.053.022s-.36.697-.263.866c.099.169-.492-.306-.34-.745z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M315.545 215.486s-.609 1.017.181 1.525c0 0-.049-.948.57-1.152l-.75-.373z",
    fill: "#d9c0b9"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M315.545 215.486s-.609 1.017.181 1.525c0 0-.049-.948.57-1.152l-.75-.373z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M319.587 214.537l-.184-.55.214-.289.432-.005.183.087s.348.793.044 1.209c0 0-.129-.448-.276-.51 0 0-.322-.05-.413.058",
    fill: "#d9c0b9"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M319.587 214.537l-.184-.55.214-.289.432-.005.183.087s.348.793.044 1.209c0 0-.129-.448-.276-.51 0 0-.322-.05-.413.058z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M320.938 213.374h.362l.137.338-.051.312-.312.144s-.515-.131-.389.481c0 0-.241-1.125.253-1.275",
    fill: "#d9c0b9"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M320.938 213.374h.362l.137.338-.051.312-.312.144s-.515-.131-.389.481c0 0-.241-1.125.253-1.275z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M323.492 215.893l.374-.412.401.212s-.166 1.088-.23 1.169c-.062.081-.074.094-.074.125s-.063-.206-.184-.344c-.12-.137-.246-.737-.287-.75",
    fill: "#d9c0b9"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M323.492 215.893l.374-.412.401.212s-.166 1.088-.23 1.169c-.062.081-.074.094-.074.125s-.063-.206-.184-.344c-.12-.137-.246-.737-.287-.75z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M325.926 214.8s.603.75.528.993c0 0 .62-.625-.178-1.512l-.35.518z",
    fill: "#d9c0b9"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M325.926 214.8s.603.75.528.993c0 0 .62-.625-.178-1.512l-.35.518z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M323.282 195.889c.12.034.194.122.235.24a.188.188 0 0 0 .007-.045c0-.025.004-.056-.004-.08-.04-.12-.116-.21-.238-.245.002.001-.02.124 0 .13m.135 2.076c.188.198.327.427.405.69-.006-.02.014-.088.003-.124a1.697 1.697 0 0 0-.408-.695c.015.016-.025.104 0 .13m-.44-1.524c.183.16.339.345.507.52-.015-.016.025-.104 0-.13-.168-.174-.324-.36-.508-.519.014.013-.025.108 0 .13m.505 3.452c.054.31-.018.576-.134.851-.014.034.011.107.004.125.148-.352.202-.71.137-1.087a.466.466 0 0 0-.007.111m.475 1.073c.024.16.028.318 0 .478a.372.372 0 0 0-.002.088c0 .004.004.048.009.023a2.159 2.159 0 0 0 0-.7c-.004-.025-.008.02-.01.023a.435.435 0 0 0 .003.088m1.83 3.78c.122.433.131.875.132 1.322 0 .074.013.074.013 0 0-.488-.008-.974-.14-1.447.005.022-.014.089-.004.125m-.305.88c-.1.305-.2.61-.339.9-.015.032.012.107.003.124.14-.29.24-.595.34-.9.011-.035-.01-.104-.004-.125m-10.23-2.92c.283.37.436.813.675 1.21-.008-.013.021-.095.003-.124-.24-.399-.394-.843-.679-1.214.016.02-.023.099 0 .129m1.796.044c-.259.034-.322-.338-.542-.415.004 0-.021.121 0 .129.219.077.283.45.542.415.014-.002.004-.13 0-.129m-1.019 1.719c.186.326.309.686.509 1.004-.008-.013.021-.096.004-.125-.2-.318-.323-.677-.509-1.004.008.015-.02.095-.003.125m1.188.418c.209.251.398.515.506.828-.006-.02.016-.089.004-.124-.11-.315-.3-.58-.51-.833.016.019-.024.1 0 .129m-.103 1.243c.105.218.2.44.305.658-.008-.016.019-.092.003-.124-.106-.218-.2-.44-.305-.658.008.017-.02.092-.003.124m1.118.243c.061.228.095.462.097.7 0 .072.013.073.013 0a3.305 3.305 0 0 0-.106-.825c.006.022-.014.089-.003.125m-.476 1.032c.073.329.169.65.34.941-.008-.014.02-.094.004-.124-.168-.287-.265-.604-.337-.928a.366.366 0 0 0-.007.111m.274-4.387c.268.102.536.203.813.277 0 0 .019-.125 0-.13a8.08 8.08 0 0 1-.813-.277c.005.002-.021.121 0 .13m.203 1.142c.32.178.656.32.983.484-.008-.004.023-.117 0-.128-.327-.165-.663-.307-.983-.485.01.005-.024.115 0 .129m.305 1.28c.165.201.346.386.542.555-.014-.013.026-.108 0-.13a4.47 4.47 0 0 1-.542-.553c.016.019-.023.1 0 .129m.337 1.59c.138.22.202.463.236.72.003.025.008-.02.01-.023a.373.373 0 0 0-.004-.089 1.791 1.791 0 0 0-.238-.733c.008.013-.022.095-.004.125m.947-3.953c.03.153.066.305.103.456-.006-.022.013-.087.004-.124a10.06 10.06 0 0 1-.1-.444c-.005-.024-.008.02-.008.024a.326.326 0 0 0 .002.088m2.373-.949a3.575 3.575 0 0 1-.238.485c-.017.03.012.11.003.124.091-.156.17-.316.237-.484.015-.035-.01-.106-.003-.125m.978-.042c0 .273-.004.543-.064.81a.393.393 0 0 0 .006.112c.068-.302.07-.612.071-.921 0-.074-.013-.074-.013 0m.205 1.5c.025.233 0 .463-.032.694a.562.562 0 0 0 .006.111 3.72 3.72 0 0 0 .035-.897c-.005-.05-.011.074-.01.091m.748 1.422c-.045.321-.239.578-.471.787-.026.023.014.116 0 .13.238-.215.432-.477.477-.806a.562.562 0 0 0-.006-.111m-2.404-1.392c-.068.135-.155.256-.237.381-.012.017-.005.06-.004.08 0 .004.004.051.007.045.082-.125.17-.247.237-.381.01-.02.005-.058.004-.08 0-.004-.004-.05-.007-.045m.273 1.902a1.89 1.89 0 0 1-.34.381c-.025.02.014.119 0 .13.135-.107.238-.244.34-.382.01-.014.006-.048.006-.064 0-.007-.01-.062-.006-.065m-.848 1.004c-.33-.327-.486-.748-.337-1.223.012-.036-.01-.104-.004-.124-.166.529-.056 1.084.341 1.476-.015-.015.025-.104 0-.129m-1.121-1.056c.025.195.024.385-.032.574-.011.036.009.103.003.124.078-.262.07-.54.035-.81-.004-.025-.008.02-.008.023a.435.435 0 0 0 .002.089m2.576 1.266c-.07.235-.197.44-.305.658-.016.032.011.108.004.125.108-.218.235-.424.305-.658.01-.036-.01-.104-.003-.125m1.66.693a9.23 9.23 0 0 1-.474.727c-.02.027.011.113.004.124.166-.237.33-.474.474-.727.017-.03-.012-.11-.003-.124m.811.871a17 17 0 0 0-.138 1.339c-.002.021.005.144.011.065.033-.432.067-.864.133-1.292a.564.564 0 0 0-.006-.112m1.048-1.554c.003.151.031.3.034.45.002.091.013.007.012-.034-.002-.15-.032-.3-.034-.45-.002-.09-.013-.007-.012.035m-11.144-4.885c-.063.445-.008.87.137 1.295-.007-.02.015-.09.003-.125-.12-.347-.188-.677-.134-1.059a.562.562 0 0 0-.006-.11"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M318.817 196.346c.716-.657 1.66-1.348 2.676-1.107 0 0 .017-.124 0-.129-1.015-.242-1.96.45-2.676 1.106-.025.024.015.116 0 .13m3.44.782c-.718-.489-1.972-.667-2.675-.065-.026.021.014.117 0 .129.703-.602 1.957-.423 2.675.065-.012-.008.025-.113 0-.13m-2.74 1.103c.293.953.674 1.923.507 2.94a.564.564 0 0 0 .006.112c.18-1.103-.19-2.137-.51-3.176.006.02-.015.089-.004.124m-1.148.58c.176.963.064 1.936-.002 2.904-.002.022.006.145.011.066.07-1.027.184-2.06-.002-3.082a.432.432 0 0 0-.006.112m1.532-.708c.936.222 1.851.846 2.355 1.69-.008-.014.021-.095.004-.125-.505-.846-1.42-1.47-2.358-1.694 0 0-.019.126 0 .13m-.835 1.302c.003.592.05 1.184-.123 1.76-.01.035.01.103.003.124.185-.616.136-1.25.133-1.884 0-.074-.013-.074-.013 0m1.47-.131c.589.486 1.055 1.22 1.143 1.998.006.05.01-.074.008-.091-.09-.794-.549-1.538-1.151-2.036.014.011-.025.108 0 .129m-4.33 1.624c.196-.278.437-.595.764-.713.02-.008-.004-.128 0-.13-.33.12-.57.439-.766.719-.02.027.011.113.003.124m1.4-5.063c-.123-.529-.52-.841-.946-1.126.01.007-.023.1 0 .115.422.283.82.595.943 1.122-.004-.02.012-.078.003-.11m-.829-.01c-.49-.232-.997-.26-1.529-.26a.312.312 0 0 0 0 .13c.532 0 1.039.027 1.529.26-.008-.005.023-.119 0-.13m1.532-.081c.064-.509-.01-.99-.45-1.303.012.008-.021.098 0 .113.369.264.503.63.444 1.092a.435.435 0 0 0 .006.098m1.844.6c.46-.244.962-.198 1.465-.195.009 0 .01-.128 0-.128-.503-.004-1.005-.05-1.465.195-.024.012.009.124 0 .129m.828 1.236c.71.075 1.253.44 1.72.976-.032-.036.048-.203 0-.258-.468-.536-1.01-.901-1.72-.977-.01 0-.027.256 0 .259m-3.124 1.958c-.168.68-.04 1.54-.825 1.818-.042.014.008.255 0 .258.795-.282.662-1.14.831-1.827.019-.073-.017-.204-.006-.249",
    fill: "#fff"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M319.515 199.009c.272.714.653 1.443.506 2.236a.873.873 0 0 0 .013.223c.18-.977-.17-1.811-.513-2.708.014.037-.033.18-.006.249m1.022-.126c.693.088 1.303.705 1.395 1.414.007.05.017-.04.017-.047a.95.95 0 0 0-.005-.176c-.093-.722-.697-1.359-1.407-1.45-.009 0-.028.255 0 .259m-.006 1.023c.109.594.277 1.188.067 1.782-.025.07.02.21.007.249.262-.74.075-1.507-.061-2.254a.92.92 0 0 0-.013.223m-.376-2.585c.763-.129 1.57-.244 2.23.26-.027-.02.05-.22 0-.258-.66-.504-1.467-.389-2.23-.26-.031.005-.005.26 0 .258m-1.394-1.514c.091-.63.646-1.081 1.204-1.284.042-.015-.01-.255 0-.258-.576.21-1.123.673-1.217 1.319a.95.95 0 0 0-.005.177c0 .008.01.096.017.046m-.696.379c-.019-.7-.325-1.262-.626-1.873.014.028-.034.163-.006.22.27.547.594 1.082.61 1.713.005.16.024.013.022-.06m-.641.374c-.136-.622-.547-1.035-1.09-1.32.018.01-.047.234 0 .26.525.274.944.678 1.077 1.283a.746.746 0 0 0 .013-.223m-1.026-.25c-.356-.247-.73-.48-1.162-.547-.006 0-.024.198 0 .201.432.067.806.3 1.162.548-.019-.013.04-.174 0-.201m2.22 2.925c.062.66.144 1.328-.185 1.931-.034.062.023.22.007.25.394-.723.27-1.578.197-2.364-.01-.101-.021.15-.018.183",
    fill: "#fff"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M319.387 198.878c.221.622.482 1.283.438 1.958-.003.042.012.29.023.13.053-.821-.182-1.572-.454-2.337.014.04-.031.18-.007.25m.513-.907c.632.194 1.26.401 1.72.91-.032-.034.048-.204 0-.257-.46-.51-1.088-.717-1.72-.911.005 0-.04.246 0 .258m-1.711-1.404c.067-.55.126-1.099.131-1.653.002-.147-.024-.147-.025 0-.005.493-.064.982-.124 1.47-.004.034.006.284.018.183m-1.155-.351c-.467-.212-.882-.515-1.274-.846.028.024-.051.216 0 .259.392.33.807.633 1.274.846-.014-.007.045-.238 0-.259m-.192 3.319c-.3.19-.506.454-.64.785-.018.045-.01.112-.009.16 0 .01.011.1.016.09.132-.328.337-.59.633-.777.05-.031-.022-.244 0-.258m.816.485c-.011.453-.26.828-.56 1.141-.05.052.03.226 0 .259.36-.378.57-.799.584-1.331.002-.083-.019-.25-.024-.07m2.138-3.562c.376-.594 1.285-.643 1.892-.81.038-.01-.002-.257 0-.257-.615.167-1.518.217-1.898.818-.037.058.023.224.007.249m-4.178-.01a2.072 2.072 0 0 1-.411-.193c.011.007-.03.143 0 .16.133.074.266.149.411.193-.003-.001.025-.153 0-.16m.083 3.038c-.131.054-.267.109-.357.225-.022.027-.013.097-.013.129 0 .03 0 .06.004.091 0-.004.006.041.01.038.09-.116.225-.171.356-.224.02-.009.013-.114.013-.13a.745.745 0 0 0-.013-.129m.55.14c-.27.12-.466.354-.635.593-.03.043.018.178.006.195.167-.236.363-.466.63-.585.035-.016-.012-.198 0-.203m1.039.258c-.235.573-.877 1.207-.411 1.848-.017-.022.045-.196.006-.25-.322-.443.245-.943.411-1.35.028-.067-.021-.212-.007-.248m.733-.01c.018.584-.085 1.16-.187 1.733a.858.858 0 0 0 .013.224c.12-.672.219-1.342.198-2.026-.006-.18-.027-.014-.024.069m1.88-.691c.426.558.803 1.158.985 1.847-.012-.044.026-.176.007-.249-.184-.693-.564-1.295-.992-1.856.031.041-.046.197 0 .258m.22-.45c.7.535 1.48 1.036 1.973 1.792-.016-.025.044-.192.006-.25-.496-.759-1.276-1.263-1.98-1.8.026.02-.05.22 0 .259",
    fill: "#fff"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M320.535 197.813c.261-.025.504-.015.752.076.222.082.406.265.608.387.204.123.41.234.575.41.218.228.22.618.284.912.004.02.02-.147.01-.19-.051-.241-.079-.486-.161-.72-.08-.228-.278-.368-.47-.49-.23-.148-.457-.297-.685-.448-.271-.178-.603-.187-.913-.157-.022.002-.01.22 0 .22",
    fill: "#fff"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M322.25 199.248c.077.226.168.447.245.673-.009-.026.02-.116.004-.162-.077-.226-.168-.447-.245-.673.009.026-.02.116-.004.162m-1.962-3.571c.493-.136.998-.226 1.483-.393.041-.014-.007-.256 0-.258-.485.167-.99.257-1.483.393-.038.01.003.257 0 .258m-2.056.248c.069-.262.18-.475.33-.698.183-.275.21-.618.435-.869.049-.054-.03-.223 0-.258-.186.206-.25.471-.357.723-.128.302-.329.525-.415.853-.02.073.018.205.007.249m-1.685 4.617c-.088.425-.071.869.086 1.274-.015-.037.033-.18.007-.249a1.365 1.365 0 0 1-.08-.802.67.67 0 0 0 .004-.176c0-.01-.007-.096-.017-.047m1.023.804c-.177.24-.18.607-.086.884a.341.341 0 0 0 .015-.085c.002-.046.006-.105-.008-.15-.052-.154-.014-.28.08-.406.019-.027.011-.09.011-.122 0-.013-.017-.115-.012-.121m.76-.408c-.008.244-.139.477-.24.692-.023.047.016.156.004.18.127-.267.244-.522.254-.823.002-.06-.014-.18-.018-.05m.023-1.434v.309c0 .009-.002.129.013.129s.013-.12.013-.13v-.308c0-.009.002-.129-.013-.129s-.013.12-.013.13m-.347.18c.02.036.036.073.05.113.008.054.012.057.012.009a.726.726 0 0 0-.014.24c0 .008.008.096.017.047.039-.212.048-.464-.058-.657-.006-.013-.015.08-.016.09 0 .041-.012.12.01.159m-.495-.165c-.051.16-.086.324-.113.49a.802.802 0 0 0-.004.177c0 .008.009.096.017.046a3.27 3.27 0 0 1 .107-.464c.015-.048.01-.109.009-.159 0-.011-.013-.1-.015-.09m-.382.023c-.23.283-.538.47-.85.646-.05.027.018.247 0 .258.312-.175.62-.363.85-.645.021-.027.013-.098.013-.13 0-.013-.017-.124-.013-.129m-.659.112a1.58 1.58 0 0 1-.467.253c-.041.015.008.256 0 .258.169-.059.326-.14.467-.252.022-.018.013-.106.013-.13 0-.007-.012-.13-.013-.129m-.934-.23c-.136.061-.275.114-.411.175-.037.015.01.202 0 .207.136-.06.275-.113.411-.174.037-.016-.01-.202 0-.207m2.844-.112c.003.169.03.333.061.498.01.049.017-.038.018-.047a.802.802 0 0 0-.004-.176c-.023-.113-.048-.228-.05-.344 0-.01-.012-.1-.015-.09-.017.047-.01.11-.01.159m.44-.203c.002.198.021.388.091.574.004.01.016-.08.016-.09.002-.048.008-.114-.01-.16a.959.959 0 0 1-.072-.324c0-.009.002-.129-.013-.129s-.013.12-.013.13m.34-.045c.058.083.125.197.128.303 0 .01.011.1.015.09.017-.047.01-.11.01-.159a.832.832 0 0 0-.147-.483c-.009-.012-.015.082-.016.09 0 .037-.013.127.01.16m.415-.164c.145.031.276.09.384.196-.002-.002.013-.119.013-.129 0-.027.009-.107-.013-.129a.763.763 0 0 0-.384-.196c-.002 0-.035.25 0 .258m.22-.337c.17.142.357.248.576.28.007.002.03-.253 0-.258a1.17 1.17 0 0 1-.576-.28l-.013.129c0 .024-.01.11.013.13m.466-1.123c.149.002.294.026.44.056.002 0 .033-.252 0-.258a2.316 2.316 0 0 0-.44-.057c-.018 0-.02.259 0 .259m-.216-.538c.09-.146.224-.254.353-.36.022-.018.013-.105.013-.129l-.013-.13c-.133.11-.268.22-.36.37-.022.036-.01.12-.009.159 0 .009.008.103.016.09m-.409-.518a.972.972 0 0 1 .186-.459c.021-.028.013-.097.013-.13 0-.013-.018-.122-.013-.128a1.044 1.044 0 0 0-.204.671c0 .007.01.096.018.046m-.333-.24c.17-.237.282-.51.44-.756.022-.035.01-.12.008-.16 0-.008-.008-.102-.016-.09-.156.247-.27.52-.439.758-.023.032-.01.122-.009.159 0 .009.007.102.016.09",
    fill: "#fff"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M318.545 195.302c.006.29.027.579.088.862.011.049.017-.037.018-.046a.652.652 0 0 0-.004-.177 3.657 3.657 0 0 1-.077-.708c-.004-.181-.026-.014-.024.069m-1.227.202c.044.105.103.203.155.305.033.063.062.128.088.195l.025.076c-.016-.052.01-.038-.021.017-.035.06.023.22.007.249.074-.129.063-.337.03-.477-.054-.223-.19-.406-.278-.614.016.035-.035.182-.006.249m-.244.504a4.51 4.51 0 0 0-.549-.449 1.946 1.946 0 0 0-.013.13c0 .021-.009.112.013.128.191.14.381.28.55.45-.003-.003.012-.12.012-.13 0-.028.01-.107-.013-.13m.803.27c.114-.567.092-1.134-.14-1.668.015.035-.036.183-.007.25.17.388.22.768.134 1.194-.01.057-.008.12-.005.177 0 .008.008.095.018.046m1.202-.74c.019 0 .019-.258 0-.258s-.019.259 0 .259",
    fill: "#fff"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M317.72 196.302c.03-.32.105-.634.137-.954.01-.09.008-.184 0-.274-.006-.065-.02-.065-.027 0-.032.32-.107.634-.137.954-.008.09-.01.184 0 .274.006.065.02.066.027 0m3.474 1.992c.278.091.552.28.681.554.008.018.023-.12.024-.135.002-.066.016-.175-.013-.238-.133-.28-.408-.475-.692-.568.009.003-.06.367 0 .387m-.939 1.93a1 1 0 0 1 .023.487 1.167 1.167 0 0 0-.007.265c0 .012.013.143.027.07.07-.387.081-.818-.032-1.196a.694.694 0 0 0-.024.135c-.002.075-.009.165.013.238m-.783-.523c0 .32.02.639-.045.955-.017.084-.012.18-.006.265 0 .013.01.143.026.07.087-.426.066-.859.064-1.29 0-.014.003-.194-.02-.194-.02 0-.018.18-.018.194m-.398.346c-.11.425-.22.85-.307 1.282-.017.085-.012.18-.007.265 0 .013.011.143.026.07.084-.418.19-.83.297-1.243.03-.11-.027-.308-.01-.374m.536.271c.004.365.046.734.006 1.098a1.32 1.32 0 0 0 0 .273c.006.066.02.065.026 0 .052-.458.01-.912.006-1.37 0-.014.003-.194-.018-.194-.023 0-.02.18-.02.193m-2.571.195c.008-.115.006-.138-.003-.069a.567.567 0 0 1-.075.192c-.032.058-.015.176-.013.238 0 .014.013.155.023.136.135-.243.125-.563.087-.831-.01-.075-.025.058-.026.07-.005.087-.006.177.007.264m1.13-.766c.076.145.07.272.07.43 0 .014-.004.194.018.194s.019-.18.019-.193c.002-.268.03-.56-.096-.804-.01-.019-.023.121-.024.135-.002.064-.017.179.014.238m.307-.133a.367.367 0 0 1 .136.182c.008.023.012.094.01.013a.75.75 0 0 0 .009.115c0-.002.006.043.015.02.025-.07.015-.165.013-.238-.004-.189-.03-.358-.183-.48-.006-.004-.014.063-.013.057a1.258 1.258 0 0 0-.006.138c0 .045 0 .091.006.136.002.012.002.047.013.057m.38-.344c.06.124.13.242.192.365.01.02.014-.016.015-.02.006-.037.007-.077.008-.115 0-.05 0-.1-.002-.15-.002-.024 0-.065-.012-.088-.06-.124-.13-.242-.192-.365-.01-.02-.013.016-.014.02a.895.895 0 0 0-.01.115c0 .05 0 .1.003.15.002.024 0 .065.01.088m.852-.308c.15.214.305.424.472.624-.006-.007.019-.175.019-.194 0-.046.013-.155-.02-.193a9.327 9.327 0 0 1-.461-.61c-.013-.02-.023.121-.023.135-.002.054-.021.19.013.238m.44-.73c.113.2.245.39.389.568-.006-.007.019-.174.019-.193 0-.047.013-.154-.02-.194a4.119 4.119 0 0 1-.379-.554c-.01-.019-.023.122-.023.135-.002.061-.019.182.013.238m-4.278-1.951a1.715 1.715 0 0 0-.412-.253 1.108 1.108 0 0 0-.02.194c0 .024-.01.181.02.194.15.063.285.15.412.252 0 0 .018-.18.018-.194 0-.036.015-.167-.018-.193m1.34-.462a.486.486 0 0 1 .04.115.748.748 0 0 0 .012.118c0-.001.005.044.014.02.025-.07.015-.165.013-.238a1 1 0 0 0-.068-.388c-.009-.021-.015.019-.015.02a.746.746 0 0 0-.008.116c-.003.068-.015.173.013.238m1.058-1.005c.006.254-.021.522-.152.744-.032.055-.015.178-.013.238 0 .013.012.154.023.135.206-.349.189-.827.178-1.22a.56.56 0 0 0-.023-.135c-.025.07-.015.165-.013.238m.238 1.432c.225-.15.379-.382.499-.624.03-.06.015-.173.013-.238 0-.013-.014-.153-.023-.135-.118.237-.269.462-.49.61-.032.022-.018.162-.018.194 0 .011.015.196.019.193m.658-.027c.078-.08.143-.172.22-.253.012-.012.012-.042.014-.056.004-.046.006-.092.006-.138 0-.045 0-.091-.006-.136 0 .006-.008-.063-.014-.057-.077.08-.142.172-.22.252-.012.013-.012.042-.013.057a1.258 1.258 0 0 0-.006.137c0 .045 0 .091.006.137 0-.007.008.062.013.057m.99.173a7.599 7.599 0 0 1-.742-.028c-.017-.002-.04.384 0 .388.246.024.494.027.741.028.028 0 .029-.388 0-.388m-.22.893c.33.197.649.411.99.589-.027-.014.07-.35 0-.388-.341-.177-.66-.391-.99-.589.032.02-.073.343 0 .388",
    fill: "#fff"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M319.958 197.958c.294.187.614.33.88.561 0 0 .018-.18.018-.194 0-.037.014-.164-.019-.193-.265-.231-.585-.375-.879-.561a2 2 0 0 0-.019.193c0 .03-.013.173.02.194m-1.89-1.41c.042-.141.041-.293.041-.44 0-.012.003-.193-.019-.193s-.02.18-.02.194c0 .053 0 .008.003 0a.325.325 0 0 1-.015.065c-.022.074-.015.163-.013.239.002.038.002.077.01.115 0-.005.006.045.014.02m-2.314-1.03c.258.315.585.543.903.79.235.184.409.495.663.64-.03-.017.073-.346 0-.387-.229-.13-.382-.407-.585-.577-.335-.281-.7-.51-.98-.854.047.058-.071.3 0 .387m.549 1.044a7.671 7.671 0 0 1-.44-.505c-.003-.005-.014.063-.013.056a1.56 1.56 0 0 0-.006.137c0 .047-.013.154.02.194.14.173.283.345.438.505-.003-.003.02-.178.02-.194 0-.042.014-.16-.02-.193m-.307 2.56c-.103.187-.19.385-.324.554-.032.04-.019.146-.019.193 0 .02.025.186.019.194.137-.174.228-.375.334-.568.032-.057.015-.176.014-.238 0-.013-.013-.154-.024-.136m.29.388c-.006.216-.08.43-.106.644-.011.09-.008.185 0 .274.007.067.019.064.027 0 .034-.275.109-.536.115-.815.002-.073.011-.168-.014-.238a.616.616 0 0 0-.023.135m1.012 1.781c.183-.612.163-1.26.15-1.893-.004-.272-.038-.02-.036.103.009.48.014.954-.124 1.417-.032.108.029.31.01.373m.594-1.486c.07.212.084.406.051.627a1.29 1.29 0 0 0-.007.266c0 .011.015.144.026.069.066-.439.08-.91-.06-1.336a.627.627 0 0 0-.023.135c-.003.074-.01.167.013.239m.582-.218c.213.262.278.61.258.943-.004.063.018.434.032.195.031-.504.045-1.116-.29-1.526.006.007-.02.175-.02.194 0 .047-.013.154.02.194",
    fill: "#fff"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M318.635 199.326a12.6 12.6 0 0 1 .294 1.69c.015.15.031-.224.027-.275-.06-.604-.169-1.2-.31-1.789.015.068-.037.263-.01.374m.548-.14c.244.336.457.69.577 1.093a.684.684 0 0 0 .023-.135c.003-.075.009-.165-.013-.238-.12-.403-.333-.758-.577-1.094.024.032-.068.293-.01.373m1.136-.934c-.113-.196-.353-.22-.554-.204-.039.003-.019.39 0 .388.19-.016.436.002.544.19.01.018.023-.123.023-.136.002-.061.019-.182-.013-.238",
    fill: "#fff"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M319.738 198.098a7.456 7.456 0 0 1 1.071-.056c.03 0 .03-.387 0-.387-.358 0-.715.004-1.07.055-.045.007-.012.39 0 .388m.659-2.94c-.285.34-.436.802-.532 1.232-.018.084-.011.181-.007.265 0 .015.01.143.026.07.091-.409.243-.857.513-1.18.032-.039.018-.147.018-.194 0-.018-.024-.187-.019-.193m-1.547.333c.053.327.187.629.279.945a.68.68 0 0 0 .023-.135c.002-.076.008-.165-.013-.239-.088-.303-.22-.592-.27-.906-.012-.074-.025.058-.026.07-.005.087-.007.178.007.265m-.292.564a1.549 1.549 0 0 1-.297-.526c-.008-.025-.016.024-.015.02a.749.749 0 0 0-.008.115c-.002.076-.009.165.013.239.061.204.176.376.307.54.004.005.014-.064.013-.057.005-.046.006-.091.006-.137 0-.047.014-.153-.019-.194m-.521.253c-.431-.14-.844-.312-1.209-.59.04.03-.076.33 0 .388.365.278.778.45 1.209.59-.01-.004.06-.369 0-.388",
    fill: "#fff"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M318.51 196.2s-1.708.292-2.159.395c-.45.103-1.47.207-1.826.207-.356 0-.902-.285-1.282-.362-.38-.078-1.613-.207-2.064.258-.45.465-.735.62-.877.775-.143.155-.714.662-.737.887-.022.224.144.56.428.56.285 0 .883.605.882.732-.002.211.782.439 1.52.434 1.33-.007 1.985-.678 3.98-.443 1.086.128 3.084-.723 3.44-1.24.356-.517.57-1.059.214-1.653-.356-.594-1.423-.533-1.519-.55",
    fill: "#dba05f"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M318.51 196.2s-1.708.292-2.159.395c-.45.103-1.47.207-1.826.207-.356 0-.902-.285-1.282-.362-.38-.078-1.613-.207-2.064.258-.45.465-.735.62-.877.775-.143.155-.714.662-.737.887-.022.224.144.56.428.56.285 0 .883.605.882.732-.002.211.782.439 1.52.434 1.33-.007 1.985-.678 3.98-.443 1.086.128 3.084-.723 3.44-1.24.356-.517.57-1.059.214-1.653-.356-.594-1.423-.533-1.519-.55z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M311.358 198.115s-.004.038-.012-.02l-.01-.046-.012-.032-.002-.035c-.008-.012.036.01.174-.127 0 .003.041-.065.116-.177a.838.838 0 0 1 .43-.28c.261-.061.502-.018.535-.016.012-.014-.59-.02-.63.05.003-.047.58-.067.612-.027.008-.014-.545-.018-.586.058 0-.035.5-.059.555-.013 0 0-.093-.01-.118-.008l.043.008h-.07l-.04-.005s.11.014.117.024c0 .002.05-.014-.147-.003 0 0-.12-.022-.316.04-.257.038-.25.386-.639.61"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M311.315 197.97c.022.002.19-.066.35-.363-.045-.082.604-.335.671-.253.003-.003.177 0 .279.016",
    fill: "none"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M311.957 197.408c-.066-.009-.395.269-.365.284-.071.17-.256.282-.278.278m.671-.523c0-.021.446-.064.534-.03M311.902 197.567c-.012-.047.464-.112.509-.08",
    fill: "none"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M312.4 197.87s.02.012-.007-.015l-.02-.024-.013-.02-.017-.014s-.015.006-.134.112c0-.001-.052.039-.114.097-.002-.005-.116.096-.244.166-.136.02-.334.109-.334.144-.012-.053.392-.159.386-.165.029.019-.358.09-.365.168-.014-.047.355-.14.37-.14.019.02-.325.078-.335.152 0 .002.047-.047.066-.048l-.024.018c.012-.012.028-.014.043-.02l.025-.011s-.069.03-.066.044c.003.008-.04-.004.089-.038.002.012.325-.066.694-.407"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M312.34 197.787c-.003-.005-.143.14-.29.244.002.024-.301.201-.38.18-.006-.009-.13.052-.182.116",
    fill: "none"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M311.89 198.147c.023-.023.214-.153.214-.154.067-.072.235-.206.236-.206m-.443.393c.016.016-.284.057-.332.13M311.983 198.172c.02.038-.32.129-.334.14",
    fill: "none"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M312.872 196.487s-.024-.542-.546-.749c-.522-.206-1.115-.232-1.328-.206-.214.025-.25.12-.516.164a2.536 2.536 0 0 0-.551.171s0-.025-.143.233-.38.387-.26.62c.118.232.04.273.185.317.146.044-.072-.08-.072-.08s-.915.296-.692.856c.222.56.445.35.512.34.066-.012.517-.245.517-.245l.74-.692s.873-.341.968-.367c.095-.026.508.01.508.01l.678-.371z",
    fill: "#c6262c"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M312.872 196.487s-.024-.542-.546-.749c-.522-.206-1.115-.232-1.328-.206-.214.025-.25.12-.516.164a2.536 2.536 0 0 0-.551.171s0-.025-.143.233-.38.387-.26.62c.118.232.04.273.185.317.146.044-.072-.08-.072-.08s-.915.296-.692.856c.222.56.445.35.512.34.066-.012.517-.245.517-.245l.74-.692s.873-.341.968-.367c.095-.026.508.01.508.01l.678-.371z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M312.209 197.76c0 .135-.137.31-.307.39-.17.08-.307.035-.307-.1s.137-.31.307-.39c.17-.08.307-.035.307.1"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M308.585 200.237s-.716-1.231 1.27-1.835c0 0 .6.327.739.553 0 0-.346.578-1.478.73 0 0-.508.15-.53.552",
    fill: "#d9c0b9"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M308.585 200.237s-.716-1.231 1.27-1.835c0 0 .6.327.739.553 0 0-.346.578-1.478.73 0 0-.508.15-.53.552z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M308.793 200.036s.8.169 1.339-.226c.442-.324.6-.176.715-.15 0 0 .024-.403-.254-.705 0 0-.56.463-.976.59-.415.125-.696.083-.824.491",
    fill: "#d9c0b9"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M308.793 200.036s.8.169 1.339-.226c.442-.324.6-.176.715-.15 0 0 .024-.403-.254-.705 0 0-.56.463-.976.59-.415.125-.696.083-.824.491z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.133
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M311.015 199.632c.149 0 .3.002.446-.033.017-.004 0-.129 0-.129-.146.035-.297.033-.446.033a.312.312 0 0 0 0 .129m-.28-2.069c-.123 0-.086.148-.16.21-.01.009-.006.052-.006.064l.006.065c.074-.062.04-.21.16-.21.01 0 .009-.129 0-.129m.412.279c.062-.116.184-.164.295-.22.023-.011-.008-.124 0-.128-.112.056-.235.105-.298.223-.01.02-.005.059-.005.08 0 .005.005.05.008.045m.534.712a.26.26 0 0 0 .24-.116c.01-.014.006-.048.006-.065 0-.007-.01-.061-.006-.064a.26.26 0 0 1-.24.116c-.006 0-.012.128 0 .13m.422-.152a.753.753 0 0 0 .378-.328c.01-.019.005-.06.005-.08 0-.004-.004-.051-.008-.045a.743.743 0 0 1-.375.324c-.022.009.006.127 0 .13m-.663-.699c-.093.158-.27.238-.376.385-.02.027.01.114.003.124.106-.147.282-.226.376-.384.01-.018.005-.06.005-.08 0-.004-.004-.05-.008-.045m.286 2.061c.339.018.666-.027.992-.116.019-.005-.002-.13 0-.13a3.112 3.112 0 0 1-.992.117c-.008 0-.011.128 0 .129m1.562-.058c.442-.321.815-.595.96-1.156.009-.036-.01-.102-.003-.124-.144.556-.52.833-.956 1.15-.025.019.012.12 0 .13m.262-.769c.315-.187.54-.482.663-.83.013-.034-.01-.104-.003-.124a1.548 1.548 0 0 1-.66.825c-.024.014.01.123 0 .13m-.148-1.958c.241-.03.504.171.673.326-.015-.013.025-.106 0-.13-.169-.154-.432-.354-.673-.325-.013.002-.005.13 0 .129m6.262.976c.274-.443.125-.997-.16-1.394.009.01-.022.097-.002.124.24.336.399.759.16 1.145-.019.03.01.112.002.125m-4.779-.626c.277.2 1.039.711.83 1.13-.015.033.012.11.004.125.285-.574-.451-1.107-.834-1.385.012.01-.026.11 0 .13m2.148 2.062a1.45 1.45 0 0 0 .071-.367.462.462 0 0 0 0-.09c-.003-.023-.007-.023-.009 0a1.302 1.302 0 0 1-.065.332c-.008.023-.005.056-.004.08 0 .004.006.05.008.045",
    fill: "#7a2e26"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M317.859 199.19c.165-.028.33-.112.496-.225m-8.458-.24c-.325.198-.836.2-.938.649-.002.006 0 .03.002.028.101-.447.614-.449.936-.646.006-.004-.003-.03 0-.032",
    fill: "#5e3f17"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M309.677 197.29c.14.002.304.075.283.247a.4.4 0 0 0 0 .091c.002.022.006.021.009 0a.668.668 0 0 0-.023-.324c-.044-.11-.163-.142-.269-.144-.009 0-.01.13 0 .13m.67.257a.654.654 0 0 0-.063-.58c.008.012-.022.097-.003.125.071.102.108.206.064.33-.013.036.01.106.003.125m.543-.573c-.035-.226-.114-.477-.322-.595.01.005-.024.116 0 .13.203.114.282.356.316.576.004.025.008-.019.008-.023a.435.435 0 0 0-.002-.088m.478-.117c.029-.21.01-.434-.163-.575.014.01-.026.108 0 .129.096.078.175.204.156.335a.431.431 0 0 0-.002.088c0 .004.005.048.008.023m-.799-.707c.467-.236 1.418-.341 1.784.13-.016-.02.023-.099 0-.129-.366-.472-1.317-.367-1.784-.13-.024.012.008.125 0 .13",
    fill: "#842116"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M309.456 198.1c.106-.157.072-.367-.031-.515.008.011-.023.097-.004.125.027.038.05.078.069.122.022.054-.008.1-.037.144-.012.016-.005.06-.004.08 0 .004.004.05.008.044m4.767 1.37a.627.627 0 0 0 .29-.419.326.326 0 0 0 .001-.088c0-.004-.004-.048-.008-.023a.61.61 0 0 1-.283.4c-.025.016.011.122 0 .13m.715-.06a.38.38 0 0 0 .092-.251c0-.024.004-.057-.004-.08a.18.18 0 0 0-.008.045c-.002.055-.045.12-.08.158-.01.012-.006.05-.006.064 0 .006.008.063.006.065m4.319-2.37a.92.92 0 0 1 .084.671.394.394 0 0 0 .006.112c.066-.296.064-.64-.088-.908.008.015-.02.095-.003.125m-.429.438c.085.21.079.43.055.652-.002.017.003.142.009.091.032-.295.053-.586-.06-.867.008.018-.017.09-.003.124m-.406.376c0 .158.002.315-.052.464-.013.035.01.105.003.125.068-.187.062-.393.062-.589 0-.073-.013-.073-.013 0",
    fill: "#7a2e26"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M324.253 210.468l.09.255s.02.05.064.09l-.135-.38-.02.035z",
    fill: "#452c25"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M314.452 194.949c-1.714.099-3.405-1.04-3.405-1.04-2.123-.416-2.247-2.337-2.247-2.337-.85-.323-1.58-2.505-1.58-2.505-1.316.786-2.964.01-2.964.01s0-.325-1.486 0c-1.486.323-1.231-.278-1.231-.278s.594-.601-2.039 0c-2.632.6.213-.786.213-.786-.764.23-3.27.416-3.27.416-.92.041-1.852.495-2.868.784-.633.18-1.715.39-2.262.624-1.46.624-4.385 1.965-6.8 2.913-3.177 1.247-5.694 2.195-5.528 2.155.198-.048 3.449-2.107 7.52-3.953 3.78-1.714 8.12-3.3 10.308-3.922 2.84-.941 5.165-.492 6.483-.013.637.231 4.15-.108 5.721.077 1.572.184 1.735 2.768 1.735 2.768.298.185.404 2.612.404 2.612s-.87.024.148.162c1.02.139 2.888 1.619 2.888 1.619.637 0 .709-.023.709-.023s.37-.467.88-.662.977-.39 1.55-.433c.573-.044 1.382-.05 1.955.016.573.065 1.25.07 2.057.222.807.152.892.195 1.146.282.255.087.483.03.483.03 1.05-.438 2.995-1.213 3.443-1.124 0 0 .734-.185 1.13-.492a105.06 105.06 0 0 0 1.297-1.045s-.623-4.388 3.835-3.958c4.459.43 10.37 1.003 11.555 1.187 1.185.184 5.43 1.397 6.446 1.889 1.016.491 3.935 1.799 5.234 2.374.527.233 2.536 1.123 4.022 1.71 2.231.88 3.898 2.348 3.898 2.348-1.398-.592-2.528-1.268-3.635-1.749-.896-.389-1.833-.57-2.561-.893-1.546-.687-2.736-1.312-3.673-1.748-3.453-1.608-3.421-1.673-4.82-1.782-.964-.076.693 1.176.693 1.176s-3.16-1.23-4.176-1.66c-1.016-.43-1.863-.614-2.822-.553a5.797 5.797 0 0 1-2.257-.307c-.565-.184-3.782-.307-4.346-.369a7.32 7.32 0 0 1-1.016-.184l.226.369-1.58-.246-.452.676s-1.523.307-1.637-.185c-.112-.49-.903 2.213-1.298 3.012-.395.798-2.198.534-2.649 1.025-.452.492-1.415.82-1.64.944-.226.123-.91.065-1.306.065-.587 0-.087.009-1.051.192 0 0-.833-.008-1.151-.138-.319-.13-1.02-.332-1.372-.433-.482-.137-3.163-.198-3.545-.177-.382.022-1.028.22-1.453.393-.424.174-1.168.63-1.168.738",
    fill: "#dcddde"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M314.452 194.949c-1.714.099-3.405-1.04-3.405-1.04-2.123-.416-2.247-2.337-2.247-2.337-.85-.323-1.58-2.505-1.58-2.505-1.316.786-2.964.01-2.964.01s0-.325-1.486 0c-1.486.323-1.231-.278-1.231-.278s.594-.601-2.039 0c-2.632.6.213-.786.213-.786-.764.23-3.27.416-3.27.416-.92.041-1.852.495-2.868.784-.633.18-1.715.39-2.262.624-1.46.624-4.385 1.965-6.8 2.913-3.177 1.247-5.694 2.195-5.528 2.155.198-.048 3.449-2.107 7.52-3.953 3.78-1.714 8.12-3.3 10.308-3.922 2.84-.941 5.165-.492 6.483-.013.637.231 4.15-.108 5.721.077 1.572.184 1.735 2.768 1.735 2.768.298.185.404 2.612.404 2.612s-.87.023.148.162c1.02.139 2.888 1.619 2.888 1.619.637 0 .709-.023.709-.023s.37-.467.88-.662.977-.39 1.55-.433c.573-.044 1.382-.05 1.955.016.573.065 1.25.07 2.057.222.807.152.892.195 1.146.282.255.087.483.03.483.03 1.05-.438 2.995-1.213 3.443-1.124 0 0 .734-.184 1.13-.492.394-.307 1.297-1.044 1.297-1.044s-.623-4.389 3.835-3.959c4.459.43 10.37 1.003 11.555 1.187 1.185.184 5.43 1.397 6.446 1.889 1.016.491 3.935 1.8 5.234 2.374.527.233 2.536 1.123 4.022 1.71 2.231.88 3.898 2.348 3.898 2.348-1.398-.592-2.528-1.268-3.635-1.749-.896-.388-1.833-.57-2.561-.893-1.546-.687-2.736-1.312-3.673-1.748-3.453-1.608-3.421-1.673-4.82-1.782-.964-.076.693 1.176.693 1.176s-3.16-1.23-4.176-1.66c-1.016-.43-1.863-.614-2.822-.553a5.797 5.797 0 0 1-2.257-.307c-.565-.184-3.782-.307-4.346-.369a7.32 7.32 0 0 1-1.016-.184l.226.369-1.58-.246-.452.676s-1.523.307-1.637-.184c-.112-.492-.903 2.212-1.298 3.01-.395.8-2.198.535-2.649 1.026-.452.492-1.415.821-1.64.944-.226.123-.91.065-1.306.065-.587 0-.087.009-1.051.192 0 0-.833-.008-1.151-.138-.319-.13-1.02-.332-1.372-.432-.482-.138-3.163-.2-3.545-.178-.382.022-1.028.22-1.453.393-.424.174-1.168.63-1.168.738",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.065
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M314.628 194.436s-.18.138-.225.483c-.045.345-.023.207-.023.207",
    fill: "#452c25"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M323.291 193.93c.227.17.462.342.663.544.007.007.072.067.05.019a.543.543 0 0 0-.107-.141 6.537 6.537 0 0 0-.733-.606c-.042-.032.004.044.01.053a.553.553 0 0 0 .117.131",
    fill: "#574f4c"
  })));
};
export default __webpack_public_path__ + "assets/4ac8e72d8753e2c161aa47ebca743ebc.svg";
export { SvgBo as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/bo.svg